/*! For license information please see elements-chart.js.LICENSE.txt */
(function webpackUniversalModuleDefinition(root, factory) {
    if (typeof exports === "object" && typeof module === "object") module.exports = factory(require("d3")); else if (typeof define === "function" && define.amd) define([ "d3" ], factory); else {
        var a = typeof exports === "object" ? factory(require("d3")) : factory(root["d3"]);
        for (var i in a) (typeof exports === "object" ? exports : root)[i] = a[i];
    }
})(window, (function(__WEBPACK_EXTERNAL_MODULE_d3__) {
    return function(modules) {
        function webpackJsonpCallback(data) {
            var chunkIds = data[0];
            var moreModules = data[1];
            var executeModules = data[2];
            var moduleId, chunkId, i = 0, resolves = [];
            for (;i < chunkIds.length; i++) {
                chunkId = chunkIds[i];
                if (Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
                    resolves.push(installedChunks[chunkId][0]);
                }
                installedChunks[chunkId] = 0;
            }
            for (moduleId in moreModules) {
                if (Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
                    modules[moduleId] = moreModules[moduleId];
                }
            }
            if (parentJsonpFunction) parentJsonpFunction(data);
            while (resolves.length) {
                resolves.shift()();
            }
            deferredModules.push.apply(deferredModules, executeModules || []);
            return checkDeferredModules();
        }
        function checkDeferredModules() {
            var result;
            for (var i = 0; i < deferredModules.length; i++) {
                var deferredModule = deferredModules[i];
                var fulfilled = true;
                for (var j = 1; j < deferredModule.length; j++) {
                    var depId = deferredModule[j];
                    if (installedChunks[depId] !== 0) fulfilled = false;
                }
                if (fulfilled) {
                    deferredModules.splice(i--, 1);
                    result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
                }
            }
            return result;
        }
        var installedModules = {};
        var installedChunks = {
            "elements-chart": 0
        };
        var deferredModules = [];
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) {
                return installedModules[moduleId].exports;
            }
            var module = installedModules[moduleId] = {
                i: moduleId,
                l: false,
                exports: {}
            };
            modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
            module.l = true;
            return module.exports;
        }
        __webpack_require__.m = modules;
        __webpack_require__.c = installedModules;
        __webpack_require__.d = function(exports, name, getter) {
            if (!__webpack_require__.o(exports, name)) {
                Object.defineProperty(exports, name, {
                    enumerable: true,
                    get: getter
                });
            }
        };
        __webpack_require__.r = function(exports) {
            if (typeof Symbol !== "undefined" && Symbol.toStringTag) {
                Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
            }
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
        };
        __webpack_require__.t = function(value, mode) {
            if (mode & 1) value = __webpack_require__(value);
            if (mode & 8) return value;
            if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            var ns = Object.create(null);
            __webpack_require__.r(ns);
            Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            if (mode & 2 && typeof value != "string") for (var key in value) __webpack_require__.d(ns, key, function(key) {
                return value[key];
            }.bind(null, key));
            return ns;
        };
        __webpack_require__.n = function(module) {
            var getter = module && module.__esModule ? function getDefault() {
                return module["default"];
            } : function getModuleExports() {
                return module;
            };
            __webpack_require__.d(getter, "a", getter);
            return getter;
        };
        __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        __webpack_require__.p = "";
        var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
        var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
        jsonpArray.push = webpackJsonpCallback;
        jsonpArray = jsonpArray.slice();
        for (var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
        var parentJsonpFunction = oldJsonpFunction;
        deferredModules.push([ "./src/index-chart.js", "elements-core" ]);
        return checkDeferredModules();
    }({
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/area-chart/mds-area-chart.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box;font-family:Open Sans}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .area-chart{display:flex;flex-direction:column;padding-top:1rem;padding-bottom:1rem;padding-left:var(--MdsAreaChart__chartLeftPadding,8px)}:host .area-chart--with-line-label{padding-right:var(--MdsAreaChart_line__lineLabelTrailingPadding,8px)}:host .area-chart__chart-body{display:flex;flex-direction:column;height:100%;position:relative}:host .area-chart__swatch{align-self:center}:host .area-chart__empty-chart{height:100%;width:100%;display:flex;justify-content:center;align-items:center;border:var(--MdsAreaChart__graphAreaTopBorderColor,#e2e4e5) var(--MdsAreaChart__graphAreaTopBorderWidth,1px) var(--MdsAreaChart__graphAreaTopBorderStyle,solid)}:host .area-chart__svg-container svg{overflow:visible;height:100%;width:100%}:host .area-chart .x-axis text,:host .area-chart .y-axis text{font-size:var(--MdsAreaChart_axis__tickLabelTextSize,.875rem);line-height:var(--MdsAreaChart_axis__tickLabelTextLineHeight,1.25rem)}:host .area-chart .reference-line{stroke-dashoffset:var(--MdsAreaChart__referenceLineDashLength,4px),var(--MdsAreaChart__referenceLineDashGap,1px)}.area-chart__chart-container{min-height:var(--MdsAreaChart__minHeight,200px);min-width:var(--MdsAreaChart__minWidth,240px)}.area-chart__chart-body{border-top:var(--MdsAreaChart__graphAreaTopBorderColor,#e2e4e5) var(--MdsAreaChart__graphAreaTopBorderWidth,1px) var(--MdsAreaChart__graphAreaTopBorderStyle,solid)}.area-chart__empty-chart{color:var(--AbstractMdsXYChart__noDataPointTextColor,#101820);font-weight:var(--AbstractMdsXYChart__noDataPointTextWeight,400);font-size:var(--AbstractMdsXYChart__noDataPointTextSize,.875rem);line-height:var(--AbstractMdsXYChart__noDataPointTextLineHeight,1.25rem)}.area-chart .baseline{stroke:var(--MdsBarChart__baselineColor,#c1c3c3)}.area-chart .reference-line{stroke:var(--MdsAreaChart__referenceLineColor,#565a5d)}.area-chart .line--primary{stroke:var(--MdsAreaChart_line-_isPrimary-true__lineColor,#005eb8)}.area-chart .line-label{fill:var(--MdsAreaChart_line__lineLabelBackgroundColor,#005eb8)}.area-chart .line-label--text{fill:var(--MdsAreaChart_line__lineLabelTextColor,#fff)}.area-chart .detail-marker--primary{fill:var(--MdsAreaChart_line__dataPointDetailMarkerBorderColor,#005eb8)}.area-chart .detail-line{stroke:var(--MdsAreaChart_line__dataPointDetailLineColor,#565a5d)}.area-chart .text-detail-container rect{fill:var(--MdsAreaChart_line__dataPointDetailBackgroundColor,#565a5d)}.area-chart .text-detail-container text{fill:var(--MdsAreaChart_line__dataPointDetailTextColor,#fff)}.area-chart .x-axis text,.area-chart .y-axis text{color:var(--MdsAreaChart_axis__tickLabelTextColor,#565a5d)}.area-chart .y-axis .tick--negative{color:var(--AbstractMdsXYChart_axis__negativeTickLabelTextColor,#b80009)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/bar-chart-segmented/mds-bar-chart-segmented.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .segmented-chart{display:flex;flex-direction:row;width:100%;min-width:var(--MdsBarChartSegmented__chartMinWidth,280px)}:host .segmented-chart:focus{outline:none}:host .segmented-chart__segment{border-color:var(--MdsBarChartSegmented__segmentBorderColor,#fff);margin:auto 0;border-style:solid;overflow:hidden;transition:transform var(--MdsBarChartSegmented__growingAnimationDuration,.35s) var(--MdsBarChartSegmented__growingAnimationEase,cubic-bezier(0,.4,.2,1));transform:scaleY(calc(1/var(--MdsBarChartSegmented__segmentHighlightedScale, default-brand-get(mds-bar-chart-segmented-segment-highlighted-scale))));background-clip:padding-box;min-width:var(--MdsBarChartSegmented__segmentMinWidth,4px)}:host .segmented-chart__segment--small{height:calc(var(--MdsBarChartSegmented__segmentHeightSmallChart, 24px)*var(--MdsBarChartSegmented__segmentHighlightedScale, 1.25));border-left-width:var(--MdsBarChartSEgmented__segmentBorderThicknessSmallChart,1px);border-bottom-width:var(--MdsBarChartSegmented__segmentBorderThicknessSmallChart,1px);border-right-width:0;border-top-width:var(--MdsBarChartSegmented__segmentBorderThicknessSmallChart,1px)}:host .segmented-chart__segment--small:last-of-type{border-right-width:var(--MdsBarChartSegmented__segmentBorderThicknessSmallChart,1px)}:host .segmented-chart__segment--medium{height:calc(var(--MdsBarChartSegmented__segmentHeightMediumChart, 32px)*var(--MdsBarChartSegmented__segmentHighlightedScale, 1.25));border-left-width:var(--MdsBarChartSEgmented__segmentBorderThicknessSmallChart,1px);border-bottom-width:var(--MdsBarChartSegmented__segmentBorderThicknessSmallChart,1px);border-right-width:0;border-top-width:var(--MdsBarChartSegmented__segmentBorderThicknessMediumChart,2px)}:host .segmented-chart__segment--medium:last-of-type{border-right-width:var(--MdsBarChartSegmented__segmentBorderThicknessMediumChart,2px)}:host .segmented-chart__segment--large{height:calc(var(--MdsBarChartSegmented__segmentHeightLargeChart, 32px)*var(--MdsBarChartSegmented__segmentHighlightedScale, 1.25));border-left-width:var(--MdsBarChartSEgmented__segmentBorderThicknessSmallChart,1px);border-bottom-width:var(--MdsBarChartSegmented__segmentBorderThicknessSmallChart,1px);border-right-width:0;border-top-width:var(--MdsBarChartSegmented__segmentBorderThicknessChart,2px)}:host .segmented-chart__segment--large:last-of-type{border-right-width:var(--MdsBarChartSegmented__segmentBorderThicknessLargeChart,2px)}:host .segmented-chart__segment:hover{transform:scaleY(calc(var(--MdsBarChartSegmented__segmentHighlightedScale, 1.25)*0.8))}:host .segmented-chart__segment-non-interact{border-color:var(--MdsBarChartSegmented__segmentBorderColor,#fff);margin:auto 0;border-style:solid;overflow:hidden;transition:transform var(--MdsBarChartSegmented__growingAnimationDuration,.35s) var(--MdsBarChartSegmented__growingAnimationEase,cubic-bezier(0,.4,.2,1));transform:scaleY(calc(1/var(--MdsBarChartSegmented__segmentHighlightedScale, default-brand-get(mds-bar-chart-segmented-segment-highlighted-scale))));background-clip:padding-box;min-width:var(--MdsBarChartSegmented__segmentMinWidth,4px)}:host .segmented-chart__segment-non-interact--small{height:calc(var(--MdsBarChartSegmented__segmentHeightSmallChart, 24px)*var(--MdsBarChartSegmented__segmentHighlightedScale, 1.25));border-left-width:var(--MdsBarChartSEgmented__segmentBorderThicknessSmallChart,1px);border-bottom-width:var(--MdsBarChartSegmented__segmentBorderThicknessSmallChart,1px);border-right-width:0;border-top-width:var(--MdsBarChartSegmented__segmentBorderThicknessSmallChart,1px)}:host .segmented-chart__segment-non-interact--small:last-of-type{border-right-width:var(--MdsBarChartSegmented__segmentBorderThicknessSmallChart,1px)}:host .segmented-chart__segment-non-interact--medium{height:calc(var(--MdsBarChartSegmented__segmentHeightMediumChart, 32px)*var(--MdsBarChartSegmented__segmentHighlightedScale, 1.25));border-left-width:var(--MdsBarChartSEgmented__segmentBorderThicknessSmallChart,1px);border-bottom-width:var(--MdsBarChartSegmented__segmentBorderThicknessSmallChart,1px);border-right-width:0;border-top-width:var(--MdsBarChartSegmented__segmentBorderThicknessMediumChart,2px)}:host .segmented-chart__segment-non-interact--medium:last-of-type{border-right-width:var(--MdsBarChartSegmented__segmentBorderThicknessMediumChart,2px)}:host .segmented-chart__segment-non-interact--large{height:calc(var(--MdsBarChartSegmented__segmentHeightLargeChart, 32px)*var(--MdsBarChartSegmented__segmentHighlightedScale, 1.25));border-left-width:var(--MdsBarChartSEgmented__segmentBorderThicknessSmallChart,1px);border-bottom-width:var(--MdsBarChartSegmented__segmentBorderThicknessSmallChart,1px);border-right-width:0;border-top-width:var(--MdsBarChartSegmented__segmentBorderThicknessChart,2px)}:host .segmented-chart__segment-non-interact--large:last-of-type{border-right-width:var(--MdsBarChartSegmented__segmentBorderThicknessLargeChart,2px)}:host .segmented-chart__nodata{color:var(--MdsBarChartSegmented__noDataPointTextColor,#101820);background-color:var(--MdsBarChartSegmented__noDataPointTextBackgroundColor,);width:100%;text-align:center;font-size:var(--MdsBarChartSegmented__noDataPointTextSize,.75rem);font-weight:var(--MdsBarChartSegmented__noDataPointTextWeight,400);line-height:var(--MdsBarChartSegmented__noDataPointTextLineHeight,1rem)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/bar-chart-selectable/mds-bar-chart-selectable.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .bar-chart-selectable{overflow:hidden}:host .bar-chart-selectable__with-bgc{background-color:var(--MdsBarChartSelectable__backgroundColor,#fff)}:host .bar-chart-selectable__chart-body{display:flex;flex-direction:column;position:relative}:host .bar-chart-selectable__data-container{display:flex;flex-direction:column;align-items:center}:host .bar-chart-selectable__chart-container{min-height:var(--MdsBarChartSelectable__minHeight,200px);width:100%;min-width:var(--MdsBarChartSelectable__minWidth,240px)}:host .bar-chart-selectable__svg-container svg{overflow:visible}:host .bar-chart-selectable__svg-container svg .baseline{stroke-width:var(--MdsBarChartSelectable__baselineThickness,1px)}:host .bar-chart-selectable__svg-container svg .reference-line{stroke-width:var(--MdsBarChartSelectable__referenceLineThickness,1px);stroke-dasharray:var(--MdsBarChartSelectable__referenceLineDashLength,4px),var(--MdsBarChartSelectable__referenceLineDashGap,1px)}:host .bar-chart-selectable__svg-container svg .multi-series-bar--selected{stroke-width:var(--MdsBarChartSelectable_series__stackedBarInterStackPadding,1px)}:host .bar-chart-selectable__svg-container svg .x-axis-tick{font-size:var(--MdsBarChartSelectable_axisLabel__xAxisTextSize,.875rem)}:host .bar-chart-selectable__svg-container svg .y-axis{font-size:var(--MdsBarChartSelectable__tickLabelTextSize,.875rem);font-weight:var(--MdsBarChartSelectable__tickLabelTextWeight,400);line-height:var(--MdsBarChartSelectable__tickLabelTextLineHeight,1.25rem);text-anchor:end}:host .bar-chart-selectable__svg-container svg .bar__label{font-size:var(--MdsBarChart_bar__barLabelTextSize,.875rem);font-weight:var(--MdsBarChart_bar__barLabelTextWeight,600)}:host .bar-chart-selectable__empty-chart{display:flex;justify-content:center;align-items:center;height:var(--MdsBarChartSelectable__graphHeight,200px);border-style:var(--MdsBarChartSelectable__graphAreaTopBorderStyle,solid);border-width:var(--MdsBarChartSelectable__graphAreaTopBorderWidth,1px);font-weight:var(--MdsBarChartSelectable__noDataPointTextWeight,400);font-size:var(--MdsBarChartSelectable__noDataPointTextSize,.875rem);line-height:var(--MdsBarChartSelectable__noDataPointTextLineHeight,1.25rem);padding:var(--MdsBarChartSElectable__noDataPointTextPadding,16px)}:host .bar-chart-selectable__legend-container{width:100%;text-align:center;border-bottom:var(--MdsBarChartSelectable_legend__bottomBorderColor,#e2e4e5);border-bottom-style:var(--MdsBarChartSelectable_legend__bottomBorderStyle,solid);border-bottom-width:var(--MdsBarChartSelectable_legend__bottomBorderThickness,1px);margin-top:var(--MdsBarChartSelectable_legend__headerTopPadding,8px)}:host .bar-chart-selectable__legend-heading{padding-top:var(--MdsBarChartSelectable_legend__headerTopPadding,8px);padding-bottom:var(--MdsBarChartSelectable_legend__headerBottomPadding,8px);margin-bottom:var(--MdsBarChartSelectable_legend__rowBottomPadding,16px);font-size:var(--MdsBarChartSelectable_legend__headerTextSize,.875rem);font-weight:var(--MdsBarChartSelectable_legend__headerTextWeight,600);line-height:var(--MdsBarChartSelectable_legend__headerLineHeight,1.25rem)}:host .bar-chart-selectable__legend-item-row{padding-bottom:var(--MdsBarChartSelectable_legend__rowBottomPadding,16px);display:flex;justify-content:space-around}:host .bar-chart-selectable__legend-item{align-items:center;display:flex;flex-direction:column;font-size:var(--MdsBarChartSelectable_legend__itemTextSize,.875rem);font-weight:var(--MdsBarChartSelectable_legend__itemTextWeight,600);line-height:var(--MdsBarChartSelectable_legend__itemTextLineHeight,1.25rem);min-width:var(--MdsBarChartSelectable_legend__itemMinimumWidth,48px);padding-right:var(--MdsBarChartSelectable_legend__itemHorizontalPadding,8px);padding-left:var(--MdsBarChartSelectable_legend__itemHorizontalPadding,8px)}:host .bar-chart-selectable__legend-item__swatch--reference-line{width:var(--MdsBarChartSelectable_legend__referenceLineWidth,48px);height:var(--MdsBarChartSelectable__referenceLineThickness,1px);margin-top:calc(var(--MdsBarChartSelectable_legend__swatchHeight, 16px)/2);margin-bottom:calc(var(--MdsBarChartSelectable_legend__swatchHeight, 16px)/2 - var(--MdsBarChartSelectable__referenceLineThickness, 1px))}:host .bar-chart-selectable__legend-item-swatch{height:var(--MdsBarChartSelectable_legend__swatchHeight,16px);width:var(--MdsBarChartSelectable_legend__swatchWidth,16px);display:block}:host .bar-chart-selectable__legend-item-label{padding-top:var(--MdsBarChartSelectable_legend__textTopPadding,4px)}:host .bar-chart-selectable__data-marker-container{overflow:visible}:host .bar-chart-selectable__data-marker-container,:host .bar-chart-selectable__data-marker svg{height:var(--MdsBarChartSelectable__dataMarkerHeight,);width:var(--MdsBarChartSelectable__dataMarkerWidth,)}:host .bar-chart-selectable__data-marker svg{margin-bottom:var(--MdsBarChartSelectable__dataMarkerBottomMargin,)}:host .bar-chart-selectable .selected-bar-indicator{height:var(--MdsBarChartSelectable__indicatorHeight,4px);fill:var(--MdsBarChartSelectable__indicatorBorderColor,#005eb8)}.bar-chart-selectable__empty-chart{color:var(--MdsBarChartSelectable__noDataPointTextColor,#101820);background-color:var(--MdsBarChartSelectable__noDataPointTextBackgroundColor,transparent);border-color:var(--MdsBarChartSelectable__graphAreaTopBorderColor,#e2e4e5)}.bar-chart-selectable__legend-container{border-bottom-color:var(--MdsBarChartSelectable_legend__bottomBorderColor,#e2e4e5)}.bar-chart-selectable__legend-heading{background-color:var(--MdsBarChartSelectable_legend__headerBackgroundColor,#f5f7f8);color:var(--MdsBarChartSelectable_legend__headerColor,#101820)}.bar-chart-selectable__legend-item{color:var(--MdsBarChartSelectable_legend__itemTextColor,#101820)}.bar-chart-selectable__legend-item-swatch{background-color:var(--MdsBarChartSelectable__selectedBarColor,#004692)}.bar-chart-selectable__legend-item__swatch--reference-line{background-image:linear-gradient(90deg,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 0,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 4px,transparent 0,transparent 5px,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 0,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 9px,transparent 0,transparent 10px,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 0,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 14px,transparent 0,transparent 15px,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 0,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 19px,transparent 0,transparent 20px,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 0,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 24px,transparent 0,transparent 25px,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 0,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 29px,transparent 0,transparent 30px,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 0,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 34px,transparent 0,transparent 35px,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 0,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 39px,transparent 0,transparent 40px,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 0,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 44px,transparent 0,transparent 45px,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 0,var(--MdsBarChartSelectable__referenceLineColor,#8c8e90) 49px)}.bar-chart-selectable__svg-container svg .baseline{stroke:var(--MdsBarChartSelectable__baselineColor,#8c8e90)}.bar-chart-selectable__svg-container svg .reference-line{stroke:var(--MdsBarChartSelectable__referenceLineColor,#8c8e90)}.bar-chart-selectable__svg-container svg .series-bar{fill:var(--MdsBarChartSelectable__barColor,#0074c7);stroke:var(--MdsBarChartSelectable__barColor,#0074c7)}.bar-chart-selectable__svg-container svg .series-bar--selected{fill:var(--MdsBarChartSelectable__selectedBarColor,#004692);stroke:var(--MdsBarChartSelectable__selectedBarColor,#004692)}.bar-chart-selectable__svg-container svg .multi-series-bar--selected{stroke:var(--MdsBarChartSelectable_series__stackedBarInterStackColor,#fff)}.bar-chart-selectable__svg-container svg .x-axis-tick{color:var(--MdsBarChartSelectable_axisLabel__xAxisTextColor,#565a5d)}.bar-chart-selectable__svg-container svg .y-axis{color:var(--MdsBarChartSelectable__tickLabelTextLineHeight,1.25rem)}.bar-chart-selectable__data-marker svg{fill:var(--MdsBarChartSelectable__dataMarkerColor,)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/bar-chart/mds-bar-chart.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .bar-chart__chart-body{position:relative}:host .bar-chart__chart-body,:host .bar-chart__data-container{display:flex;flex-direction:column}:host .bar-chart__data-container--left{flex-direction:row}:host .bar-chart__data-container--left .bar-chart__chart-container{flex:1 1 100%}:host .bar-chart__legend{display:flex;flex-wrap:wrap}:host .bar-chart__legend--top{flex-direction:row}:host .bar-chart__legend--top .bar-chart__legend-text{word-break:break-word}:host .bar-chart__legend--top .bar-chart__legend-item{margin-right:var(--MdsBarChart-_legendPosition-top__interItemMargin,24px)}:host .bar-chart__legend--left{flex-direction:column;flex-shrink:0;flex-grow:1;justify-content:flex-end;margin-right:var(--MdsBarChart-_legendPosition-left__trailingMargin,4px);max-width:var(--MdsBarChart-_legendPosition-left__maxWidth,25%)}:host .bar-chart__legend--left .bar-chart__legend-text{word-break:break-word}:host .bar-chart__legend-item{margin-top:var(--MdsBarChart-_legendPosition-top__marginTop,8px);display:inline-flex;flex-wrap:nowrap}:host .bar-chart__legend-swatch{width:var(--MdsBarChart__legendSwatchWidth,16px);height:var(--MdsBarChart__legendSwatchHeight,16px);display:inline-block;margin-top:.125rem;flex-shrink:0}:host .bar-chart__legend-text{margin-left:var(--MdsBarChart__legendTextLeadingMargin,4px);font-size:var(--MdsBarChart__legendTextSize,.875rem);line-height:var(--MdsBarChart__legendTextLineHeight,1.25rem);font-weight:var(--MdsBarChart__legendTextWeight,400)}:host .bar-chart__chart-container{min-height:var(--MdsBarChart__minHeight,200px);min-width:var(--MdsBarChart__minWidth,240px);display:flex;margin-top:var(--MdsBarChart__chartTopMargin,16px)}:host .bar-chart__chart-container--with-axis{margin-top:var(--MdsBarChart__chartWithYAxisTopMargin,8px);padding-top:var(--MdsBarChart-_hasBarLabels-false__dataRegionTopPadding,10px)}:host .bar-chart .bar-chart__svg-container svg{overflow:visible}:host .bar-chart__empty-chart{height:100%;width:100%;display:flex;justify-content:center;align-items:center;font-weight:var(--MdsBarChart__noDataPointTextWeight,400);font-size:var(--MdsBarChart__noDataPointTextSize,.875rem);line-height:var(--MdsBarChart__noDataPointTextLineHeight,1.25rem);padding:var(--MdsBarChart__noDataPointTextPadding,16px)}:host .bar-chart__svg-container svg{overflow:visible;height:100%;width:100%}:host .bar-chart .x-axis text{font-size:var(--MdsBarChart_axisLabel__tickLabelTextSize,.875rem);line-height:var(--MdsBarChart_axisLabel__tickLabelTextLineHeight,1.25rem);font-weight:var(--MdsBarChart_axisLabel__tickLabelTextWeight,400)}:host .bar-chart .x-axis .secondary-label{font-weight:600}:host .bar-chart .y-axis text{font-size:var(--MdsBarChart_axis__tickLabelTextSize,.875rem);line-height:var(--MdsBarChart_axis__tickLabelTextLineHeight,1.25rem)}:host .bar-chart .bar{stroke-width:var(--MdsBarChart_bar__groupedBarBorderWidth,1px)}:host .bar-chart .bar__label{font-size:var(--MdsBarChart_bar__barLabelTextSize,.875rem);font-weight:var(--MdsBarChart_bar__barLabelTextWeight,600)}:host .bar-chart .bar__label--projection{font-weight:var(--MdsBarChart_bar-_projection-true__barLabelTextWeight,400)}:host .bar-chart .bar--projection{stroke-dasharray:var(--MdsBarChart_bar-_projection-true__barBorderDashLength,2px,2px);stroke-width:var(--MdsBarChart_bar-_projection-true__barBorderThickness,1px)}:host .bar-chart .secondary-tick-label{font-size:var(--MdsBarChart_axisLabel__secondaryTickLabelTextSize,.875rem);font-weight:var(--MdsBarChart_axisLabel__secondaryTickLabelTextWeight,600)}:host .bar-chart .baseline{stroke-width:var(--MdsBarChart_bar-_projection-true__barBorderThickness,1px)}.bar-chart__legend-text{color:var(--MdsBarChart__legendTextColor,#101820)}.bar-chart__empty-chart{color:var(--MdsBarChart__noDataPointTextColor,#101820);background-color:var(--MdsBarChart__noDataPointTextBackgroundColor,transparent)}.bar-chart .x-axis text:not(.secondary-label){color:var(--MdsBarChart_axisLabel__tickLabelTextColor,#717171)}.bar-chart .y-axis text:not(.tick--negative){color:var(--MdsBarChart_axis__tickLabelTextColor,#565a5d)}.bar-chart .bar--primary{fill:var(--MdsBarChart_bar__defaultBarColor,#005eb8)}.bar-chart .bar--grouped{stroke:var(--MdsBarChart_bar__groupedBarBorderColor,#fff)}.bar-chart .bar--projection{fill:var(--MdsBarChart_bar-_projection-true__barBackgroundColor,#fff);stroke:var(--MdsBarChart_bar-_projection-true__barBorderColor,#8c8e90)}.bar-chart .bar__label--primary{fill:var(--MdsBarChart_bar__barPrimaryLabelTextColor,#101820)}.bar-chart .bar__label--secondary{fill:var(--MdsBarChart_bar__barSecondaryLabelTextColor,#565a5d)}.bar-chart .bar__label--projection{fill:var(--MdsBarChart_bar-_projection-true__barLabelTextColor,#565a5d)}.bar-chart .bar__label--inset{fill:var(--MdsBarChart_bar__barInsetLabelTextColor,#fff)}.bar-chart .tick--negative{color:var(--MdsBarChart_axis__negativeTickLabelTextColor,#b80009)}.bar-chart .negative-region{fill:var(--MdsBarChart__negativeRegionBackgroundColor,#eceff1)}.bar-chart .secondary-tick-label{fill:var(--MdsBarChart_axisLabel__secondaryTickLabelTextColor,#717171)}.bar-chart .baseline{stroke:var(--MdsBarChart__baselineColor,#c1c3c3)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/bullet-chart/mds-bullet-chart.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans}:host .bullet-chart{display:flex;flex-direction:column;justify-content:flex-end;width:var(--MdsBulletChart__plotAreaWidth,96px);height:var(--MdsBulletChart__plotAreaHeight,64px);background-color:var(--MdsBulletChart__plotAreaBackgroundColor,#f5f7f8)}:host .bullet-chart .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .bullet-chart__benchmark{display:flex;align-items:flex-end;justify-content:center}:host .bullet-chart__benchmark--success{background-color:var(--MdsBulletChart__referenceAreaBackgroundColorSuccess,rgba(47,110,7,.2))}:host .bullet-chart__benchmark--success .bullet-chart__featured-measure{background-color:var(--MdsBulletChart__barColorSuccess,#2f6e07)}:host .bullet-chart__benchmark--critical{background-color:var(--MdsBulletChart__referenceAreaBackgroundColorCritical,rgba(184,0,9,.2))}:host .bullet-chart__benchmark--critical .bullet-chart__featured-measure{background-color:var(--MdsBulletChart__barColorCritical,#b80009)}:host .bullet-chart__featured-measure{width:var(--MdsBulletChart__barWidth,32px)}:host .bullet-chart__reference-line{display:flex}:host .bullet-chart__reference-line svg>line{stroke:var(--MdsBulletChart__referenceLineColor,#565a5d)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/cash-flow-chart/mds-cash-flow-chart.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .cash-flow-chart{display:flex;flex-direction:column;height:100%;position:relative;background-color:var(--MdsCashFlowChart__backgroundColor,#fff)}:host .cash-flow-chart__chart-body{padding:var(--MdsCashFlowChart__plotAreaTopPadding,8px) var(--MdsCashFlowChart__plotAreaLeadingPadding,8px) var(--MdsCashFlowChart__plotAreaBottomPadding,8px) var(--MdsCashFlowChart__plotAreaTrailingPadding,8px)}:host .cash-flow-chart__legend-container{flex:0 0 auto;margin-top:var(--MdsCashFlowChart__legendTopMargin,16px)}:host .cash-flow-chart__legend-item{display:flex;flex-direction:column;height:auto;align-items:center;padding:var(--MdsLineChart_legend__itemVerticalPadding,16px) var(--MdsLineChart_legend__itemHorizontalPadding,8px);flex-basis:0;flex-grow:1}:host .cash-flow-chart__swatch-wrapper{align-self:center;position:relative;height:var(--MdsCashFlowChart__legendSwatchWidth,16px)}:host .cash-flow-chart__swatch-circle{border-radius:50%;width:var(--MdsCashFlowChart__legendSwatchCircleHeight,10px);height:var(--MdsCashFlowChart__legendSwatchCircleHeight,10px);top:.25rem;left:calc(var(--MdsCashFlowChart__legendSwatchCircleHeight, 10px)/-2)}:host .cash-flow-chart__swatch-circle,:host .cash-flow-chart__swatch-line{position:absolute;background-color:var(--MdsCashFlowChart__legendSwatchCircleColor,#101820)}:host .cash-flow-chart__swatch-line{align-self:center;display:inline-block;top:calc(var(--MdsCashFlowChart__legendSwatchCircleHeight, 10px)/2 + .188rem);left:calc(var(--MdsCashFlowChart__legendSwatchLineLength, 48px)/-2);width:var(--MdsCashFlowChart__legendSwatchLineLength,48px);height:var(--MdsCashFlowChart__legendSwatchLineThickness,2px)}:host .cash-flow-chart__swatch-square{width:var(--MdsCashFlowChart__legendSwatchHeight,16px);height:var(--MdsCashFlowChart__legendSwatchWidth,16px)}:host .cash-flow-chart__swatch-square--inflows{background-color:var(--MdsCashFlowChart__legendInflowSwatchColor,#01564c)}:host .cash-flow-chart__swatch-square--outflows{background-color:var(--MdsCashFlowChart__legendOutflowSwatchColor,#004692)}:host .cash-flow-chart__legend-items-container{display:flex;flex-wrap:wrap}:host .cash-flow-chart__legend-key{font-weight:var(--MdsCashFlowChart__legendKeyTextWeight,600);font-size:var(--MdsCashFlowChart__legendKeyTextSize,.875rem);line-height:var(--MdsCashFlowChart__legendKeyTextLineHeight,1.25rem);text-align:var(--MdsCashFlowChart__legendKeyTextAlignment,center);color:var(--MdsCashFlowChart__legendKeyTextColor,#101820)}:host .cash-flow-chart__legend-value{font-weight:var(--MdsCashFlowChart__legendValueTextWeight,600);font-size:var(--MdsCashFlowChart__legendValueTextSize,.875rem);line-height:var(--MdsCashFlowChart__legendValueTextLineHeight,1.25rem);text-align:var(--MdsCashFlowChart__legendValueTextAlignment,center);color:var(--MdsCashFlowChart__legendValueTextColor,#101820)}:host .cash-flow-chart__legend-heading{padding-bottom:var(--MdsCashFlowChart__legendTitleBottomPadding,8px);padding-top:var(--MdsCashFlowChart__legendTitleTopPadding,8px);font-weight:var(--MdsCashFlowChart__legendTitleTextWeight,600);font-size:var(--MdsCashFlowChart__legendTitleTextSize,.875rem);line-height:var(--MdsCashFlowChart__legendTitleTextLineHeight,1.25rem);display:flex;justify-content:center;align-items:center;color:var(--MdsCashFlowChart__legendTitleTextColor,#101820);background-color:var(--MdsCashFlowChart__legendTitleBackgroundColor,#f5f7f8)}:host .cash-flow-chart__empty-chart{height:100%;width:100%;display:flex;justify-content:center;align-items:center}:host .cash-flow-chart__svg-container svg{overflow:visible}:host .cash-flow-chart__svg-container svg rect{cursor:pointer;width:var(--MdsCashFlowChart_series_bar__width,32px)}:host .cash-flow-chart__svg-container svg .rect-inflows{fill:var(--MdsCashFlowChart_series_bar__inflowBackgroundColor,#04806e)}:host .cash-flow-chart__svg-container svg .rect-inflows--selected{fill:var(--MdsCashFlowChart_series_bar__inflowBackgroundColor--selected,#04806e)}:host .cash-flow-chart__svg-container svg .rect-outflows{fill:var(--MdsCashFlowChart_series_bar__outflowBackgroundColor,#0074c7)}:host .cash-flow-chart__svg-container svg .rect-outflows--selected{fill:var(--MdsCashFlowChart_series_bar__outflowBackgroundColor--selected,#004692)}:host .cash-flow-chart__svg-container svg .y-axis{margin-bottom:var(--MdsCashFlowChart_axis__yAxisBottomMargin,6px);color:var(--MdsCashFlowChart_axis__yAxisTextColor,#565a5d)}:host .cash-flow-chart__svg-container svg .y-axis .tick{font-size:var(--MdsCashFlowChart_axis__yAxisTextSize,.875rem)}:host .cash-flow-chart__svg-container svg .y-axis .tick .y-axis__text--neg{color:var(--MdsCashFlowChart_axis__yAxisNegativeTextColor,#b80009)}:host .cash-flow-chart__svg-container svg .x-axis{font-size:var(--MdsCashFlowChart_axisLabel__xAxisTextSize,.875rem);font-weight:var(--MdsCashFlowChart_axisLabel__xAxisTextWeight,400);color:var(--MdsCashFlowChart_axisLabel__xAxisTextColor,#565a5d)}:host .cash-flow-chart__svg-container svg .borderline{fill:none;stroke:var(--MdsCashFlowChart_series_line__borderColor,#fff);stroke-linecap:square;stroke-width:calc(var(--MdsCashFlowChart_series_line__borderThickness, 1px)*4);pointer-events:none}:host .cash-flow-chart__svg-container svg .line{fill:none;stroke:var(--MdsCashFlowChart_series_line__color,#101820);stroke-width:var(--MdsCashFlowChart_series_line__thickness,2px);stroke-linecap:square;pointer-events:none}:host .cash-flow-chart__svg-container svg .dot{stroke-width:var(--MdsCashFlowChart_series_line__circleBorderThickness,1px);stroke:var(--MdsCashFlowChart_series_line__circleBorderColor,#fff);pointer-events:none;fill:var(--MdsCashFlowChart_series_line__circleColor,#101820)}:host .cash-flow-chart__svg-container svg .baseline{stroke-width:var(--MdsCashFlowChart__baselineThickness,2px);stroke:var(--MdsCashFlowChart__baselineColor,#fff);pointer-events:none}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/donut-chart/mds-donut-chart.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;-webkit-tap-highlight-color:transparent}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .donut-chart{padding:var(--AbstractMdsChart__containerTopPadding,16px)}:host .donut-chart__chart-body{display:flex;flex-direction:column;height:100%;width:100%;position:relative}:host .donut-chart__chart-container{width:100%;min-height:7.5rem;min-width:7.5rem;display:flex;justify-content:flex-start;align-items:flex-start}:host .donut-chart__actual-svg{overflow:visible}:host .donut-chart__empty-chart{border-radius:50%;min-height:7.5rem;min-width:7.5rem;color:var(--AbstractMdsChart__noDataPointTextColor,#101820);font-weight:var(--AbstractMdsChart__noDataPointTextWeight,400);font-size:var(--AbstractMdsChart__noDataPointTextSize,.875rem);line-height:var(--AbstractMdsChart__noDataPointTextLineHeight,1.25rem);background-color:var(--MdsDonutChart__noDataPointTextBackgroundColor,#eceff1);border:.0625rem solid var(--MdsDonutChart__noDataPointTextBackgroundColor,#eceff1)}:host .donut-chart__empty-chart,:host .donut-chart__no-display-data{display:flex;justify-content:center;align-items:center;box-sizing:border-box;text-align:center}:host .donut-chart__no-display-data{border-radius:50%;border:var(--MdsDonutChart__noDataPointRingBorderWidth--selectable,) solid var(--MdsDonutChart__noDisplayValueRingBorderColor,#c1c3c3)}:host .donut-chart__no-display-data--outer-circle{min-height:7.5rem;min-width:7.5rem}:host .donut-chart__alternative-view-link{margin-top:var(--AbstractMdsChart__accessibleAlternativeLinkTextTopMargin,16px);align-self:center}:host .donut-chart__expand-button{position:absolute;right:0;top:-2.25rem}:host .donut-chart__center-text{height:100%;text-align:center;overflow:hidden;padding:.125rem}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/gauge-chart-linear/mds-gauge-chart-linear.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .gauge-chart-linear{display:flex;flex-direction:column}:host .gauge-chart-linear--below{flex-direction:column-reverse}:host .gauge-chart-linear--below .gauge-chart-linear__primary-label,:host .gauge-chart-linear--below .gauge-chart-linear__secondary-label-container{margin-top:var(--MdsGaugeChartLinear-_position-below__labelMarginTop,4px)}:host .gauge-chart-linear--above .gauge-chart-linear__primary-label,:host .gauge-chart-linear--above .gauge-chart-linear__secondary-label-container{margin-bottom:var(--MdsGaugeChartLinear-_position-above__labelMarginBottom,4px)}:host .gauge-chart-linear--pin.gauge-chart-linear--trailingBarLabel .gauge-chart-linear__gauge-container{padding-top:calc(var(--MdsGaugeChartLinear__pinHeight, 3rem) - var(--MdsGaugeChartLinear__trailingBarLabelTextLineHeight, 1.25rem)/2 + var(--MdsGaugeChartLinear__containerHeight, .5rem)/2)}:host .gauge-chart-linear--pin .gauge-chart-linear__gauge-container{padding-top:var(--MdsGaugeChartLinear__pinHeight,48px)}:host .gauge-chart-linear .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .gauge-chart-linear__gauge-container{display:flex;align-items:center;opacity:0}:host .gauge-chart-linear__track,:host .gauge-chart-linear__track--range{position:relative;height:0;flex-grow:1;border-radius:var(--MdsGaugeChartLinear__containerBorderRadius,12px);background-color:var(--MdsGaugeChartLinear__containerColor,#8c8e90);border:calc(var(--MdsGaugeChartLinear__trackHeight, 4px)/2) solid var(--MdsGaugeChartLinear__containerColor,#8c8e90);border-right:0}:host .gauge-chart-linear__track--range{border:0}:host .gauge-chart-linear__indicator{background-color:var(--MdsGaugeChartLinear__areaColor,#005eb8)}:host .gauge-chart-linear__indicator,:host .gauge-chart-linear__indicator--range{position:absolute;border-radius:var(--MdsGaugeChartLinear__areaBorderRadius,12px);height:calc(var(--MdsGaugeChartLinear__trackHeight, 4px)*2);top:calc(var(--MdsGaugeChartLinear__areaHeight, 8px)/-1 + 2px);left:calc(var(--MdsGaugeChartLinear__areaHeight, 8px)/-2);border:var(--MdsGaugeChartLinear__indicatorOuterBorderWidth,2px) solid var(--MdsGaugeChartLinear__indicatorOuterBorderColor,#fff)}:host .gauge-chart-linear__indicator--empty,:host .gauge-chart-linear__indicator--range--empty{border-style:none}:host .gauge-chart-linear__indicator--range{width:100%;background-image:linear-gradient(90deg,rgba(0,94,184,.4),var(--MdsGaugeChartLinear__areaColor,#005eb8))}:host .gauge-chart-linear__pin-container{position:relative;display:inline-flex;margin-left:calc(var(--MdsGaugeChartLinear__pinWidth, 48px)*-1/2);top:calc(var(--MdsGaugeChartLinear__pinHeight, 48px)*-1 + var(--MDsGaugeChartLinear__containerHeight, 8px)/2*-1)}:host .gauge-chart-linear__pin-background-icon svg{height:var(--MdsGaugeChartLinear__pinHeight,48px);width:var(--MdsGaugeChartLinear__pinWidth,48px);fill:var(--MdsGaugeChartLinear__pinTextBackgroundColor,#005eb8)}:host .gauge-chart-linear__pin-icon{top:var(--MdsGaugeChartLinear__pinIconMarginTop,9px)}:host .gauge-chart-linear__pin-icon svg{height:var(--MdsGaugeChartLinear__pinIconHeight,24px);width:var(--MdsGaugeChartLinear__pinIconWidth,24px);fill:var(--MdsGaugeChartLinear__pinIconColor,#fff)}:host .gauge-chart-linear__pin-text{top:var(--MdsGaugeChartLinear__pinTextMarginTop,12px);font-size:var(--MdsGaugeChartLinear__pinTextSize,.75rem);white-space:nowrap;padding-right:var(--MdsGaugeChartLinear__pinTextPaddingTrailing,2px);padding-left:var(--MdsGaugeChartLinear__pinTextPaddingLeading,2px);line-height:var(--MdsGaugeChartLinear__pinTextLineHeight,1rem);font-weight:var(--MdsGaugeChartLinear__pinTextWeight,600);border-radius:var(--MdsGaugeChartLinear__pinTextBorderRadius,2px);background-color:var(--MdsGaugeChartLinear__pinTextBackgroundColor,#005eb8);color:var(--MdsGaugeChartLinear__pinTextColor,#fff)}:host .gauge-chart-linear .gauge-chart-linear__pin-icon,:host .gauge-chart-linear .gauge-chart-linear__pin-text{position:absolute;left:calc(var(--MdsGaugeChartLinear__pinWidth, 48px)/2);transform:translateX(-50%)}:host .gauge-chart-linear #gauge-chart-linear__pin{position:absolute;left:0}:host .gauge-chart-linear__labels{display:flex}:host .gauge-chart-linear__labels .gauge-chart-linear__primary-label{color:var(--MdsGaugeChartLinear__primaryLabelTextColor,#565a5d);font-size:var(--MdsGaugeChartLinear__primaryLabelTextSize,.875rem);font-weight:var(--MdsGaugeChartLinear__primaryLabelTextWeight,400);line-height:var(--MdsGaugeChartLinear__primaryLabelTextLineHeight,1.25rem)}:host .gauge-chart-linear__labels .gauge-chart-linear__secondary-label{color:var(--MdsGaugeChartLinear__secondaryLabelTextColor,#565a5d);font-size:var(--MdsGaugeChartLinear__secondaryLabelTextSize,.875rem);font-weight:var(--MdsGaugeChartLinear__secondaryLabelTextWeight,400);line-height:var(--MdsGaugeChartLinear__secondaryLabelTextLineHeight,1.25rem);text-align:right}:host .gauge-chart-linear__labels .gauge-chart-linear__secondary-label-container{margin-left:auto;display:flex;padding-left:var(--MdsGaugeChartLinear__secondaryLabelMarginLeading,24px)}:host .gauge-chart-linear__labels .gauge-chart-linear__secondary-label-value{color:var(--MdsGaugeChartLinear__secondaryLabelValueTextColor,#565a5d);font-size:var(--MdsGaugeChartLinear__secondaryLabelValueTextSize,.875rem);font-weight:var(--MdsGaugeChartLinear__secondaryLabelValueTextWeight,600);line-height:var(--MdsGaugeChartLinear__secondaryLabelValueTextLineHeight,1.25rem);margin-left:var(--MdsGaugeChartLinear__secondaryLabelValueMarginLeading,4px)}:host .gauge-chart-linear__trailing-bar-label{color:var(--MdsGaugeChartLinear__trailingBarLabelTextColor,#101820);font-size:var(--MdsGaugeChartLinear__trailingBarLabelTextSize,.875rem);font-weight:var(--MdsGaugeChartLinear__trailingBarLabelTextWeight,600);line-height:var(--MdsGaugeChartLinear__trailingBarLabelTextLineHeight,1.25rem);margin-left:var(--MdsGaugeChartLinear__trailingBarLabelMarginLeading,8px)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/gauge-chart-radial/mds-gauge-chart-radial.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .gauge-chart-radial{opacity:0;overflow:inherit}:host .gauge-chart-radial .gauge-chart-radial--secondary .gauge-chart-radial__primary-data-marker{stroke-width:var(--MdsGaugeChartRadial__primaryDataMarkerBorderRadiusWidth,2px)}:host .gauge-chart-radial--regular .gauge-chart-radial__track{stroke-width:var(--MdsGaugeChartRadial-_thickness-regular__trackWidth,10px)}:host .gauge-chart-radial--regular .gauge-chart-radial__primary-indicator{stroke-width:var(--MdsGaugeChartRadial-_thickness-regular__primaryIndicatorWidth,16px)}:host .gauge-chart-radial--regular .gauge-chart-radial__secondary-indicator{stroke-width:var(--MdsGaugeChartRadial-_thickness-regular__secondaryIndicatorWidth,16px)}:host .gauge-chart-radial__bar-label-leading,:host .gauge-chart-radial__bar-label-trailing{font-weight:var(--MdsGaugeChartRadial__barLabelTextWeight,400);font-size:var(--MdsGaugeChartRadial__barLabelTextSize,.875rem);text-anchor:middle;fill:var(--MdsGaugeChartRadial__barLabelTextColor,#565a5d)}:host .gauge-chart-radial__container{height:100%;width:100%;position:relative}:host .gauge-chart-radial__content{top:33%;left:25%;width:50%;height:66%;overflow:auto;position:absolute}:host .gauge-chart-radial__primary-indicator{fill:none;stroke-linecap:round;stroke:var(--MdsGaugeChartRadial__primaryAreaColor,#005eb8)}:host .gauge-chart-radial__primary-indicator--outer-border{fill:none;stroke-width:calc(var(--MdsGaugeChartRadial-_thickness-regular__primaryIndicatorWidth, 16px) + var(--MdsGaugeChartRadial__primaryDataMarkerBorderRadiusWidth, 2px)*2);stroke-linecap:round;stroke:var(--MdsGaugeChartRadial__primaryDataMarkerBorderColor,#fff)}:host .gauge-chart-radial__secondary-indicator{fill:none;stroke-linecap:round;stroke:var(--MdsGaugeChartRadial__secondaryAreaColor,#8c8e90)}:host .gauge-chart-radial__track{fill:none;stroke-linecap:round;stroke-width:var(--MdsGaugeChartRadial-_thickness-regular__trackWidth,10px);stroke:var(--MdsGaugeChartRadial__trackColor,#8c8e90)}:host .gauge-chart-radial__primary-data-marker{fill:var(--MdsGaugeChartRadial__primaryAreaColor,#005eb8)}:host .gauge-chart-radial__secondary-data-marker{fill:var(--MdsGaugeChartRadial__secondaryAreaColor,#8c8e90);stroke:var(--MdsGaugeChartRadial__primaryDataMarkerBorderColor,#fff);stroke-width:var(--MdsGaugeChartRadial__primaryDataMarkerBorderRadiusWidth,2px)}:host .gauge-chart-radial__datamarker-icon svg{height:var(--MdsGaugeChartRadial__secondaryDataMarkerIconHeight,24px);width:var(--MdsGaugeChartRadial__secondaryDataMarkerIconWidth,24px);fill:var(--MdsGaugeChartRadial__secondaryDataMarkerIconColor,#fff)}:host .gauge-chart-radial--thin .gauge-chart-radial__track{stroke-width:var(--MdsGaugeChartRadial-_thickness-thin__trackWidth,4px)}:host .gauge-chart-radial--thin .gauge-chart-radial__primary-indicator{stroke-width:var(--MdsGaugeChartRadial-_thickness-thin__primaryindicatorWidth,8px)}:host .gauge-chart-radial--thin .gauge-chart-radial__primary-indicator--outer-border{fill:none;stroke-width:calc(var(--MdsGaugeChartRadial-_thickness-thin__primaryindicatorWidth, 8px) + var(--MdsGaugeChartRadial__primaryDataMarkerBorderRadiusWidth, 2px)*2);stroke-linecap:round;stroke:var(--MdsGaugeChartRadial__primaryDataMarkerBorderColor,#fff)}:host .gauge-chart-radial--thin .gauge-chart-radial__secondary-indicator{stroke-width:var(--MdsGaugeChartRadial-_thickness-thin__secondaryIndicatorWidth,8px)}:host .gauge-chart-radial--secondary .gauge-chart-radial__primary-data-marker{stroke:var(--MdsGaugeChartRadial__primaryDataMarkerBorderColor,#fff);stroke-width:var(--MdsGaugeChartRadial__primaryDataMarkerBorderRadiusWidth,2px)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/line-chart/mds-line-chart.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .line-chart{display:flex;flex-direction:column;padding-left:var(--MdsLineChart__chartLeftPadding,8px);padding-top:var(--MdsLineChart__containerTopPadding,16px);padding-bottom:var(--MdsLineChart__containerBottomPadding,16px)}:host .line-chart--with-top-border{border-top:var(--MdsLineChart__graphAreaTopBorderWidth,1px) var(--MdsLineChart__graphAreaTopBorderStyle,solid) var(--MdsLineChart__graphAreaTopBorderColor,#e2e4e5)}:host .line-chart__chart-body{display:flex;flex-direction:column;height:100%;position:relative}:host .line-chart__chart-container{min-height:var(--MdsLineChart__minHeight,200px);min-width:var(--MdsLineChart__minWidth,240px)}:host .line-chart__legend-heading{padding:var(--MdsLineChart__legendXAxisVerticalPadding,8px);color:var(--MdsLineChart__legendXAisTextColor,#101820);font-weight:var(--MdsLineChart__legendXAisTextWeight,600);font-size:var(--MdsLineChart__legendXAxisTextSize,.875rem);line-height:var(--MdsLineChart__legendXAxisTextLineHeight,1.25rem);display:flex;justify-content:center;align-items:center;background-color:var(--MdsLineChart__legendXAxisBackgroundColor,#f5f7f8)}:host .line-chart__legend-item{display:flex;flex-direction:column;height:auto;align-items:center;padding:var(--MdsLineChart_legend__itemVerticalPadding,16px) var(--MdsLineChart_legend__itemHorizontalPadding,8px);min-width:var(--MdsLineChart_legend__itemMinimumWidth,48px);flex-basis:0;flex-grow:1}:host .line-chart__legend-item-break{flex-basis:100%;height:0;flex-grow:0;flex-shrink:1}:host .line-chart__legend-value{margin-top:var(--MdsLineChart_legend__textPaddingTop,4px);color:var(--MdsLineChart__legendYAxisTextColor,#101820);font-weight:var(--MdsLineChart__legendYAxisTextWeight,600);font-size:var(--MdsLineChart__legendYAxisTextSize,.875rem);line-height:var(--MdsLineChart__legendYAxisTextLineHeight,1.25rem);text-align:center}:host .line-chart__legend-value--negative{color:var(--MdsLineChart__legendYAxisNegativeTextColor,#b80009)}:host .line-chart__swatch-wrapper{align-self:center;position:relative;height:var(--MdsLineChart_legend__swatchCircleHeight,10px)}:host .line-chart__swatch-circle{border-radius:50%;position:absolute;top:0;left:calc(var(--MdsLineChart_legend__swatchCircleHeight, 10px)/-2);width:var(--MdsLineChart_legend__swatchCircleHeight,10px);height:var(--MdsLineChart_legend__swatchCircleHeight,10px)}:host .line-chart__swatch-circle svg{display:block}:host .line-chart__swatch{align-self:center;display:inline-block;position:absolute;top:calc(var(--MdsLineChart_legend__swatchCircleHeight, 10px)/2 - .0625rem);left:calc(var(--MdsLineChart_legend__swatchLineLength, 48px)/-2);width:var(--MdsLineChart_legend__swatchLineLength,48px);height:var(--MdsLineChart_legend__swatchLineWeight,1px)}:host .line-chart__swatch--primary{height:var(--MdsLineChart_legend__swatchLineWeightPrimary,2px);background-color:var(--MdsLineChart_line-_isPrimary-true__lineColor,#005eb8)}:host .line-chart__swatch--reference-line{background-image:linear-gradient(90deg,var(--MdsLineChart__referenceLineColor,#8c8e90) 0,var(--MdsLineChart__referenceLineColor,#8c8e90) 4px,transparent 0,transparent 5px,var(--MdsLineChart__referenceLineColor,#8c8e90) 0,var(--MdsLineChart__referenceLineColor,#8c8e90) 9px,transparent 0,transparent 10px,var(--MdsLineChart__referenceLineColor,#8c8e90) 0,var(--MdsLineChart__referenceLineColor,#8c8e90) 14px,transparent 0,transparent 15px,var(--MdsLineChart__referenceLineColor,#8c8e90) 0,var(--MdsLineChart__referenceLineColor,#8c8e90) 19px,transparent 0,transparent 20px,var(--MdsLineChart__referenceLineColor,#8c8e90) 0,var(--MdsLineChart__referenceLineColor,#8c8e90) 24px,transparent 0,transparent 25px,var(--MdsLineChart__referenceLineColor,#8c8e90) 0,var(--MdsLineChart__referenceLineColor,#8c8e90) 29px,transparent 0,transparent 30px,var(--MdsLineChart__referenceLineColor,#8c8e90) 0,var(--MdsLineChart__referenceLineColor,#8c8e90) 34px,transparent 0,transparent 35px,var(--MdsLineChart__referenceLineColor,#8c8e90) 0,var(--MdsLineChart__referenceLineColor,#8c8e90) 39px,transparent 0,transparent 40px,var(--MdsLineChart__referenceLineColor,#8c8e90) 0,var(--MdsLineChart__referenceLineColor,#8c8e90) 44px,transparent 0,transparent 45px,var(--MdsLineChart__referenceLineColor,#8c8e90) 0,var(--MdsLineChart__referenceLineColor,#8c8e90) 49px)}:host .line-chart__swatch-circle--primary svg{fill:var(--MdsLineChart_line-_isPrimary-true__lineColor,#005eb8)}:host .line-chart__line-label{margin-top:var(--MdsLineChart_legend__textPaddingTop,4px);color:var(--MdsLineChart__legendLineLabelTextColor,#101820);font-weight:var(--MdsLineChart__legendLineLabelTextWeight,600);font-size:var(--MdsLineChart__legendYAxisTextSize,.875rem);line-height:var(--MdsLineChart__legendYAxisTextLineHeight,1.25rem);text-align:center}:host .line-chart__legend-container{flex:0 0 auto;padding-top:calc(.375rem + var(--MdsLineChart__legendTopMargin, 8px));border-bottom:var(--MdsLineChart__legendBottomBorderWidth,1px) var(--MdsLineChart__legendBottomBorderColor,#c1c3c3) var(--MdsLineChart__legendBottomBorderStyle,solid)}:host .line-chart__legend-item-container{display:flex;flex-wrap:wrap}:host .line-chart__empty-chart{height:100%;width:100%;display:flex;justify-content:center;align-items:center;color:var(--AbstractMdsXYChart__noDataPointTextColor,#101820);font-weight:var(--AbstractMdsXYChart__noDataPointTextWeight,400);font-size:var(--AbstractMdsXYChart__noDataPointTextSize,.875rem);line-height:var(--AbstractMdsXYChart__noDataPointTextLineHeight,1.25rem)}:host .line-chart .reference-line{stroke-dashoffset:var(--MdsLineChart__referenceLineDashLength,4px),var(--MdsLineChart__referenceLineDashGap,1px);stroke:var(--MdsLineChart__referenceLineColor,#8c8e90)}:host .line-chart .line--primary{stroke:var(--MdsLineChart_line-_isPrimary-true__lineColor,#005eb8)}:host .line-chart .line-label{fill:var(--MdsLineChart_line__lineLabelBackgroundColor,#005eb8)}:host .line-chart .line-label--text{fill:var(--MdsLineChart_line__lineLabelTextColor,#fff)}:host .line-chart .detail-marker--primary{fill:var(--MdsLineChart_line__dataPointDetailMarkerBorderColor,#005eb8)}:host .line-chart .detail-line{stroke:var(--MdsLineChart_line__dataPointDetailLineColor,#565a5d)}:host .line-chart .text-detail-container rect{fill:var(--MdsLineChart_line__dataPointDetailBackgroundColor,#565a5d)}:host .line-chart .text-detail-container text{fill:var(--MdsLineChart_line__dataPointDetailTextColor,#fff)}:host .line-chart .baseline{stroke:var(--MdsLineChart__baselineColor,#8c8e90)}:host .line-chart__svg-container svg{overflow:visible;height:100%;width:100%}:host .line-chart .x-axis text,:host .line-chart .y-axis text{font-size:var(--MdsLineChart_axis__tickLabelTextSizeLargeChart,.875rem);line-height:var(--MdsLineChart_axis__tickLabelTextLineHeight,1.25rem);color:var(--MdsLineChart_axis__tickLabelTextColor,#565a5d)}:host .line-chart .y-axis .tick--negative{color:var(--MdsLineChart_axis__negativeTickLabelTextColor,#b80009)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/projection-bar-chart/projection-bar-chart.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .projection-bar-chart__chart-body{display:flex;flex-direction:column;position:relative}:host .projection-bar-chart__data-container{display:flex;flex-direction:row}:host .projection-bar-chart__legend-right{max-width:var(--MdsProjectionBarChart__legendMaxWidth,45%);display:flex;flex-wrap:wrap;flex-direction:column}:host .projection-bar-chart__legend-list-container{margin:0;padding:0;list-style:none}:host .projection-bar-chart__legend-item{margin-bottom:var(--MdsProjectionBarChart__projectionAnnotationBottomMargin,8px);display:inline-flex;flex-wrap:nowrap}:host .projection-bar-chart__legend-swatch{width:var(--MdsBarChart__legendSwatchWidth,16px);height:var(--MdsBarChart__legendSwatchHeight,16px);display:block;float:left;margin-top:.125rem;flex-shrink:0}:host .projection-bar-chart__legend-swatch--high{background-color:var(--MdsProjectionBarChart__highProjectionBarBackgroundColor,#0091da)}:host .projection-bar-chart__legend-swatch--medium{background-color:var(--MdsProjectionBarChart__mediumProjectionBarBackgroundColor,#005eb8)}:host .projection-bar-chart__legend-swatch--low{background-color:var(--MdsProjectionBarChart__lowProjectionBarBackgroundColor,#004692)}:host .projection-bar-chart__legend-title{display:inline-flex;margin-bottom:var(--MdsProjectionBarChart__projectionAnnotationBottomMargin,8px);font-size:var(--MdsProjectionBarChart__annotationLabelTextSize,.875rem);line-height:var(--MdsProjectionBarChart__annotationLabelLineHeight,1.25rem);font-weight:var(--MdsProjectionBarChart__annotationLabelTextWeight,400);color:var(--MdsProjectionBarChart__annotationTextColor,#101820)}:host .projection-bar-chart__legend-text{margin-left:var(--MdsProjectionBarChart__annotationTextLeadingMargin,8px);font-size:var(--MdsProjectionBarChart__annotationValueTextSize,.875rem);line-height:var(--MdsProjectionBarChart__annotationValueLineHeight,1.25rem);font-weight:var(--MdsProjectionBarChart__annotationValueTextWeight,600);color:var(--MdsProjectionBarChart__annotationTextColor,#101820)}:host .projection-bar-chart__legend-value{display:block}:host .projection-bar-chart__chart-container{display:flex;margin-right:var(--MdsProjectionBarChart__projectionAnnotationLeadingMargin,16px);flex-shrink:0;flex-direction:column}:host .projection-bar-chart__svg-container svg{overflow:visible}:host .projection-bar-chart__empty-chart{height:100%;width:100%;display:flex;justify-content:center;align-items:center;font-weight:var(--MdsBarChart__noDataPointTextWeight,400);font-size:var(--MdsBarChart__noDataPointTextSize,.875rem);line-height:var(--MdsBarChart__noDataPointTextLineHeight,1.25rem);padding:var(--MdsBarChart__noDataPointTextPadding,16px);color:var(--MdsProjectionBarChart__noDataPointTextColor,#101820);background-color:var(--MdsProjectionBarChart__noDataPointTextBackgroundColor,transparent)}:host .projection-bar-chart .baseline{stroke-width:var(--MdsProjectionBarChart__baselineWidth,1px);stroke:var(--MdsProjectionBarChart__baselineColor,#c1c3c3)}:host .projection-bar-chart rect{stroke-width:var(--MdsProjectionBarChart__projectionBarBorderWidth,2px);transition-timing-function:var(--MdsProjectionBarChart__projectionBarTransitionEase,cubic-bezier(0,.2,.1,1));transition-duration:var(--MdsProjectionBarChart__projectionBarTransitionTime,.5s);stroke:var(--MdsProjectionBarChart__projectionBarBorderColor,#fff)}:host .projection-bar-chart .bar__label--primary{font-weight:var(--MdsProjectionBarChart__annotationLabelTextWeight,400)}:host .projection-bar-chart .bar__label--secondary{font-weight:var(--MdsProjectionBarChart__annotationValueTextWeight,600)}:host .projection-bar-chart .bar__label--group{line-height:var(--MdsProjectionBarChart__annotationValueLineHeight,1.25rem);fill:var(--MdsProjectionBarChart__annotationTextColor,#101820)}:host .projection-bar-chart .bar--high{transition-delay:var(--MdsProjectionBarChart__highProjectionBarTransitionDelayTime,.15s);fill:var(--MdsProjectionBarChart__highProjectionBarBackgroundColor,#0091da)}:host .projection-bar-chart .bar--medium{transition-delay:var(--MdsProjectionBarChart__mediumProjectionBarTransitionDelayTime,.1s);fill:var(--MdsProjectionBarChart__mediumProjectionBarBackgroundColor,#005eb8)}:host .projection-bar-chart .bar--low{transition-delay:var(--MdsProjectionBarChart__lowProjectionBarTransitionDelayTime,50ms);fill:var(--MdsProjectionBarChart__lowProjectionBarBackgroundColor,#004692)}:host .projection-bar-chart .bar--current{fill:var(--MdsProjectionBarChart__currentMeasureBarBackgroundColor,#115880)}:host .projection-bar-chart__non-positive-chart{display:flex;justify-content:space-between;border-bottom-color:var(--MdsProjectionBarChart__baselineColor,#c1c3c3);border-bottom:var(--MdsProjectionBarChart__baselineWidth,1px) solid var(--MdsProjectionBarChart__baselineColor,#c1c3c3)}:host .projection-bar-chart__non-positive__current-measure{display:flex;flex-direction:column;align-self:flex-end}:host .projection-bar-chart__non-positive__current-measure__key{font-weight:var(--MdsProjectionBarChart__annotationKeyTextWeight,600);font-size:var(--MdsProjectionBarChart__annotationKeyTextSize,.875rem);line-height:var(--MdsProjectionBarChart__annotationKeyLineHeight,1.25rem);color:var(--MdsProjectionBarChart__annotationTextColor,#101820)}:host .projection-bar-chart__non-positive__current-measure__value{font-weight:var(--MdsProjectionBarChart__annotationValueTextWeight,600);font-size:var(--MdsProjectionBarChart__annotationValueTextSize,.875rem);line-height:var(--MdsProjectionBarChart__annotationValueLineHeight,1.25rem);color:var(--MdsProjectionBarChart__annotationTextColor,#101820)}:host .projection-bar-chart__non-positive__message{display:flex;justify-content:center;align-items:center;font-weight:var(--MdsProjectionBarChart__annotationLabelTextWeight,400);font-size:var(--MdsProjectionBarChart__annotationLabelTextSize,.875rem);line-height:var(--MdsProjectionBarChart__annotationLabelLineHeight,1.25rem);color:var(--MdsProjectionBarChart__annotationTextColor,#101820)}:host .projection-bar-chart__non-positive__current-measure__value--negative{color:var(--MdsProjectionBarChart__annotationNegativeValueColor,#b80009)}:host .projection-bar-chart--low{fill:var(--MdsProjectionBarChart__lowProjectionBarBackgroundColor,#004692)}:host__legend-swatch--high{background-color:var(--MdsProjectionBarChart__highProjectionBarBackgroundColor,#0091da)}:host__legend-swatch--medium{background-color:var(--MdsProjectionBarChart__mediumProjectionBarBackgroundColor,#005eb8)}:host__legend-swatch--low{background-color:var(--MdsProjectionBarChart__lowProjectionBarBackgroundColor,#004692)}:host__non-positive-chart{border-bottom-color:var(--MdsProjectionBarChart__baselineColor,#c1c3c3)}:host__non-positive__current-measure__key,:host__non-positive__current-measure__value{color:var(--MdsProjectionBarChart__annotationTextColor,#101820)}:host__non-positive__current-measure__value--negative{color:var(--MdsProjectionBarChart__annotationNegativeValueColor,#b80009)}:host__non-positive__message{color:var(--MdsProjectionBarChart__annotationTextColor,#101820)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/projection-line-chart/mds-projection-line-chart.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host *{box-sizing:border-box;font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif}:host .accessible-text{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}:host .projection-line-chart .area{fill:var(--MdsProjectionLineChart__bandColor,#eaf6ff)}:host .projection-line-chart .area--bottom{fill:#fff}:host .projection-line-chart__chart-body{display:flex;flex-direction:column;position:relative;border-top:var(--MdsProjectionLineChart__topBorderWidth,1px) var(--MdsProjectionLineChart__topBorderStyle,solid) var(--MdsProjectionLineChart__topBorderColor,#e2e4e5)}:host .projection-line-chart__data-container{display:flex;flex-direction:column}:host .projection-line-chart__chart-container--with-axis{min-height:var(--MdsProjectionLineChart__minHeight,200px);min-width:var(--MdsProjectionLineChart__minWidth,240px);margin-top:var(--MdsProjectionLineChart__containerTopPadding,16px)}:host .projection-line-chart__empty-chart{height:100%;width:100%;display:flex;justify-content:center;align-items:center;font-weight:var(--MdsProjectionLineChart__noDataPointTextWeight,400);font-size:var(--MdsProjectionLineChart__noDataPointTextSize,.875rem);line-height:var(--MdsProjectionLineChart__noDataPointTextLineHeight,1.25rem);padding:var(--MdsProjectionLineChart__noDataPointTextPadding,16px);color:var(--MdsProjectionLineChart__noDataPointTextColor,#101820);background-color:var(--MdsProjectionLineChart__noDataPointTextBackgroundColor,transparent)}:host .projection-line-chart .slot{height:100%;width:100%}:host .projection-line-chart__legend-heading{padding:var(--MdsProjectionLineChart__legendTitleVerticalPadding,8px);font-weight:var(--MdsProjectionLineChart__legendTitleTextWeight,600);font-size:var(--MdsProjectionLineChart__legendTitleTextSize,.875rem);line-height:var(--MdsProjectionLineChart__legendTitleTextLineHeight,1.25rem);display:flex;justify-content:center;align-items:center;border-radius:var(--MdsProjectionLineChart__legendTitleBarBorderRadius,2px);color:var(--MdsProjectionLineChart__legendTitleTextColor,#101820);background-color:var(--MdsProjectionLineChart__legendTitleBarColor,#f5f7f8)}:host .projection-line-chart__legend-line-label{font-weight:var(--MdsProjectionLineChart_legend_items__legendLineNameTextWeight,600);font-size:var(--MdsProjectionLineChart_legend_items__legendLineNameTextSize,.875rem);line-height:var(--MdsProjectionLineChart_legend_items__legendLineNameTextLineHeight,1.25rem);color:var(--MdsProjectionLineChart_legend_items__legendLineNameTextColor,#101820)}:host .projection-line-chart__legend-line-label,:host .projection-line-chart__legend-value{margin-top:var(--MdsProjectionLineChart_legend_items__itemTextTopPadding,4px);text-align:center}:host .projection-line-chart__legend-value{font-weight:var(--MdsProjectionLineChart_legend_items__legendValueTextWeight,600);font-size:var(--MdsProjectionLineChart_legend_items__legendValueTextSize,.875rem);line-height:var(--MdsProjectionLineChart_legend_items__legendValueTextLineHeight,1.25rem);color:var(--MdsProjectionLineChart_legend_items__legendValueTextColor,#101820)}:host .projection-line-chart__legend-item{display:flex;flex-direction:column;height:auto;align-items:center;padding:var(--MdsProjectionLineChart_legend_items__itemVerticalPadding,14px) var(--MdsProjectionLineChart_legend_items__itemHorizontalPadding,8px);min-width:var(--MdsProjectionLineChart_legend_items__itemMinimumWidth,48px);flex-basis:0;flex-grow:1}:host .projection-line-chart__swatch-wrapper{align-self:center;position:relative;height:var(--MdsProjectionLineChart_legend_items__swatchCircleHeight,10px)}:host .projection-line-chart__swatch-circle{border-radius:50%;position:absolute;top:0;left:calc(var(--MdsProjectionLineChart_legend_items__swatchCircleHeight, 10px)/-2);width:var(--MdsProjectionLineChart_legend_items__swatchCircleHeight,10px);height:var(--MdsProjectionLineChart_legend_items__swatchCircleHeight,10px);background-position:0 0;background-repeat:repeat-x;background-color:var(--MdsProjectionLineChart__lineColorPrimary,#005eb8)}:host .projection-line-chart__swatch-circle--top{background-color:var(--MdsProjectionLineChart__lineColorTop,#0091da)}:host .projection-line-chart__swatch-circle--bottom{background-color:var(--MdsProjectionLineChart__lineColorBottom,#004692)}:host .projection-line-chart__swatch{align-self:center;display:inline-block;position:absolute;top:calc(var(--MdsProjectionLineChart_legend_items__swatchCircleHeight, 10px)/2 - .0625rem);left:calc(var(--MdsProjectionLineChart_legend_items__swatchLineLength, 48px)/-2);width:var(--MdsProjectionLineChart_legend_items__swatchLineLength,48px);height:var(--MdsProjectionLineChart_legend_items__swatchLineWidth,2px)}:host .projection-line-chart__swatch--primary{background-color:var(--MdsProjectionLineChart__lineColorPrimary,#005eb8)}:host .projection-line-chart__swatch--top{background:repeating-linear-gradient(90deg,var(--MdsProjectionLineChart__lineColorTop,#0091da),var(--MdsProjectionLineChart__lineColorTop,#0091da) var(--MdsProjectionLineChart__topLineDashLength,4px),transparent calc(var(--MdsProjectionLineChart__topLineDashLength, 4px) + var(--MdsProjectionLineChart__topLineDashGap, 2px)),transparent calc(var(--MdsProjectionLineChart__topLineDashLength, 4px) + var(--MdsProjectionLineChart__topLineDashGap, 2px) + var(--MdsProjectionLineChart__topLineDashGap, 2px)))}:host .projection-line-chart__swatch--bottom{background:repeating-linear-gradient(90deg,var(--MdsProjectionLineChart__lineColorBottom,#004692),var(--MdsProjectionLineChart__lineColorBottom,#004692) var(--MdsProjectionLineChart__topLineDashLength,4px),transparent calc(var(--MdsProjectionLineChart__topLineDashLength, 4px) + var(--MdsProjectionLineChart__bottomLineDashGap, 2px)),transparent calc(var(--MdsProjectionLineChart__topLineDashLength, 4px) + var(--MdsProjectionLineChart__bottomLineDashGap, 2px) + var(--MdsProjectionLineChart__bottomLineDashGap, 2px)))}:host .projection-line-chart__legend-container{flex:0 0 auto;padding-top:calc(.375rem + var(--MdsProjectionLineChart__legendTopMargin, 8px));border-bottom:var(--MdsProjectionLineChart__bottomBorderWidth,1px) var(--MdsProjectionLineChart__bottomBorderStyle,solid) var(--MdsProjectionLineChart__bottomBorderColor,#e2e4e5)}:host .projection-line-chart__legend-item-container{display:flex;flex-wrap:wrap}:host .projection-line-chart__svg-container svg{overflow:visible;height:100%;width:100%}:host .projection-line-chart__svg-container svg .line{fill:none;stroke-width:var(--MdsProjectionLineChart__lineThickness,2px);stroke:var(--MdsProjectionLineChart__lineColorPrimary,#005eb8)}:host .projection-line-chart__svg-container svg .line--top{stroke-dasharray:var(--MdsProjectionLineChart__topLineDashLength,4px) var(--MdsProjectionLineChart__topLineDashGap,2px);stroke:var(--MdsProjectionLineChart__lineColorTop,#0091da)}:host .projection-line-chart__svg-container svg .line--bottom{stroke-dasharray:var(--MdsProjectionLineChart__bottomLineDashLength,2px) var(--MdsProjectionLineChart__topLineDashGap,2px);stroke:var(--MdsProjectionLineChart__lineColorBottom,#004692)}:host .projection-line-chart__svg-container svg .baseline{stroke-width:1;stroke:var(--MdsProjectionLineChart__baseLineColor,#c1c3c3)}:host .projection-line-chart__svg-container svg .x-axis{font-size:var(--MdsProjectionChart_axisWithLabel__tickLabelTextSize,.875rem);font-weight:var(--MdsProjectionChart_axisWithLabel__tickLabelTextWeight,400);line-height:var(--MdsProjectionChart_axisWithLabel__tickLabelTextLineHeight,1.25rem);color:var(--MdsProjectionLineChart_axisWithLabel__tickLabelTextColor,#565a5d)}:host .projection-line-chart__svg-container svg .y-axis{font-size:var(--MdsProjectionLineChart_axis__tickLabelTextSize,.875rem);color:var(--MdsProjectionLineChart_axis__tickLabelTextColor,#565a5d)}:host .projection-line-chart__svg-container svg .detail-marker{stroke:var(--MdsProjectionLineChart__lineColorPrimary,#005eb8);stroke-width:0;fill:var(--MdsProjectionLineChart__lineColorPrimary,#005eb8)}:host .projection-line-chart__svg-container svg .detail-marker--top{stroke:var(--MdsProjectionLineChart__lineColorTop,#0091da);fill:var(--MdsProjectionLineChart__lineColorTop,#0091da)}:host .projection-line-chart__svg-container svg .detail-marker--bottom{stroke:var(--MdsProjectionLineChart__lineColorBottom,#004692);fill:var(--MdsProjectionLineChart__lineColorBottom,#004692)}:host .projection-line-chart .mouse-line{stroke-width:var(--AbstractMdsXYChart_line__dataPointDetailLineWidth,1px);stroke:var(--AbstractMdsXYChart_line__dataPointDetailLineColor,#565a5d)}", "" ]);
            module.exports = exports;
        },
        "./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/sparkline/mds-sparkline.scss": function(module, exports, __webpack_require__) {
            var ___CSS_LOADER_API_IMPORT___ = __webpack_require__("./node_modules/css-loader/dist/runtime/api.js");
            exports = ___CSS_LOADER_API_IMPORT___(false);
            exports.push([ module.i, ":host .sparkline{width:100%;min-height:var(--MdsSparkline__minHeight,24px);max-height:var(--MdsSparkline__maxHeight,60px);min-width:var(--MdsSparkline__minWidth,40px);max-width:var(--MdsSparkline__maxWidth,240px);display:flex;justify-content:center;align-items:center}:host .sparkline__empty-text{color:var(--MdsSparkline__noDataPointTextColor,#101820);font-family:Open Sans,Helvetica Neue,helvetica,arial,sans-serif;font-weight:var(--MdsSparkline__noDataPointTextWeight,400);font-size:var(--MdsSparkline__noDataPointTextSize,.875rem);line-height:var(--MdsSparkline__noDataPointTextLineHeight,1.25rem);margin:0}:host .sparkline__accessible-text,:host .sparkline__empty-text--hidden{clip:rect(.0625rem,.0625rem,.0625rem,.0625rem);position:absolute!important;padding:0!important;border:0!important;height:.0625rem!important;width:.0625rem!important;overflow:hidden}", "" ]);
            module.exports = exports;
        },
        "./src/abstract-chart/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _tab_bar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/tab-bar/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/data-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function logCompositeError() {
                console.error("Mds charts no longer support composite elements. This includes chartTitle, accessibleAlternativeLinkText, fullScreenButon, and tabs");
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin, boolean = _mixins$AttributeMars.boolean, numberRequired = _mixins$AttributeMars.numberRequired, satisfies = _mixins$AttributeMars.satisfies, stringRequired = _mixins$AttributeMars.stringRequired, string = _mixins$AttributeMars.string;
            var entity = {
                chartTitle: string.withChangedCallback(logCompositeError),
                accessibleName: stringRequired,
                shortDescription: string,
                showFullScreenButton: boolean,
                fullScreenButtonAlternativeText: string.withChangedCallback(logCompositeError),
                tabs: satisfies(_tab_bar__WEBPACK_IMPORTED_MODULE_2__["entity"]).withChangedCallback(logCompositeError),
                accessibleAlternativeLinkText: string.withChangedCallback(logCompositeError),
                noDataPointText: string.defaultsTo("Chart temporarily unavailable."),
                chartHeight: numberRequired.withMinSize(Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["cleanCssToPx"])("200px"))
            };
            var AbstractChart = function(_AgaveComponent) {
                _inherits(AbstractChart, _AgaveComponent);
                _createClass(AbstractChart, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "AbstractChart";
                    }
                } ]);
                function AbstractChart() {
                    var _this;
                    _classCallCheck(this, AbstractChart);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractChart).call(this));
                    _this.rootClass = "abstract";
                    _this.chartVariables = {};
                    _this.defineObservedProperty("chartSize", "large");
                    _this.dispatchCustomEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])();
                    _this._resizeRerender = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["debounce"])(_this._resizeRerender.bind(_assertThisInitialized(_this)), 100);
                    window.addEventListener("resize", _this._resizeRerender);
                    return _this;
                }
                _createClass(AbstractChart, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(AbstractChart.prototype), "connectedCallback", this).call(this);
                        var rootClass = this.rootClass;
                        this._title = this.shadowRoot.querySelector(".".concat(rootClass, "__chart-title"));
                        if (this.showFullScreenButton == true) {
                            console.error("Mds charts no longer support composite elements. This includes chartTitle, accessibleAlternativeLinkText, fullScreenButon, and tabs");
                        }
                    }
                }, {
                    key: "disconnectedCallback",
                    value: function disconnectedCallback() {
                        _get(_getPrototypeOf(AbstractChart.prototype), "disconnectedCallback", this) && _get(_getPrototypeOf(AbstractChart.prototype), "disconnectedCallback", this).call(this);
                        window.removeEventListener("resize", this._resizeRerender);
                    }
                }, {
                    key: "brandChangedCallback",
                    value: function brandChangedCallback() {
                        this.renderChart && this.renderChart();
                    }
                }, {
                    key: "_resizeRerender",
                    value: function _resizeRerender() {
                        if (this.chartVariables.container) {
                            var isWidthChanged = this.chartVariables.container.offsetWidth !== this.chartVariables.width;
                            var isHeightChanged = this.chartVariables.container.offsetHeight !== this.chartVariables.height;
                            (isWidthChanged || isHeightChanged) && this.renderChart();
                        }
                    }
                }, {
                    key: "render",
                    value: function render(classOverrides) {
                        var _this2 = this, _root, _container;
                        var classes = _extends({
                            root: (_root = {}, _defineProperty(_root, "".concat(this.rootClass), true), _defineProperty(_root, "".concat(this.rootClass, "--").concat(this.chartSize), this.chartSize === true), 
                            _defineProperty(_root, "".concat(this.rootClass, "--with-line-label"), this.lines && this.lines.some(function(line) {
                                _newArrowCheck(this, _this2);
                                return line.showLineLabel;
                            }.bind(this))), _defineProperty(_root, "".concat(this.rootClass, "--with-top-border"), this.rootClass === "line-chart" && this.hideTopBorder !== true), 
                            _root),
                            container: (_container = {}, _defineProperty(_container, "".concat(this.rootClass, "__chart-container"), true), 
                            _defineProperty(_container, "".concat(this.rootClass, "__chart-container--with-legend"), this.rootClass === "line-chart" && this.showLegend), 
                            _container),
                            chartBody: _defineProperty({}, "".concat(this.rootClass, "__chart-body"), this.rootClass === "area-chart" ? this.topBorder : true)
                        }, classOverrides);
                        var idAccessibleTitle = "".concat(this.id, "-accessible-title");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.root);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.chartBody);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text", "role", "img", "aria-labelledby", idAccessibleTitle);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true", "id", idAccessibleTitle);
                        _renderArbitrary(this.accessibleName);
                        _renderArbitrary(this.shortDescription);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.container, "id", "chart-container", "aria-hidden", "true");
                        _renderArbitrary(this._isEmpty() && this._renderEmptyChart());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__svg-container"), "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(!this._isEmpty() && this.showLegend && this._renderLegend());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return AbstractChart;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a);
            __webpack_exports__["default"] = AbstractChart;
        },
        "./src/abstract-xy-chart/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "axisEntity", (function() {
                return axisEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "abstractLineEntity", (function() {
                return abstractLineEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "referenceLineEntity", (function() {
                return referenceLineEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var d3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d3");
            var d3__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(d3__WEBPACK_IMPORTED_MODULE_1__);
            var moment_timezone__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./node_modules/moment-timezone/index.js");
            var moment_timezone__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(moment_timezone__WEBPACK_IMPORTED_MODULE_2__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_3__);
            var _abstract_chart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/abstract-chart/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/data-utils.js");
            var _utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/chart-utils.js");
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _slicedToArray(arr, i) {
                return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
            }
            function _nonIterableRest() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _iterableToArrayLimit(arr, i) {
                var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
                if (null != _i) {
                    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
                    try {
                        if (_x = (_i = _i.call(arr)).next, 0 === i) {
                            if (Object(_i) !== _i) return;
                            _n = !1;
                        } else for (;!(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) ;
                    } catch (err) {
                        _d = !0, _e = err;
                    } finally {
                        try {
                            if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
                        } finally {
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
            }
            function _arrayWithHoles(arr) {
                if (Array.isArray(arr)) return arr;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_3__["mixins"].AttributeMarshallingMixin, string = _mixins$AttributeMars.string, arrayOf = _mixins$AttributeMars.arrayOf, boolean = _mixins$AttributeMars.boolean, satisfies = _mixins$AttributeMars.satisfies, number = _mixins$AttributeMars.number, object = _mixins$AttributeMars.object, enumerables = _mixins$AttributeMars.enumerables;
            var axisEntity = {
                range: arrayOf(number.or(object)),
                numTickLabels: number,
                d3TickFormatString: string,
                intervalType: enumerables(string, "interYear", "interMonth", "interDay", "intraDay", "interYearWithMonth", "custom"),
                locale: string,
                timeZone: string,
                labelStep: number,
                hideBaseline: boolean.defaultsTo(false),
                customXAxisLabels: arrayOf(string).withMinLength(2).withMaxLength(3)
            };
            var dataPointEntity = {
                x: number.or(string),
                y: number.or(string)
            };
            var abstractLineEntity = {
                isPrimary: boolean,
                lineName: string,
                showLineLabel: boolean.defaultsTo(false),
                lineStyle: enumerables(string, "solid").defaultsTo("solid"),
                showDataPointDetail: boolean.defaultsTo(false),
                dataPoints: arrayOf(satisfies(dataPointEntity))
            };
            var referenceLineEntity = {
                y: number,
                name: string
            };
            var entity = _objectSpread({}, _abstract_chart__WEBPACK_IMPORTED_MODULE_4__["entity"], {
                showYAxis: boolean.defaultsTo(true),
                xAxis: satisfies(axisEntity).withChangedCallback(),
                yAxis: satisfies(axisEntity).withChangedCallback(),
                d3DataPointDetailXFormatString: string,
                d3DataPointDetailYFormatString: string,
                referenceLines: arrayOf(satisfies(referenceLineEntity)),
                defaultDataPointDetailPosition: number.or(string)
            });
            var AbstractXYChart = function(_AbstractChart) {
                _inherits(AbstractXYChart, _AbstractChart);
                _createClass(AbstractXYChart, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "AbstractXYChart";
                    }
                } ]);
                function AbstractXYChart() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, AbstractXYChart);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(AbstractXYChart).call(this));
                    _this._getTextBoxWidth = function(textContainer) {
                        var _this3 = this;
                        var wordMultiplier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                        var letterMultiplier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
                        _newArrowCheck(this, _this2);
                        var ele = textContainer.node();
                        var elementCopy = Array.from(ele.querySelectorAll("tspan")).map(function(node) {
                            _newArrowCheck(this, _this3);
                            return node.innerHTML;
                        }.bind(this)).join(" ");
                        var elementWords = elementCopy.split(" ").length;
                        var elementLetters = elementCopy.length;
                        var defaultAccumilatorVal = elementWords * wordMultiplier + elementLetters * letterMultiplier;
                        for (var _len = arguments.length, spacingToAdd = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
                            spacingToAdd[_key - 3] = arguments[_key];
                        }
                        return textContainer.node().getComputedTextLength() + spacingToAdd.reduce(function(acc, curr) {
                            _newArrowCheck(this, _this3);
                            return acc + curr;
                        }.bind(this), defaultAccumilatorVal);
                    }.bind(this);
                    _this.rootClass = "abstract-xy-chart";
                    _extends(_this.chartVariables, {
                        cachedxAxisTicks: {},
                        cachedyAxisTicks: {}
                    });
                    _this._moveDetailOnHover = _this._moveDetailOnHover.bind(_assertThisInitialized(_this));
                    _this._getHoverContainerWidth = _this._getHoverContainerWidth.bind(_assertThisInitialized(_this));
                    _this.hoverVariables = {};
                    _this.hoverVariables.leadingPadding = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px");
                    _this.hoverVariables.trailingPadding = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px");
                    _this.hoverVariables.valueSeperation = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("8px");
                    _this.hoverVariables.WCAGWordSpacing = 1.79;
                    _this.hoverVariables.WCAGLetterSpacing = 1.44;
                    return _this;
                }
                _createClass(AbstractXYChart, [ {
                    key: "xAxisChangedCallback",
                    value: function xAxisChangedCallback(newAxisData) {
                        this.chartVariables.cachedxAxisTicks = {};
                        this.chartVariables.computedStep = 1;
                        this.chartVariables.originalNumXTicks = null;
                        if (newAxisData.locale) {
                            moment_timezone__WEBPACK_IMPORTED_MODULE_2___default.a.locale(newAxisData.locale);
                            this.renderChart();
                        }
                    }
                }, {
                    key: "linesChangedCallback",
                    value: function linesChangedCallback() {
                        var _this4 = this;
                        window.setTimeout(function() {
                            _newArrowCheck(this, _this4);
                            var initialHoverValue = this._getInitialHoverValue();
                            if (initialHoverValue !== this.hoverVariables.xValue) {
                                this.hoverVariables.xValue = initialHoverValue;
                                this._moveDetail();
                            }
                        }.bind(this));
                    }
                }, {
                    key: "yAxisChangedCallback",
                    value: function yAxisChangedCallback() {
                        this.chartVariables.cachedyAxisTicks = {};
                    }
                }, {
                    key: "_moveDetailOnHover",
                    value: function _moveDetailOnHover() {
                        var location = d3__WEBPACK_IMPORTED_MODULE_1__["mouse"](this.hoverVariables.hoverContainer.node())[0];
                        var hoverXValue = this.chartVariables.xScale.invert(location);
                        var closestPointData = this._getClosestPointData(hoverXValue);
                        if (this.hoverVariables.closestPointData && closestPointData.lineIndex === this.hoverVariables.closestPointData.lineIndex && closestPointData.closestIndex === this.hoverVariables.closestPointData.closestIndex) {
                            return;
                        }
                        this.hoverVariables.closestPointData = closestPointData;
                        this.hoverVariables.xValue = this.chartVariables.orderedLines[closestPointData.lineIndex].dataPoints[closestPointData.closestIndex].x;
                        this._moveDetail();
                    }
                }, {
                    key: "_moveDetail",
                    value: function _moveDetail() {
                        if (this.hoverVariables.hoverLine) {
                            this.hoverVariables.hoverLine.attr("transform", "translate(".concat(this.chartVariables.xScale(this.hoverVariables.xValue), ", 0)"));
                            this.chartVariables.orderedLines.forEach(this._moveCircle.bind(this));
                            this.hoverVariables.hasDataPointDetail && this._moveTextDetail();
                        }
                    }
                }, {
                    key: "_moveCircle",
                    value: function _moveCircle(line, i) {
                        var dataPoint = this._findDataPointAtXValue(line, this.hoverVariables.xValue);
                        var dataMarkerObject = this.hoverVariables.dataMarkers[i];
                        var numOfLines = this.hoverVariables.dataMarkers.length;
                        var radius = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("10px") / 2;
                        if (dataPoint && (dataPoint.y >= 0 || dataPoint.y < 0)) {
                            if (i === numOfLines - 1) {
                                dataMarkerObject.dataMarker.attr("cx", this.chartVariables.xScale(dataPoint.x)).attr("cy", this.chartVariables.yScale(dataPoint.y));
                            } else if (i === numOfLines - 2) {
                                dataMarkerObject.dataMarker.attr("x", this.chartVariables.xScale(dataPoint.x) - radius).attr("y", this.chartVariables.yScale(dataPoint.y) - radius);
                            } else if (i === numOfLines - 3) {
                                dataMarkerObject.dataMarker.attr("points", "".concat(this.chartVariables.xScale(dataPoint.x), ",").concat(this.chartVariables.yScale(dataPoint.y) - radius, " ").concat(this.chartVariables.xScale(dataPoint.x) + radius, ",").concat(this.chartVariables.yScale(dataPoint.y) + radius, " ").concat(this.chartVariables.xScale(dataPoint.x) - radius, ",").concat(this.chartVariables.yScale(dataPoint.y) + radius));
                            } else if (i === numOfLines - 4) {
                                dataMarkerObject.dataMarker.attr("points", "".concat(this.chartVariables.xScale(dataPoint.x), ",").concat(this.chartVariables.yScale(dataPoint.y) - radius, " ").concat(this.chartVariables.xScale(dataPoint.x) + radius, ",").concat(this.chartVariables.yScale(dataPoint.y), " ").concat(this.chartVariables.xScale(dataPoint.x), ",").concat(this.chartVariables.yScale(dataPoint.y) + radius, " ").concat(this.chartVariables.xScale(dataPoint.x) - radius, ",").concat(this.chartVariables.yScale(dataPoint.y)));
                            }
                            dataMarkerObject.dataMarker.style("display", "");
                            dataMarkerObject.xValue = dataPoint.x;
                            dataMarkerObject.yValue = dataPoint.y;
                        } else if (dataPoint) {
                            dataMarkerObject.dataMarker.style("display", "none");
                            dataMarkerObject.xValue = dataPoint.x;
                            dataMarkerObject.yValue = dataPoint.y;
                        } else {
                            dataMarkerObject.dataMarker.style("display", "none");
                            dataMarkerObject.xValue = "—";
                            dataMarkerObject.yValue = "—";
                        }
                    }
                }, {
                    key: "_getClosestPointData",
                    value: function _getClosestPointData(hoverXValue) {
                        var _this5 = this;
                        var points = [];
                        this.chartVariables.orderedLines.forEach(function(line, i) {
                            var _this6 = this;
                            _newArrowCheck(this, _this5);
                            var nextIndex = Math.min(d3__WEBPACK_IMPORTED_MODULE_1__["bisector"](function(d) {
                                _newArrowCheck(this, _this6);
                                return d.x;
                            }.bind(this)).left(line.dataPoints, hoverXValue), line.dataPoints.length - 1);
                            var _this$_getClosestData = this._getClosestDataPointIndex(hoverXValue, nextIndex, line.dataPoints), closestIndex = _this$_getClosestData.closestIndex, difference = _this$_getClosestData.difference;
                            points.push({
                                closestIndex: closestIndex,
                                difference: difference,
                                lineIndex: i
                            });
                        }.bind(this));
                        return points.reduce(function(minPoint, nextPoint) {
                            _newArrowCheck(this, _this5);
                            return minPoint.difference < nextPoint.difference ? minPoint : nextPoint;
                        }.bind(this), points[0]);
                    }
                }, {
                    key: "_getClosestDataPointIndex",
                    value: function _getClosestDataPointIndex(xValue, indexAbove, dataPoints) {
                        var differenceAbove = Math.abs(xValue - dataPoints[indexAbove].x);
                        var aboveReturn = {
                            closestIndex: indexAbove,
                            difference: differenceAbove
                        };
                        if (indexAbove === 0) {
                            return aboveReturn;
                        }
                        var differenceBelow = Math.abs(xValue - dataPoints[indexAbove - 1].x);
                        return differenceAbove < differenceBelow ? aboveReturn : {
                            closestIndex: indexAbove - 1,
                            difference: differenceBelow
                        };
                    }
                }, {
                    key: "_renderDetailInitial",
                    value: function _renderDetailInitial() {
                        var _this7 = this;
                        this.hoverVariables.hoverLine = this._renderHoverLine(this.hoverVariables.xValue);
                        this.hoverVariables.dataMarkers = [];
                        this.chartVariables.orderedLines.forEach(function(line, i) {
                            _newArrowCheck(this, _this7);
                            var dataPoint = this._findDataPointAtXValue(line, this.hoverVariables.xValue);
                            var yValue = dataPoint ? dataPoint.y : "—";
                            this._renderHoverCircle(line, this.hoverVariables.xValue, yValue, i, this.chartVariables.orderedLines.length);
                        }.bind(this));
                        this.hoverVariables.hasDataPointDetail && this._renderTextDetail();
                    }
                }, {
                    key: "_renderTextDetail",
                    value: function _renderTextDetail() {
                        this.hoverVariables.textDetailContainer = this.chartVariables.svg.append("g").attr("class", "text-detail-container");
                        var rectAttrs = {
                            rx: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("2px"),
                            height: this.chartVariables.detailHeight
                        };
                        var padding = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("4px");
                        var yTranslate = rectAttrs.height / 2 + padding;
                        this.hoverVariables.yTranslate = yTranslate;
                        var textAttrs = {
                            "text-anchor": "middle",
                            "font-size": "0.75rem",
                            height: "1rem",
                            "font-weight": 600
                        };
                        this.hoverVariables.textDetailBackground = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["applyAttributes"])(this.hoverVariables.textDetailContainer.append("rect"), rectAttrs);
                        this.hoverVariables.textContainer = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["applyAttributes"])(this.hoverVariables.textDetailContainer.append("text"), textAttrs);
                        var _this$hoverVariables$ = this.hoverVariables.dataMarkers[0], xValue = _this$hoverVariables$.xValue, yValue = _this$hoverVariables$.yValue;
                        var _this$_assignHoverTex = this._assignHoverTexts(xValue, yValue), xText = _this$_assignHoverTex.xText, yText = _this$_assignHoverTex.yText;
                        this.hoverVariables.xText = this.hoverVariables.textContainer.append("tspan").text(xText);
                        this.hoverVariables.yText = this.hoverVariables.textContainer.append("tspan").text(yText).attr("dx", "8");
                        var boxWidth = this._getTextBoxWidth(this.hoverVariables.textContainer, this.hoverVariables.WCAGWordSpacing, this.hoverVariables.WCAGLetterSpacing, this.hoverVariables.trailingPadding, this.hoverVariables.leadingPadding, this.hoverVariables.valueSeperation);
                        this.hoverVariables.textContainer.attr("transform", "translate(".concat(boxWidth / 2, ", ").concat(yTranslate, ")"));
                        this.hoverVariables.textDetailBackground.attr("width", boxWidth);
                        this._translateTextDetail(boxWidth, xValue);
                    }
                }, {
                    key: "_translateTextDetail",
                    value: function _translateTextDetail(boxWidth, xValue) {
                        var defaultTranslate = this.chartVariables.xScale(xValue) - boxWidth / 2;
                        var maxTranslate = this.chartVariables.width - boxWidth;
                        var minTranslate = 0;
                        var translate;
                        if (defaultTranslate > maxTranslate) {
                            translate = maxTranslate;
                        } else if (defaultTranslate < minTranslate) {
                            translate = minTranslate;
                        } else {
                            translate = defaultTranslate;
                        }
                        this.hoverVariables.textDetailContainer.attr("transform", "translate(".concat(translate, ", 0)"));
                    }
                }, {
                    key: "_assignHoverTexts",
                    value: function _assignHoverTexts(xValue, yValue) {
                        var xText = this.chartVariables.dataPointDetailXFormatter(xValue);
                        var yText = this.chartVariables.dataPointDetailYFormatter(yValue);
                        return {
                            xText: xText,
                            yText: yText
                        };
                    }
                }, {
                    key: "_moveTextDetail",
                    value: function _moveTextDetail() {
                        var _this$hoverVariables$2 = this.hoverVariables.dataMarkers[0], xValue = _this$hoverVariables$2.xValue, yValue = _this$hoverVariables$2.yValue;
                        var _this$_assignHoverTex2 = this._assignHoverTexts(xValue, yValue), xText = _this$_assignHoverTex2.xText, yText = _this$_assignHoverTex2.yText;
                        this.hoverVariables.xText.text(xText);
                        this.hoverVariables.yText.text(yText);
                        var boxWidth = this._getTextBoxWidth(this.hoverVariables.textContainer, this.hoverVariables.WCAGWordSpacing, this.hoverVariables.WCAGLetterSpacing, this.hoverVariables.trailingPadding, this.hoverVariables.leadingPadding, this.hoverVariables.valueSeperation);
                        this.hoverVariables.textDetailBackground.attr("width", boxWidth);
                        this.hoverVariables.textContainer.attr("transform", "translate(".concat(boxWidth / 2, ", ").concat(this.hoverVariables.yTranslate, ")"));
                        this._translateTextDetail(boxWidth, xValue);
                    }
                }, {
                    key: "_findDataPointAtXValue",
                    value: function _findDataPointAtXValue(line, xValue) {
                        var _this8 = this;
                        return line.dataPoints.find(function(dataPair) {
                            _newArrowCheck(this, _this8);
                            return dataPair.x === xValue;
                        }.bind(this));
                    }
                }, {
                    key: "_renderHoverLine",
                    value: function _renderHoverLine(xValue) {
                        var topTranslate = this.hoverVariables.hasDataPointDetail ? Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("2px") - this.chartVariables.marginTop : 0;
                        return this.hoverVariables.referenceLineContainer.append("line").attr("class", "detail-line").attr("transform", "translate(".concat(this.chartVariables.xScale(xValue), ", 0)")).attr("y1", topTranslate).attr("y2", this.chartVariables.height - this.chartVariables.xAxisHeight - this.chartVariables.marginTop).attr("stroke-width", Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("1px"));
                    }
                }, {
                    key: "_renderHoverCircle",
                    value: function _renderHoverCircle(line, xValue, yValue, index, noOfLines) {
                        var radius = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("10px") / 2;
                        var translateX = this.chartVariables.xScale(xValue);
                        var translateY = this.chartVariables.yScale(yValue);
                        var stroke = !line.isPrimary && line.lineColor;
                        if (index === noOfLines - 1) {
                            var dataMarker = this.hoverVariables.referenceLineContainer.append("circle").attr("r", radius).attr("cx", translateX).attr("cy", translateY).attr("fill", stroke).attr("stroke", stroke).attr("class", line.isPrimary ? "detail-marker--primary" : "detail-marker").attr("stroke-width", 0);
                            (yValue === "—" || yValue < 0) && dataMarker.style("display", "none");
                            this.hoverVariables.dataMarkers.push({
                                dataMarker: dataMarker,
                                xValue: xValue,
                                yValue: yValue,
                                index: index
                            });
                        } else if (index === noOfLines - 2) {
                            var _dataMarker = this.hoverVariables.referenceLineContainer.append("rect").attr("width", radius * 2).attr("height", radius * 2).attr("x", translateX - radius).attr("y", translateY - radius || 0).attr("fill", stroke).attr("stroke", stroke).attr("class", "detail-marker").attr("stroke-width", 0);
                            (yValue === "—" || yValue < 0) && _dataMarker.style("display", "none");
                            this.hoverVariables.dataMarkers.push({
                                dataMarker: _dataMarker,
                                xValue: xValue,
                                yValue: yValue,
                                index: index
                            });
                        } else if (index === noOfLines - 3) {
                            var _dataMarker2 = this.hoverVariables.referenceLineContainer.append("polygon").attr("fill", stroke).attr("stroke", stroke).attr("points", "".concat(translateX, ",").concat(translateY - radius, " ").concat(translateX + radius, ",").concat(translateY + radius, " ").concat(translateX - radius, ",").concat(translateY + radius)).attr("class", "detail-marker").attr("stroke-width", 0);
                            (yValue === "—" || yValue < 0) && _dataMarker2.style("display", "none");
                            this.hoverVariables.dataMarkers.push({
                                dataMarker: _dataMarker2,
                                xValue: xValue,
                                yValue: yValue,
                                index: index
                            });
                        } else if (index === noOfLines - 4) {
                            var _dataMarker3 = this.hoverVariables.referenceLineContainer.append("polygon").attr("fill", stroke).attr("stroke", stroke).attr("points", "".concat(translateX, ",").concat(translateY - radius, " ").concat(translateX + radius, ",").concat(translateY, " ").concat(translateX, ",").concat(translateY + radius, " ").concat(translateX - radius, ",").concat(translateY)).attr("class", "detail-marker").attr("stroke-width", 0);
                            (yValue === "—" || yValue < 0) && _dataMarker3.style("display", "none");
                            this.hoverVariables.dataMarkers.push({
                                dataMarker: _dataMarker3,
                                xValue: xValue,
                                yValue: yValue,
                                index: index
                            });
                        }
                    }
                }, {
                    key: "orderLinesByLastYValue",
                    value: function orderLinesByLastYValue() {
                        var _this9 = this;
                        var newLines = this.lines.slice(0);
                        var primaryIndex = newLines.findIndex(function(line) {
                            _newArrowCheck(this, _this9);
                            return line.isPrimary;
                        }.bind(this));
                        var primaryLine = newLines.splice(primaryIndex, 1)[0];
                        newLines.sort(function(firstLine, secondLine) {
                            _newArrowCheck(this, _this9);
                            var firstLineLastYValue = firstLine.dataPoints[firstLine.dataPoints.length - 1].y;
                            var secondLineLastYValue = secondLine.dataPoints[secondLine.dataPoints.length - 1].y;
                            return firstLineLastYValue - secondLineLastYValue;
                        }.bind(this));
                        newLines.push(primaryLine);
                        return newLines;
                    }
                }, {
                    key: "getXAxisFormatter",
                    value: function getXAxisFormatter() {
                        var intervalType = this.xAxis.intervalType;
                        var timeZone = this.xAxis.timeZone || "America/New_York";
                        var format;
                        if (intervalType === "interYear") {
                            format = this.curryMomentFormatter(timeZone, "YYYY");
                        } else if (intervalType === "interYearWithMonth") {
                            format = this.curryMomentFormatter(timeZone, "MMM 'YY");
                        } else if (intervalType === "interMonth") {
                            format = this.curryMomentFormatter(timeZone, "MMM", this.rangeSpansInterval(timeZone), "MMM 'YY");
                        } else if (intervalType === "interDay") {
                            format = this.curryMomentFormatter(timeZone, "D", this.rangeSpansInterval(timeZone), "D MMM");
                        } else if (intervalType === "intraDay") {
                            format = this.curryMomentFormatter(timeZone, "h", this.rangeSpansInterval(timeZone), "h A");
                        } else if (intervalType === "custom") {
                            format = this.xAxis.d3TickFormatString ? d3__WEBPACK_IMPORTED_MODULE_1__["timeFormat"](this.xAxis.d3TickFormatString) : this.throwConstraintError("The x-axis must be supplied an d3TickFormatString");
                        } else {
                            this.throwConstraintError("The x-axis must be supplied an interval type");
                        }
                        return format;
                    }
                }, {
                    key: "rangeSpansInterval",
                    value: function rangeSpansInterval(timeZone) {
                        var _this$xAxis = this.xAxis, range = _this$xAxis.range, intervalType = _this$xAxis.intervalType;
                        var startDate = moment_timezone__WEBPACK_IMPORTED_MODULE_2___default()(range[0]).tz(timeZone);
                        var endDate = moment_timezone__WEBPACK_IMPORTED_MODULE_2___default()(range[1]).tz(timeZone);
                        var type = {
                            interMonth: "year",
                            interDay: "month",
                            intraDay: "day"
                        }[intervalType];
                        var intraDaySpanning = intervalType === "intraDay" && startDate.format("A") !== endDate.format("A");
                        return intraDaySpanning || startDate[type]() !== endDate[type]();
                    }
                }, {
                    key: "curryMomentFormatter",
                    value: function curryMomentFormatter(timeZone, format) {
                        var _this10 = this;
                        var isIntervalSpanning = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                        var spanFormat = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
                        return function(date) {
                            _newArrowCheck(this, _this10);
                            var finalFormat = format;
                            var currentDate = moment_timezone__WEBPACK_IMPORTED_MODULE_2___default()(date).tz(timeZone);
                            if (isIntervalSpanning && this.isSkip(currentDate, timeZone, format)) {
                                finalFormat = spanFormat;
                            }
                            return currentDate.format(finalFormat);
                        }.bind(this);
                    }
                }, {
                    key: "isSkip",
                    value: function isSkip(currentDate, timeZone, format) {
                        var range = this.xAxis.range;
                        var labelStep = this.xAxis.labelStep || this.chartVariables.computedStep;
                        if (this.chartVariables.cachedxAxisTicks[labelStep] && this.chartVariables.cachedxAxisTicks[labelStep][0] === Number.parseInt(currentDate.format("x"))) {
                            return true;
                        }
                        var startDate = moment_timezone__WEBPACK_IMPORTED_MODULE_2___default()(range[0]).tz(timeZone);
                        var currentDateFormatted = +currentDate.format(format[0]);
                        var isBeyondStep = labelStep ? currentDateFormatted - labelStep <= 0 : currentDateFormatted === 1;
                        return startDate.isSame(currentDate) || isBeyondStep;
                    }
                }, {
                    key: "yAxisTicks",
                    value: function yAxisTicks(axis, axisData) {
                        if (axisData.numTickLabels) {
                            if (!this.chartVariables.cachedyAxisTicks[1]) {
                                this.chartVariables.cachedyAxisTicks[1] = [];
                                var maxPossibleTicks = Math.floor(this.chartVariables.yAxisHeight / this.chartVariables.tickLabelLineHeight);
                                var numTicks = Math.min(maxPossibleTicks, axisData.numTickLabels);
                                var increment = Math.abs((axisData.range[1] - axisData.range[0]) / numTicks);
                                for (var i = 0; i < numTicks; i += 1) {
                                    this.chartVariables.cachedyAxisTicks[1].push(axisData.range[0] + increment * i);
                                }
                            }
                            axis.tickValues(this.chartVariables.cachedyAxisTicks[1]);
                        }
                    }
                }, {
                    key: "interTicks",
                    value: function interTicks(axis, axisData, labelSkip, type) {
                        if (!this.chartVariables.cachedxAxisTicks[labelSkip]) {
                            var _axisData$range = _slicedToArray(axisData.range, 2), firstTimestamp = _axisData$range[0], lastTimestamp = _axisData$range[1];
                            var currentDate = moment_timezone__WEBPACK_IMPORTED_MODULE_2___default()(firstTimestamp).tz(axisData.timeZone || "America/New_York");
                            var startOfCurrentDate = moment_timezone__WEBPACK_IMPORTED_MODULE_2___default()(currentDate).startOf(type);
                            var newTimestamp = currentDate.isSame(startOfCurrentDate) ? firstTimestamp : Number.parseInt(currentDate.add(1, type).startOf(type).format("x"));
                            this.chartVariables.cachedxAxisTicks[labelSkip] = [];
                            while (+newTimestamp < +lastTimestamp) {
                                this.chartVariables.cachedxAxisTicks[labelSkip].push(newTimestamp);
                                currentDate.add(labelSkip, type);
                                newTimestamp = +currentDate.format("x");
                            }
                        }
                        axis.tickValues(this.chartVariables.cachedxAxisTicks[labelSkip]);
                    }
                }, {
                    key: "interTicksForCustomInterval",
                    value: function interTicksForCustomInterval(axis, axisData, labelSkip) {
                        this.chartVariables.cachedxAxisTicks[labelSkip] = [];
                        var _axisData$range2 = _slicedToArray(axisData.range, 2), firstTimestamp = _axisData$range2[0], lastTimestamp = _axisData$range2[1];
                        var middleTimestamp = (firstTimestamp + lastTimestamp) / 2;
                        var firstTick = moment_timezone__WEBPACK_IMPORTED_MODULE_2___default()(firstTimestamp).tz(axisData.timeZone || "America/New_York").format("x");
                        var middleTick = moment_timezone__WEBPACK_IMPORTED_MODULE_2___default()(middleTimestamp).tz(axisData.timeZone || "America/New_York").format("x");
                        var lastTick = moment_timezone__WEBPACK_IMPORTED_MODULE_2___default()(lastTimestamp).tz(axisData.timeZone || "America/New_York").format("x");
                        this.chartVariables.cachedxAxisTicks[labelSkip] = axisData.customXAxisLabels.length === 3 ? [ firstTick, middleTick, lastTick ] : [ firstTick, lastTick ];
                        axis.tickValues(this.chartVariables.cachedxAxisTicks[labelSkip]);
                    }
                }, {
                    key: "createScale",
                    value: function createScale(type) {
                        var otherAxisOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                        this.chartVariables.xAxisWidth = this.chartVariables.width - otherAxisOffset;
                        this.chartVariables.yAxisHeight = this.chartVariables.height - this.chartVariables.marginTop - otherAxisOffset;
                        var range = type === "xAxis" ? [ 0, this.chartVariables.xAxisWidth ] : [ this.chartVariables.yAxisHeight, 0 ];
                        return d3__WEBPACK_IMPORTED_MODULE_1__[type === "xAxis" ? "scaleTime" : "scaleLinear"]().domain(this[type].range).range(range);
                    }
                }, {
                    key: "renderXAxis",
                    value: function renderXAxis(labelSkip, attributes) {
                        var _this11 = this;
                        var domainAndLineOffset = 11;
                        var xAxisYTranslate = this.chartVariables.height - this.chartVariables.xAxisHeight - this.chartVariables.marginTop + domainAndLineOffset;
                        var axis = d3__WEBPACK_IMPORTED_MODULE_1__["axisBottom"](this.chartVariables.xScale);
                        var typeMapper = {
                            interYear: "years",
                            interYearWithMonth: "years",
                            interMonth: "months",
                            interDay: "days",
                            intraDay: "hours"
                        };
                        if (this.xAxis.intervalType === "custom") {
                            this.interTicksForCustomInterval(axis, this.xAxis, labelSkip);
                        } else {
                            this.interTicks(axis, this.xAxis, labelSkip, typeMapper[this.xAxis.intervalType]);
                        }
                        this.xAxis.customXAxisLabels ? axis.tickFormat(function(d, i) {
                            _newArrowCheck(this, _this11);
                            return this.xAxis.customXAxisLabels[i];
                        }.bind(this)) : axis.tickFormat(this.getXAxisFormatter());
                        var xAxis = this.chartVariables.chartArea.append("g").attr("class", "x-axis").attr("transform", "translate(0, ".concat(xAxisYTranslate, ")")).call(axis).call(function(g) {
                            _newArrowCheck(this, _this11);
                            return g.select(".domain").remove();
                        }.bind(this)).call(function(g) {
                            _newArrowCheck(this, _this11);
                            return g.selectAll("line").remove();
                        }.bind(this));
                        if (this.xAxis.intervalType === "custom") {
                            xAxis.selectAll("text").attr("text-anchor", function(_, i) {
                                _newArrowCheck(this, _this11);
                                if (i === 0) {
                                    return "start";
                                } else if (this.xAxis.customXAxisLabels && this.xAxis.customXAxisLabels.length === 3 && i === 1) {
                                    return "middle";
                                } else {
                                    return "end";
                                }
                            }.bind(this));
                        } else {
                            xAxis.selectAll("text").attr("text-anchor", "start");
                        }
                        attributes && Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["applyAttributes"])(xAxis, attributes);
                        return {
                            xAxis: xAxis,
                            xAxisYTranslate: xAxisYTranslate
                        };
                    }
                }, {
                    key: "renderYAxis",
                    value: function renderYAxis(attributes) {
                        var _this12 = this;
                        var domainAndLineOffset = 9;
                        var axis = d3__WEBPACK_IMPORTED_MODULE_1__["axisRight"](this.chartVariables.yScale);
                        this.yAxisTicks(axis, this.yAxis);
                        axis.tickFormat(Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["getFormatter"])(d3__WEBPACK_IMPORTED_MODULE_1__, this, this.yAxis.d3TickFormatString, "formatYAxis"));
                        var yAxis = this.chartVariables.chartArea.append("g").attr("class", "y-axis").attr("transform", "translate(".concat(this.chartVariables.width - domainAndLineOffset, ", 0)")).call(axis).call(function(g) {
                            _newArrowCheck(this, _this12);
                            return g.select(".domain").remove();
                        }.bind(this)).call(function(g) {
                            _newArrowCheck(this, _this12);
                            return g.selectAll("line").remove();
                        }.bind(this));
                        yAxis.selectAll("text").attr("font-size", "".concat(this.chartVariables.tickLabelFontSize, "px")).style("text-anchor", "end");
                        attributes && Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["applyAttributes"])(yAxis, attributes);
                        return yAxis;
                    }
                }, {
                    key: "renderAxes",
                    value: function renderAxes() {
                        this.chartVariables.yAxis = this.renderYAxis();
                        if (MDS.isFireFox) {
                            this.chartVariables.yAxisWidth = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["getLargestTextWidth"])(this.chartVariables.yAxis, "text");
                        } else {
                            this.chartVariables.yAxisWidth = this.chartVariables.yAxis.node().getBBox().width;
                        }
                        if (this.showYAxis) {
                            this.chartVariables.xScale = this.createScale("xAxis", this.chartVariables.yAxisWidth + this.chartVariables.yAxisMargin);
                        } else {
                            this.chartVariables.xScale = this.createScale("xAxis");
                        }
                        var _this$renderXAxis = this.renderXAxis(this.xAxis.labelStep || this.chartVariables.computedStep || 1), xAxis = _this$renderXAxis.xAxis, xAxisYTranslate = _this$renderXAxis.xAxisYTranslate;
                        var xTicks = xAxis.selectAll("text");
                        var previousNumTicks = this.chartVariables.cachedxAxisTicks[1] && this.chartVariables.cachedxAxisTicks[1].length;
                        this.chartVariables.originalNumXTicks = this.xAxis.numTickLabels && previousNumTicks || xTicks.size();
                        var numXTicks = this.chartVariables.originalNumXTicks;
                        var xTickMaxWidth = this.chartVariables.xAxisWidth / numXTicks - this.chartVariables.xAxisTickMargin;
                        var shouldAlwaysWrap = this.xAxis.intervalType === "interDay";
                        var _textWrap = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["textWrap"])(d3__WEBPACK_IMPORTED_MODULE_1__, xTicks, xTickMaxWidth, this.chartVariables.tickLabelLineHeight, "px", shouldAlwaysWrap), extraLines = _textWrap.extraLines, overflows = _textWrap.overflows;
                        if (!this.xAxis.labelStep) {
                            this.chartVariables.computedStep = 1;
                            while (overflows && numXTicks > 1 && this.chartVariables.computedStep < this.chartVariables.originalNumXTicks) {
                                ++this.chartVariables.computedStep;
                                xAxis.remove();
                                var _this$renderXAxis2 = this.renderXAxis(this.chartVariables.computedStep);
                                xAxis = _this$renderXAxis2.xAxis;
                                xAxisYTranslate = _this$renderXAxis2.xAxisYTranslate;
                                xTicks = xAxis.selectAll("text");
                                numXTicks = xTicks.size();
                                xTickMaxWidth = this.chartVariables.xAxisWidth / numXTicks - this.chartVariables.xAxisTickMargin;
                                var _textWrap2 = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["textWrap"])(d3__WEBPACK_IMPORTED_MODULE_1__, xTicks, xTickMaxWidth, this.chartVariables.tickLabelLineHeight, "px", shouldAlwaysWrap);
                                extraLines = _textWrap2.extraLines;
                                overflows = _textWrap2.overflows;
                            }
                        }
                        if (extraLines) {
                            var extraXHeight = extraLines * this.chartVariables.tickLabelLineHeight;
                            this.chartVariables.xAxisHeight = this.chartVariables.xAxisHeight + extraXHeight;
                            this.chartVariables.yScale = this.createScale("yAxis", this.chartVariables.xAxisHeight);
                            xAxis.attr("transform", "translate(0, ".concat(xAxisYTranslate - extraXHeight, ")"));
                            this.chartVariables.yAxis.remove();
                            this.chartVariables.yAxis = this.renderYAxis();
                        }
                        if (!this.showYAxis) {
                            this.chartVariables.yAxis.remove();
                        }
                    }
                }, {
                    key: "_drawLine",
                    value: function _drawLine() {
                        var _this13 = this;
                        return d3__WEBPACK_IMPORTED_MODULE_1__["line"]().x(function(d) {
                            _newArrowCheck(this, _this13);
                            return this.chartVariables.xScale(new Date(d.x));
                        }.bind(this)).y(function(d) {
                            _newArrowCheck(this, _this13);
                            return this.chartVariables.yScale(d.y);
                        }.bind(this));
                    }
                }, {
                    key: "_renderLine",
                    value: function _renderLine(lineGenerator, line, attributes) {
                        var lineSVG = this.chartVariables.chartArea.append("path").attr("fill", "none").attr("stroke", !line.isPrimary && line.lineColor).attr("stroke-width", line.isPrimary ? "2" : "1").attr("class", line.isPrimary ? "line--primary" : "line").attr("d", lineGenerator(line.dataPoints));
                        attributes && Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["applyAttributes"])(lineSVG, attributes);
                        return lineSVG;
                    }
                }, {
                    key: "_setDimensionVariables",
                    value: function _setDimensionVariables() {
                        this.chartVariables.container = this.chartVariables.container || this.shadowRoot.getElementById("chart-container");
                        this.chartVariables.width = this.chartVariables.container.offsetWidth || this._getDefaultWidth();
                        this.chartVariables.height = this.chartHeight;
                        this.chartVariables.size = this.chartVariables.width > 360 ? "large" : "small";
                    }
                }, {
                    key: "_getDefaultWidth",
                    value: function _getDefaultWidth() {
                        var padding = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px") + Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px");
                        var chartWidth = this.offsetWidth - padding;
                        return Math.max(Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("240px"), chartWidth);
                    }
                }, {
                    key: "_renderLineLabel",
                    value: function _renderLineLabel(yScale, line) {
                        if (this.chartVariables.size !== "large" || !line.showLineLabel || !this.showYAxis) {
                            return;
                        }
                        var yValue = line.dataPoints[line.dataPoints.length - 1].y;
                        var paddingRight = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("8px");
                        var width = this.chartVariables.yAxisWidth + paddingRight + 16;
                        var radius = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssValue"])("2px");
                        var height = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("1.25rem");
                        var rectAttrs = {
                            d: this._rightRoundedRect(0, 0, width, height, radius),
                            class: "line-label"
                        };
                        var halfHeight = height / 2;
                        var translateX = this.chartVariables.width - width + paddingRight;
                        var translateY = yScale(yValue) - halfHeight;
                        var padding = height - Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("0.875rem") - 1;
                        var textAttrs = {
                            "text-anchor": "end",
                            transform: "translate(".concat(width - paddingRight, ", ").concat(halfHeight + padding, ")"),
                            class: "line-label--text"
                        };
                        var group = this.chartVariables.chartArea.append("g").attr("class", "line-label-container").attr("transform", "translate(".concat(translateX, ", ").concat(translateY, ")"));
                        Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["applyAttributes"])(group.append("path"), rectAttrs);
                        var text = this.chartVariables.yFormatter(yValue);
                        Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["applyAttributes"])(group.append("text"), textAttrs).style("line-height", "1.25rem").style("font-size", "0.875rem").style("font-weight", 600).text(text);
                    }
                }, {
                    key: "_rightRoundedRect",
                    value: function _rightRoundedRect(x, y, width, height, radius) {
                        var triangleWidth = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px");
                        var widthMinusTriange = width - triangleWidth;
                        return "M".concat(x, ",").concat(y + height / 2) + "l".concat(Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px"), ",-").concat(height / 2) + "h".concat(widthMinusTriange - radius) + "a".concat(radius, " ,").concat(radius, " 0 0 1 ").concat(radius, ",").concat(radius) + "v".concat(height - 2 * radius) + "a".concat(radius, ",").concat(radius, " 0 0 1 -").concat(radius, ",").concat(radius) + "h".concat(radius - widthMinusTriange) + "z";
                    }
                }, {
                    key: "_isEmpty",
                    value: function _isEmpty() {
                        var _this14 = this;
                        return !this.lines || this.lines.length === 0 || this.lines.every(function(line) {
                            _newArrowCheck(this, _this14);
                            return line.dataPoints.length === 0;
                        }.bind(this));
                    }
                }, {
                    key: "_renderEmptyChart",
                    value: function _renderEmptyChart() {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__empty-chart"));
                        _renderArbitrary(this.noDataPointText);
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_renderReferenceLine",
                    value: function _renderReferenceLine(lineGenerator, level, attributes) {
                        var dashLength = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("4px");
                        var dashGap = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("1px");
                        var fullAttributes = _extends({
                            "stroke-dasharray": "".concat(dashLength, ", ").concat(dashGap),
                            "stroke-width": Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("1px")
                        }, attributes);
                        this._renderHorizontalLine(lineGenerator, level, fullAttributes);
                    }
                }, {
                    key: "_renderHorizontalLine",
                    value: function _renderHorizontalLine(lineGenerator, level, attributes) {
                        var line = {
                            dataPoints: [ {
                                x: this.xAxis.range[0],
                                y: level
                            }, {
                                x: this.xAxis.range[1],
                                y: level
                            } ]
                        };
                        this._renderLine(lineGenerator, line, attributes);
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback(prop) {
                        _get(_getPrototypeOf(AbstractXYChart.prototype), "renderedCallback", this) && _get(_getPrototypeOf(AbstractXYChart.prototype), "renderedCallback", this).call(this, prop);
                        var widthChanged = !this.chartVariables.container || this.chartVariables.container.offsetWidth && this.chartVariables.container.offsetWidth !== this.chartVariables.width;
                        var container = this.shadowRoot.getElementById("chart-container");
                        var isChartDataChanged = !prop || prop.match(/(lines|showYAxis|xAxis|yAxis|referenceLines|chartHeight)/);
                        if (container && (widthChanged || isChartDataChanged) && this.isConnected) {
                            this.renderChart(prop);
                        }
                    }
                }, {
                    key: "_getInitialHoverValue",
                    value: function _getInitialHoverValue() {
                        var _this15 = this;
                        if (!Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["isNonZeroFalsy"])(this.defaultDataPointDetailPosition)) {
                            return this.defaultDataPointDetailPosition;
                        }
                        var finalDataPoint = this.lines[0] ? this.lines[0].dataPoints[this.lines[0].dataPoints.length - 1] : 0;
                        return this.lines.reduce(function(largestValue, newLine) {
                            _newArrowCheck(this, _this15);
                            var lastX = newLine.dataPoints[newLine.dataPoints.length - 1].x;
                            return lastX > largestValue ? lastX : largestValue;
                        }.bind(this), finalDataPoint.x);
                    }
                }, {
                    key: "_getHoverContainerWidth",
                    value: function _getHoverContainerWidth() {
                        if (this.showYAxis) {
                            return this.chartVariables.width - this.chartVariables.yAxisWidth - this.chartVariables.yAxisMargin;
                        } else {
                            return this.chartVariables.width;
                        }
                    }
                }, {
                    key: "renderChart",
                    value: function renderChart() {
                        if (this._isEmpty()) {
                            return;
                        } else if (!this.hasAlreadyRunRender) {
                            this.hasAlreadyRunRender = true;
                            window.setTimeout(this.renderChart.bind(this));
                            return;
                        }
                        try {
                            this._setDimensionVariables();
                        } catch (error) {
                            return "";
                        }
                        this.hoverVariables.hasDataPointDetail = !this.showLegend && this.lines.length === 1 && this.lines[0].showDataPointDetail;
                        this.chartVariables.detailHeight = this.hoverVariables.hasDataPointDetail ? this.chartVariables.detailHeightTokens : 0;
                        this.chartVariables.marginTop = this.chartVariables.detailHeight;
                        this.chartVariables.xAxisHeight = this.chartVariables.xAxisMargin + this.chartVariables.tickLabelFontSize;
                        this.chartVariables.yScale = this.createScale("yAxis", this.chartVariables.xAxisHeight);
                        this.chartVariables.xFormatter = this.getXAxisFormatter();
                        this.chartVariables.yFormatter = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["getFormatter"])(d3__WEBPACK_IMPORTED_MODULE_1__, this, this.yAxis.d3TickFormatString, "formatYAxis");
                        this.chartVariables.dataPointDetailXFormatter = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["getFormatter"])(d3__WEBPACK_IMPORTED_MODULE_1__, this, this.d3DataPointDetailXFormatString, "formatDataPointDetailX", this.xAxis.d3TickFormatString, true);
                        this.chartVariables.dataPointDetailYFormatter = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["getFormatter"])(d3__WEBPACK_IMPORTED_MODULE_1__, this, this.d3DataPointDetailYFormatString, "formatDataPointDetailY", this.yAxis.d3TickFormatString);
                        this.chartVariables.svg && this.chartVariables.svg.remove();
                        var svgContainer = this.shadowRoot.querySelector(".".concat(this.rootClass, "__svg-container"));
                        this.chartVariables.svg = d3__WEBPACK_IMPORTED_MODULE_1__["select"](svgContainer).append("svg").attr("width", this.chartVariables.width).attr("height", this.chartVariables.height);
                        this.chartVariables.chartArea = this.chartVariables.svg.append("g").attr("class", "chart-container").attr("transform", "translate(0, ".concat(this.chartVariables.marginTop, ")"));
                        this.renderAxes();
                        Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["colorNegativeAxisTicks"])(d3__WEBPACK_IMPORTED_MODULE_1__, this.chartVariables.yAxis);
                        this._renderChartCb && this._renderChartCb();
                        this._renderLineLabel(this.chartVariables.yScale, this.chartVariables.orderedLines[this.chartVariables.orderedLines.length - 1]);
                        this.hoverVariables.referenceLineContainer = this.chartVariables.chartArea.append("g");
                        this.hoverVariables.hoverContainer = this.chartVariables.chartArea.append("rect").attr("class", "hoverContainer").attr("height", this.chartVariables.height - this.chartVariables.marginTop - this.chartVariables.xAxisHeight).attr("width", this._getHoverContainerWidth).attr("fill", "none").style("pointer-events", "all").on("mousemove", this._moveDetailOnHover).on("touchmove", this._moveDetailOnHover);
                        this.hoverVariables.xValue = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["isNonZeroFalsy"])(this.hoverVariables.xValue) ? this._getInitialHoverValue() : this.hoverVariables.xValue;
                        this._renderDetailInitial();
                        this.chartSize = this.chartVariables.size;
                    }
                } ]);
                return AbstractXYChart;
            }(_abstract_chart__WEBPACK_IMPORTED_MODULE_4__["default"]);
            __webpack_exports__["default"] = AbstractXYChart;
        },
        "./src/area-chart/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "lineEntity", (function() {
                return lineEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var d3__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d3");
            var d3__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(d3__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_area_chart_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/area-chart/mds-area-chart.scss");
            var _mds_area_chart_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_area_chart_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _abstract_xy_chart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-xy-chart/index.jsx");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/data-utils.js");
            var _utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/chart-utils.js");
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _slicedToArray(arr, i) {
                return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
            }
            function _nonIterableRest() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _iterableToArrayLimit(arr, i) {
                var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
                if (null != _i) {
                    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
                    try {
                        if (_x = (_i = _i.call(arr)).next, 0 === i) {
                            if (Object(_i) !== _i) return;
                            _n = !1;
                        } else for (;!(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) ;
                    } catch (err) {
                        _d = !0, _e = err;
                    } finally {
                        try {
                            if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
                        } finally {
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
            }
            function _arrayWithHoles(arr) {
                if (Array.isArray(arr)) return arr;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin, string = _mixins$AttributeMars.string, boolean = _mixins$AttributeMars.boolean, arrayOf = _mixins$AttributeMars.arrayOf, satisfies = _mixins$AttributeMars.satisfies;
            var lineEntity = _objectSpread({}, _abstract_xy_chart__WEBPACK_IMPORTED_MODULE_3__["abstractLineEntity"], {
                color: string
            });
            var entity = _objectSpread({}, _abstract_xy_chart__WEBPACK_IMPORTED_MODULE_3__["entity"], {
                lines: arrayOf(satisfies(lineEntity)).withChangedCallback(),
                topBorder: boolean.defaultsTo(true),
                baseline: boolean.defaultsTo(false)
            });
            var tokens = {
                tickLabelLineHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["cleanCssToPx"])("1.25rem"),
                tickLabelFontSize: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["cleanCssToPx"])("0.875rem"),
                yAxisMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["cleanCssToPx"])("16px"),
                xAxisMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["cleanCssToPx"])("4px"),
                xAxisTickMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["cleanCssToPx"])("16px"),
                detailHeightTokens: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["cleanCssToPx"])("1rem") + Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["cleanCssToPx"])("4px") + Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_4__["cleanCssToPx"])("4px")
            };
            var MdsAreaChart = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractXYChart) {
                _inherits(MdsAreaChart, _AbstractXYChart);
                _createClass(MdsAreaChart, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsAreaChart";
                    }
                } ]);
                function MdsAreaChart() {
                    var _this;
                    _classCallCheck(this, MdsAreaChart);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsAreaChart).call(this));
                    _this.rootClass = "area-chart";
                    _extends(_this.chartVariables, tokens);
                    _this.ieColors = {
                        cpo: _this._hexToRgba("#126bc5", .35),
                        jpo: _this._hexToRgba("#126bc5", .28),
                        cpc: _this._hexToRgba("#126bc5", .35),
                        cmb: _this._hexToRgba("#005eb8", .35),
                        jmb: _this._hexToRgba("#005eb8", .35),
                        bcb: _this._hexToRgba("#126bc5", .35)
                    };
                    _this.tokens = {
                        cpo: {
                            start: "#126bc5",
                            end: "#126bc5"
                        },
                        jpo: {
                            start: "#126bc5",
                            end: "#1570a3"
                        },
                        cpc: {
                            start: "#126bc5",
                            end: "#126bc5"
                        },
                        cmb: {
                            start: "#005eb8",
                            end: "#005eb8"
                        },
                        jmb: {
                            start: "#005eb8",
                            end: "#005eb8"
                        },
                        bcb: {
                            start: "#126bc5",
                            end: "#126bc5"
                        }
                    };
                    return _this;
                }
                _createClass(MdsAreaChart, [ {
                    key: "_drawArea",
                    value: function _drawArea() {
                        var _this2 = this;
                        return d3__WEBPACK_IMPORTED_MODULE_0__["area"]().x(function(d) {
                            _newArrowCheck(this, _this2);
                            return this.chartVariables.xScale(new Date(d.x));
                        }.bind(this)).y0(function(d) {
                            _newArrowCheck(this, _this2);
                            return this.chartVariables.yScale(0);
                        }.bind(this)).y1(function(d) {
                            _newArrowCheck(this, _this2);
                            return this.chartVariables.yScale(d.y);
                        }.bind(this));
                    }
                }, {
                    key: "_renderArea",
                    value: function _renderArea(areaGenerator, line, attributes) {
                        var _this3 = this;
                        var colors = [ "".concat(this._addOpacity(this.tokens[MDS.brand || "cmb"].start, 0)), "".concat(this._addOpacity(this.tokens[MDS.brand || "cmb"].end, .35)) ];
                        var areaSVG = this.chartVariables.chartArea.append("path").attr("class", "area").style("fill", "url(#linear-gradient)").attr("d", areaGenerator(line.dataPoints));
                        attributes && Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["applyAttributes"])(areaSVG, attributes);
                        var gradientVector = this._calculateVector(0);
                        var linearGradient = this.chartVariables.chartArea.append("defs").append("linearGradient").attr("id", "linear-gradient").attr("x1", gradientVector.x1).attr("y1", gradientVector.y1).attr("x2", gradientVector.x2).attr("y2", gradientVector.y2);
                        var negDataSet = this.chartVariables.orderedLines[0].dataPoints.filter(function(value) {
                            _newArrowCheck(this, _this3);
                            return value.y < 0;
                        }.bind(this));
                        if (negDataSet.length == 0) {
                            linearGradient.append("stop").attr("offset", "0%").attr("stop-color", colors[0]);
                            linearGradient.append("stop").attr("offset", "100%").attr("stop-color", colors[1]);
                        } else {
                            var minPoint = Number.MAX_SAFE_INTEGER;
                            var maxPoint = Number.MIN_SAFE_INTEGER;
                            this.chartVariables.orderedLines[0].dataPoints.forEach(function(value) {
                                _newArrowCheck(this, _this3);
                                minPoint = Math.min(value.y, minPoint);
                                maxPoint = Math.max(value.y, maxPoint);
                            }.bind(this));
                            var totalDistance = Math.abs(minPoint) + maxPoint;
                            var distanceFromZero = Math.abs(minPoint) / totalDistance * 100;
                            linearGradient.append("stop").attr("offset", "0%").attr("stop-color", colors[1]);
                            linearGradient.append("stop").attr("offset", "".concat(distanceFromZero, "%")).attr("stop-color", colors[0]);
                            linearGradient.append("stop").attr("offset", "100%").attr("stop-color", colors[1]);
                        }
                        return areaSVG;
                    }
                }, {
                    key: "_convertOpacityToHexAlpha",
                    value: function _convertOpacityToHexAlpha(opacity) {
                        opacity = Math.round(opacity * 100) / 100;
                        var alpha = Math.round(opacity * 255);
                        var hexAlpha = (alpha + 65536).toString(16).substr(-2).toUpperCase();
                        return hexAlpha;
                    }
                }, {
                    key: "_hexParser",
                    value: function _hexParser(hex, regex, size) {
                        var length = hex.length - size + 1;
                        var hexOutput = [];
                        for (var i = 0; i < hex.length; i++) {
                            if (i === 0) {
                                hexOutput.push(hex);
                            } else {
                                hexOutput.push(hex.slice(i, i + size));
                                i += size - 1;
                            }
                        }
                        return regex.test(hex) && hexOutput;
                    }
                }, {
                    key: "_hexToRgba",
                    value: function _hexToRgba(hex, opacity) {
                        var cleanedHex = this._hexParser(hex, /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i, 2);
                        var color = cleanedHex ? {
                            r: parseInt(cleanedHex[1], 16),
                            g: parseInt(cleanedHex[2], 16),
                            b: parseInt(cleanedHex[3], 16),
                            a: Math.round(opacity * 100) / 100
                        } : null;
                        return "rgba(".concat(color.r, ", ").concat(color.g, ", ").concat(color.b, ", ").concat(color.a, ")");
                    }
                }, {
                    key: "_addOpacity",
                    value: function _addOpacity(hexColor, opacity) {
                        return "".concat(hexColor).concat(this._convertOpacityToHexAlpha(opacity));
                    }
                }, {
                    key: "_calculateVector",
                    value: function _calculateVector(angle) {
                        angle = Math.PI / 180;
                        return {
                            x1: "".concat(Math.abs(parseFloat(Math.sin(angle)) * 100), "%"),
                            y1: "".concat(Math.abs(parseFloat(Math.cos(angle)) * 100), "%"),
                            x2: "0%",
                            y2: "0%"
                        };
                    }
                }, {
                    key: "_renderChartCb",
                    value: function _renderChartCb() {
                        var _this4 = this;
                        var lineGen = this._drawLine();
                        var areaGen = this._drawArea();
                        var _this$chartVariables$ = this.chartVariables.yScale.domain(), _this$chartVariables$2 = _slicedToArray(_this$chartVariables$, 2), y0 = _this$chartVariables$2[0], y1 = _this$chartVariables$2[1];
                        (y0 <= 0 && y1 >= 0 || this.baseline) && this._renderHorizontalLine(lineGen, 0, {
                            class: "baseline"
                        });
                        this.chartVariables.chartArea.append("clipPath").attr("id", "clipped-path").append("rect").attr("x", 0).attr("y", 0).attr("height", this.chartVariables.height - this.chartVariables.marginTop - this.chartVariables.xAxisHeight).attr("width", this.chartVariables.width - this.chartVariables.marginTop * 1.5);
                        this.chartVariables.orderedLines = this.orderLinesByLastYValue();
                        this.chartVariables.orderedLines.forEach(function(line) {
                            _newArrowCheck(this, _this4);
                            this._renderLine(lineGen, line, {
                                "clip-path": "url(#clipped-path)"
                            });
                            this._renderArea(areaGen, line, {
                                "clip-path": "url(#clipped-path)"
                            });
                        }.bind(this));
                        this.referenceLines && this.referenceLines.forEach(function(lineVal) {
                            _newArrowCheck(this, _this4);
                            return this._renderReferenceLine(lineGen, lineVal.y, {
                                class: "reference-line"
                            });
                        }.bind(this));
                    }
                }, {
                    key: "renderChart",
                    value: function renderChart() {
                        if (this._isEmpty()) {
                            return;
                        }
                        _get(_getPrototypeOf(MdsAreaChart.prototype), "renderChart", this).call(this);
                    }
                } ]);
                return MdsAreaChart;
            }(_abstract_xy_chart__WEBPACK_IMPORTED_MODULE_3__["default"]), _class2.styles = _mds_area_chart_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsAreaChart;
        },
        "./src/area-chart/mds-area-chart.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/area-chart/mds-area-chart.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/bar-chart-segmented/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_bar_chart_segmented_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/bar-chart-segmented/mds-bar-chart-segmented.scss");
            var _mds_bar_chart_segmented_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_bar_chart_segmented_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _dec, _class, _class2;
            var _accessibleText$wrapper = function _accessibleText$wrapper(_this$accessibleName, _this$accessibleDescr) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text", "role", "img", "aria-labelledby", "segmented-accessible-title");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true", "id", "segmented-accessible-title");
                _renderArbitrary(_this$accessibleName);
                _renderArbitrary(_this$accessibleDescr);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            };
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin, boolean = _mixins$AttributeMars.boolean, string = _mixins$AttributeMars.string, number = _mixins$AttributeMars.number, arrayOf = _mixins$AttributeMars.arrayOf, satisfies = _mixins$AttributeMars.satisfies, enumerables = _mixins$AttributeMars.enumerables, stringRequired = _mixins$AttributeMars.stringRequired;
            var segmentEntity = {
                value: number.withMinSize(0),
                color: stringRequired
            };
            var entity = {
                size: enumerables(string, "small", "medium", "large").defaultsTo("medium"),
                accessibleDescription: string,
                accessibleName: stringRequired,
                interactive: boolean.defaultsTo(true),
                sortSegments: boolean.defaultsTo(false),
                noDataPointText: string,
                segments: arrayOf(satisfies(segmentEntity))
            };
            var MdsBarChartSegmented = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsBarChartSegmented, _AgaveComponent);
                _createClass(MdsBarChartSegmented, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsBarChartSegmented";
                    }
                } ]);
                function MdsBarChartSegmented() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsBarChartSegmented);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsBarChartSegmented).call(this));
                    _this._handleClick = _this._handleClick.bind(_assertThisInitialized(_this));
                    _this._handleMouseOver = _this._handleMouseOver.bind(_assertThisInitialized(_this));
                    _this._handleMouseOut = _this._handleMouseOut.bind(_assertThisInitialized(_this));
                    _this._onfocus = _this._onfocus.bind(_assertThisInitialized(_this));
                    _this._onblur = _this._onblur.bind(_assertThisInitialized(_this));
                    _this._dispatchMouseOverEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "mouseover-segment";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._dispatchMouseOutEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "mouseout-segment";
                    }.bind(this), _assertThisInitialized(_this));
                    _this._dispatchClickEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "click-segment";
                    }.bind(this), _assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsBarChartSegmented, [ {
                    key: "_formatSegmentValue",
                    value: function _formatSegmentValue(val) {
                        return val.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0];
                    }
                }, {
                    key: "_renderSegments",
                    value: function _renderSegments() {
                        var _this3 = this;
                        var segmentClasses = _defineProperty({
                            "segmented-chart__segment": true
                        }, "segmented-chart__segment--".concat(this.size), true);
                        var segmentNonInteractive = _defineProperty({
                            "segmented-chart__segment-non-interact": true
                        }, "segmented-chart__segment-non-interact--".concat(this.size), true);
                        var total = this.segments.reduce(function(sum, segment) {
                            _newArrowCheck(this, _this3);
                            return sum += segment.value;
                        }.bind(this), 0);
                        this.sortSegments && this.segments.sort(function(a, b) {
                            _newArrowCheck(this, _this3);
                            return b.value - a.value;
                        }.bind(this));
                        return this.segments.map(function(segment, i) {
                            _newArrowCheck(this, _this3);
                            var segmentStyles = {
                                width: "".concat(this._formatSegmentValue(segment.value / total * 100), "%"),
                                "background-color": segment.color
                            };
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "segment".concat(i + 1));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("data-index", i);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", this.interactive ? segmentClasses : segmentNonInteractive);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("style", _objectSpread({}, segmentStyles));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onmouseover", this._handleMouseOver);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onfocus", this._onfocus);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onmouseout", this._handleMouseOut);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("onblur", this._onblur);
                            _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                                onclick: this._handleClick
                            }, this.interactive));
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        }.bind(this));
                    }
                }, {
                    key: "_handleClick",
                    value: function _handleClick(event) {
                        event.stopPropagation();
                        this._dispatchClickEvent(event, _extends({}, event.detail, {
                            index: event.target.dataset.index
                        }));
                    }
                }, {
                    key: "_handleMouseOver",
                    value: function _handleMouseOver(event) {
                        event.stopPropagation();
                        this._dispatchMouseOverEvent(event, _extends({}, event.detail, {
                            index: event.target.dataset.index
                        }));
                    }
                }, {
                    key: "_handleMouseOut",
                    value: function _handleMouseOut(event) {
                        event.stopPropagation();
                        this._dispatchMouseOutEvent(event, _extends({}, event.detail, {
                            index: event.target.dataset.index
                        }));
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _accessibleText = _jsxWrapper(_accessibleText$wrapper, [ this.accessibleName, this.accessibleDescription ]);
                        if (this.segments && this.segments.length > 0) {
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div");
                            _renderArbitrary(_accessibleText);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "segmented-chart");
                            _renderArbitrary(this._renderSegments());
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "segmented-chart");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "segmented-chart__nodata");
                        _renderArbitrary(_accessibleText);
                        _renderArbitrary(this.noDataPointText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsBarChartSegmented;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_bar_chart_segmented_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsBarChartSegmented;
        },
        "./src/bar-chart-segmented/mds-bar-chart-segmented.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/bar-chart-segmented/mds-bar-chart-segmented.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/bar-chart-selectable/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "axisEntity", (function() {
                return axisEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "axisLabelEntity", (function() {
                return axisLabelEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "legendEntity", (function() {
                return legendEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "seriesEntity", (function() {
                return seriesEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "referenceLineEntity", (function() {
                return referenceLineEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var d3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d3");
            var d3__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(d3__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_2__);
            var _mds_bar_chart_selectable_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/bar-chart-selectable/mds-bar-chart-selectable.scss");
            var _mds_bar_chart_selectable_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_bar_chart_selectable_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _abstract_chart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/abstract-chart/index.jsx");
            var _utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/chart-utils.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/data-utils.js");
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            var _div$wrapper = function _div$wrapper(_class3, _deferred, _args) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", _class3);
                _renderArbitrary(_deferred.map(_args));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _slicedToArray(arr, i) {
                return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
            }
            function _nonIterableRest() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _iterableToArrayLimit(arr, i) {
                var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
                if (null != _i) {
                    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
                    try {
                        if (_x = (_i = _i.call(arr)).next, 0 === i) {
                            if (Object(_i) !== _i) return;
                            _n = !1;
                        } else for (;!(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) ;
                    } catch (err) {
                        _d = !0, _e = err;
                    } finally {
                        try {
                            if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
                        } finally {
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
            }
            function _arrayWithHoles(arr) {
                if (Array.isArray(arr)) return arr;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_2__["mixins"].AttributeMarshallingMixin, enumerables = _mixins$AttributeMars.enumerables, string = _mixins$AttributeMars.string, number = _mixins$AttributeMars.number, arrayOf = _mixins$AttributeMars.arrayOf, satisfies = _mixins$AttributeMars.satisfies, boolean = _mixins$AttributeMars.boolean;
            var axisEntity = {
                numTickLabels: number,
                range: arrayOf(number).withMinLength(2).withMaxLength(2),
                d3TickFormatString: string
            };
            var axisLabelEntity = {
                axisLabel: string,
                legendLabel: string
            };
            var legendEntity = {
                itemsPerRow: arrayOf(number).withMinLength(2).withMaxLength(5)
            };
            var seriesEntity = {
                bars: arrayOf(number).withMaxLength(12),
                color: string,
                legendLabel: string
            };
            var referenceLineEntity = {
                label: string,
                value: number
            };
            var entity = _objectSpread({}, _abstract_chart__WEBPACK_IMPORTED_MODULE_4__["entity"], {
                series: arrayOf(satisfies(seriesEntity)).withMinLength(1).withMaxLength(4),
                xAxisLabels: arrayOf(satisfies(axisLabelEntity)).withMinLength(1).withMaxLength(12),
                yAxis: satisfies(axisEntity),
                d3BarLabelFormatString: string,
                referenceLine: satisfies(referenceLineEntity),
                selectedBar: number,
                legend: satisfies(legendEntity),
                unselectedBarColor: string,
                selectedBarColor: string,
                variant: enumerables(string, "regular", "barValue", "groupedBars").defaultsTo("regular").withChangedCallback(),
                barWidth: enumerables(number, 8, 16, 24, 32, 48, 64).defaultsTo(32),
                backgroundColor: boolean.defaultsTo(false)
            });
            var tokens = {
                barWidth: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("32px"),
                barWidthSevenOrMore: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("16px"),
                barWidthDesktop: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("32px"),
                chartMinHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("200px"),
                chartMinWidth: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("240px"),
                seriesInterGroupMinPadding: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("8px"),
                seriesStackedBarInterStackPadding: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("1px"),
                selectedBarXAxisLabelTextWeight: 600,
                xAxisTextWeight: 400,
                xAxisTextLineHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("1.25rem"),
                xAxisLabelHorizontalMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("4px"),
                yAxisTopPadding: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("20px"),
                yAxisWidth: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("40px")
            };
            var MdsBarChartSelectable = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_2__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractChart) {
                _inherits(MdsBarChartSelectable, _AbstractChart);
                _createClass(MdsBarChartSelectable, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsBarChartSelectable";
                    }
                } ]);
                function MdsBarChartSelectable(props) {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsBarChartSelectable);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsBarChartSelectable).call(this, props));
                    _this._formatGroupedVariantData = function(series) {
                        var _this3 = this;
                        _newArrowCheck(this, _this2);
                        if (series.length !== 2) return;
                        var whichSeriesIndexToUse = 0;
                        var dataBarSetsAreNotSameLength = series[0].bars.length !== series[1].bars.length;
                        if (dataBarSetsAreNotSameLength) {
                            whichSeriesIndexToUse = series[0].bars.length > series[1].bars.length ? whichSeriesIndexToUse : 1;
                        }
                        var formattedDataSets = series[whichSeriesIndexToUse].bars.reduce(function(acc, curr, idx) {
                            _newArrowCheck(this, _this3);
                            var bars = [ series[0].bars[idx] || 0, series[1].bars[idx] || 0 ];
                            var colors = [ series[0].color, series[1].color ];
                            var selectedBarColors = [ series[0].selectedBarColor, series[1].selectedBarColor ];
                            var dataSet = {
                                bars: bars,
                                colors: colors,
                                selectedBarColors: selectedBarColors
                            };
                            acc.push(dataSet);
                            return acc;
                        }.bind(this), []);
                        _this.formattedSeries = formattedDataSets;
                        return formattedDataSets;
                    }.bind(this);
                    _this._renderGroupedBarsSeries = function(series, seriesIndex) {
                        var _this4 = this;
                        _newArrowCheck(this, _this2);
                        var _assertThisInitialize = _assertThisInitialized(_this), selectedGroupIndex = _assertThisInitialize.selectedBar, barWidth = _assertThisInitialize.barWidth, _assertThisInitialize2 = _assertThisInitialize.chartVariables, svg = _assertThisInitialize2.svg, xScale = _assertThisInitialize2.xScale, yScale = _assertThisInitialize2.yScale, yAxisTopPadding = _assertThisInitialize2.yAxisTopPadding, defaultBarWidth = _assertThisInitialize.defaultBarWidth;
                        var seriesSVG = svg.append("g").attr("id", "gropued-series-".concat(seriesIndex)).attr("transform", "translate(".concat(xScale(series.labels.axisLabel), ", 0)"));
                        var barSubGroup = seriesSVG.selectAll("rect").data(series.bars).join("rect").attr("width", function() {
                            _newArrowCheck(this, _this4);
                            return barWidth;
                        }.bind(this)).attr("height", function(bar) {
                            _newArrowCheck(this, _this4);
                            return _this._calculateBarHeight(yScale, bar);
                        }.bind(this)).attr("x", function(bar, idx) {
                            _newArrowCheck(this, _this4);
                            return idx === 0 ? xScale.bandwidth() / 2 - barWidth : xScale.bandwidth() / 2 + 1;
                        }.bind(this)).attr("y", function(bar) {
                            _newArrowCheck(this, _this4);
                            return yScale(bar) + yAxisTopPadding;
                        }.bind(this)).attr("fill", function(bar, idx) {
                            _newArrowCheck(this, _this4);
                            return series.colors[idx];
                        }.bind(this));
                        var shouldSetSelecectedBarColors = Array.isArray(series.selectedBarColors) && series.selectedBarColors.length === 2;
                        if (shouldSetSelecectedBarColors) {
                            barSubGroup.attr("fill", function(bar, idx) {
                                _newArrowCheck(this, _this4);
                                return seriesIndex === selectedGroupIndex ? series.selectedBarColors[idx] : series.colors[idx];
                            }.bind(this));
                        }
                    }.bind(this);
                    _this._calculateBarHeight = function(scale) {
                        var barVal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
                        _newArrowCheck(this, _this2);
                        var isZeroOrNegativeVal = barVal < 0;
                        return isZeroOrNegativeVal ? 0 : Math.abs(scale(0) - scale(barVal));
                    }.bind(this);
                    _this._renderSeries = function(series, seriesIndex) {
                        var _this5 = this;
                        _newArrowCheck(this, _this2);
                        var isMultiSeries = _this.series.length > 1;
                        var barWidthForScreenSize = _this._getBarWidth(seriesIndex);
                        var seriesSVG = _this.chartVariables.svg.append("g").attr("id", "series-".concat(seriesIndex));
                        var seriesData = [];
                        var bars = seriesSVG.selectAll("rect").data(series.bars.map(function(bar) {
                            _newArrowCheck(this, _this5);
                            return {
                                val: bar
                            };
                        }.bind(this))).enter().append("g");
                        bars.append("rect").attr("id", function(bar, i) {
                            _newArrowCheck(this, _this5);
                            return _this._isSelectedBar(i) ? "series-".concat(seriesIndex, "-bar-").concat(i, "--selected") : "series-".concat(seriesIndex, "-bar-").concat(i);
                        }.bind(this)).attr("class", function(bar, i) {
                            _newArrowCheck(this, _this5);
                            return _this._getBarClass(i, isMultiSeries);
                        }.bind(this)).attr("x", function(bar, i) {
                            _newArrowCheck(this, _this5);
                            return _this._generateBarXOffset(seriesIndex, i);
                        }.bind(this)).attr("y", function(bar, i) {
                            _newArrowCheck(this, _this5);
                            return _this._generateYOffset(bar.val, i, seriesIndex);
                        }.bind(this)).attr("height", function(bar) {
                            _newArrowCheck(this, _this5);
                            return _this._calculateBarHeight(_this.chartVariables.yScale, bar.val);
                        }.bind(this)).attr("width", function(bar, i) {
                            _newArrowCheck(this, _this5);
                            return _this.barWidth;
                        }.bind(this)).attr("fill", function(bar, i) {
                            _newArrowCheck(this, _this5);
                            return isMultiSeries && _this._isSelectedBar(i) ? series.color : "";
                        }.bind(this)).attr("style", function(bar, i) {
                            _newArrowCheck(this, _this5);
                            return !isMultiSeries && _this._setCustomBarColor(i, isMultiSeries);
                        }.bind(this)).each((function(bar) {
                            bar.barHeight = this.getBBox().height;
                        }));
                        if (_this.isBarValueVariant && !isMultiSeries) {
                            _this._addBarLabels(bars, seriesIndex, barWidthForScreenSize, seriesData);
                        }
                    }.bind(this);
                    _this._getBarWidth = function() {
                        _newArrowCheck(this, _this2);
                        return _this.barWidth;
                    }.bind(this);
                    _this._getRegionWidth = function(variant) {
                        _newArrowCheck(this, _this2);
                        return variant === "groupedBars" ? _this.chartVariables.xScale.bandwidth() : (_this.chartVariables.width - _this.chartVariables.yAxisWidth) / _this.series[0].bars.length;
                    }.bind(this);
                    _this._handleClick = function(e) {
                        var _this6 = this;
                        _newArrowCheck(this, _this2);
                        _this.selectedBar = Number(d3__WEBPACK_IMPORTED_MODULE_1__["event"].target.id.match(/(\d+)/)[0]);
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_6__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this6);
                            return "selection";
                        }.bind(this), _assertThisInitialized(_this))(e, _extends({}, {
                            selectedBar: _this.selectedBar
                        }));
                    }.bind(this);
                    _this._addSelectedBarIndicator = function() {
                        var _this7 = this;
                        _newArrowCheck(this, _this2);
                        var _this$chartVariables = _this.chartVariables, xScale = _this$chartVariables.xScale, yScale = _this$chartVariables.yScale, svg = _this$chartVariables.svg, yAxisTopPadding = _this$chartVariables.yAxisTopPadding, seriesInterGroupMinPadding = _this$chartVariables.seriesInterGroupMinPadding;
                        var width = (_this.chartVariables.width - _this.chartVariables.yAxisWidth) / _this.series[0].bars.length;
                        svg.append("rect").attr("class", "selected-bar-indicator").attr("width", function() {
                            _newArrowCheck(this, _this7);
                            return _this.isGroupedBarsVariant ? xScale.bandwidth() : width;
                        }.bind(this)).attr("y", yScale(0) + yAxisTopPadding - 1).attr("x", function() {
                            _newArrowCheck(this, _this7);
                            return _this._generateRegionXOffset(_this.selectedBar);
                        }.bind(this));
                    }.bind(this);
                    _this._setInitalSelectedBar = function(series) {
                        _newArrowCheck(this, _this2);
                        return series[0].bars.length - 1;
                    }.bind(this);
                    _this.rootClass = "bar-chart-selectable";
                    _extends(_this.chartVariables, tokens);
                    _this.defaultBarWidth = 32;
                    _this.maxBarWith = 64;
                    return _this;
                }
                _createClass(MdsBarChartSelectable, [ {
                    key: "renderChart",
                    value: function renderChart() {
                        var _this8 = this;
                        if (this._isEmpty()) {
                            return;
                        }
                        this.isGroupedBarsVariant && this._formatGroupedVariantData(this.series);
                        this.isMultiSeries = this.series.length > 1;
                        this._setDimensionVariables();
                        this._createSVG();
                        this._addAxes(this.series[0].bars.map(function(b, idx) {
                            _newArrowCheck(this, _this8);
                            return "bar-".concat(idx);
                        }.bind(this)));
                        this._addBars();
                        this._addBaseline();
                        this._addSelectedBarIndicator();
                        this.referenceLine && this._addReferenceLine(this.referenceLine.value);
                    }
                }, {
                    key: "_setDimensionVariables",
                    value: function _setDimensionVariables() {
                        var _this$chartVariables2 = this.chartVariables, chartMinHeight = _this$chartVariables2.chartMinHeight, chartMinWidth = _this$chartVariables2.chartMinWidth, xAxisTextLineHeight = _this$chartVariables2.xAxisTextLineHeight, yAxisWidth = _this$chartVariables2.yAxisWidth;
                        this.chartVariables.container = this.shadowRoot.getElementById("chart-container");
                        this.chartVariables.width = this.chartVariables.container && this.chartVariables.container.offsetWidth || chartMinWidth + yAxisWidth;
                        this.chartVariables.height = this.chartHeight ? this.chartHeight + xAxisTextLineHeight : chartMinHeight + xAxisTextLineHeight;
                    }
                }, {
                    key: "_createSVG",
                    value: function _createSVG() {
                        this.chartVariables.svg && this.chartVariables.svg.remove();
                        var svgContainer = this.shadowRoot.querySelector(".".concat(this.rootClass, "__svg-container"));
                        this.chartVariables.svg = d3__WEBPACK_IMPORTED_MODULE_1__["select"](svgContainer).append("svg").attr("width", this.chartVariables.width).attr("height", this.chartVariables.height);
                    }
                }, {
                    key: "_addAxes",
                    value: function _addAxes(subGroup) {
                        var newXAxisHeight = this._addXAxis(subGroup);
                        if (newXAxisHeight !== this.chartVariables.xAxisTextLineHeight) {
                            this.chartVariables.height = this.chartHeight ? this.chartHeight + newXAxisHeight : this.chartVariables.chartMinHeight + newXAxisHeight;
                            var svg = this.shadowRoot.querySelector(".".concat(this.rootClass, "__svg-container svg"));
                            d3__WEBPACK_IMPORTED_MODULE_1__["select"](svg).attr("height", this.chartVariables.height);
                        }
                        this._addYAxis();
                    }
                }, {
                    key: "_addYAxis",
                    value: function _addYAxis() {
                        var _this9 = this;
                        this.chartVariables.yAxisHeight = this.chartHeight ? this.chartHeight - this.chartVariables.yAxisTopPadding : this.chartVariables.chartMinHeight - this.chartVariables.yAxisTopPadding;
                        var range = [ this.chartVariables.yAxisHeight, 0 ];
                        var barValueVariantDomain = [ this.yAxis.range[0], 1.3 * d3__WEBPACK_IMPORTED_MODULE_1__["max"](this.series[0].bars) ];
                        this.chartVariables.barValueVariantYAxisDomain = barValueVariantDomain;
                        this.chartVariables.yScale = d3__WEBPACK_IMPORTED_MODULE_1__["scaleLinear"]().domain(this.isBarValueVariant && !this.isMultiSeries ? barValueVariantDomain : this.yAxis.range).range(range);
                        var domainAndLineOffset = 9;
                        var axis = d3__WEBPACK_IMPORTED_MODULE_1__["axisRight"](this.chartVariables.yScale);
                        this._specifyTicks(axis, this.series);
                        axis.tickFormat(Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["getFormatter"])(d3__WEBPACK_IMPORTED_MODULE_1__, this, this.yAxis.d3TickFormatString, "formatYAxis"));
                        if (this.isBarValueVariant && !this.isMultiSeries || this.isGroupedBarsVariant) return;
                        this.chartVariables.yAxis = this.chartVariables.svg.append("g").attr("class", "y-axis").attr("transform", "translate(".concat(this.chartVariables.width - domainAndLineOffset, ", ").concat(this.chartVariables.yAxisTopPadding, ")")).call(axis).call(function(g) {
                            _newArrowCheck(this, _this9);
                            return g.select(".domain").remove();
                        }.bind(this)).call(function(g) {
                            _newArrowCheck(this, _this9);
                            return g.selectAll("line").remove();
                        }.bind(this));
                    }
                }, {
                    key: "_specifyTicks",
                    value: function _specifyTicks(axis) {
                        var numTickLabels = this.yAxis.numTickLabels;
                        if (numTickLabels) {
                            var ticks = [];
                            var increment = Math.floor(this.yAxis.range[1] / numTickLabels);
                            for (var i = 0; i < numTickLabels; i += 1) {
                                ticks.push(0 + increment * i);
                            }
                            axis.tickValues(ticks);
                        }
                    }
                }, {
                    key: "_addXAxis",
                    value: function _addXAxis(subGroup) {
                        var _this10 = this;
                        var _this$chartVariables3 = this.chartVariables, height = _this$chartVariables3.height, width = _this$chartVariables3.width, yAxisWidth = _this$chartVariables3.yAxisWidth;
                        var newXAxisHeight = 0;
                        var yAxisOffset = height ? yAxisWidth : 0;
                        this.chartVariables.xScale = d3__WEBPACK_IMPORTED_MODULE_1__["scaleBand"]().domain(this.xAxisLabels.map(function(label) {
                            _newArrowCheck(this, _this10);
                            return label.axisLabel;
                        }.bind(this))).range([ 0, width - yAxisOffset ]).paddingInner(.3);
                        if (this.isGroupedBarsVariant && subGroup.length) {
                            this.chartVariables.xScale.range([ 0, width ]).paddingInner(0);
                            this.chartVariables.subGroupXScale = d3__WEBPACK_IMPORTED_MODULE_1__["scaleBand"]().domain(subGroup).range([ 0, this.chartVariables.xScale.bandwidth() ]).paddingInner(.3);
                        }
                        newXAxisHeight += this._renderXAxis(this.chartVariables.xScale);
                        return newXAxisHeight;
                    }
                }, {
                    key: "_renderXAxis",
                    value: function _renderXAxis(xScale) {
                        var _this11 = this;
                        var _this$chartVariables4 = this.chartVariables, chartMinHeight = _this$chartVariables4.chartMinHeight, svg = _this$chartVariables4.svg, xAxisTextLineHeight = _this$chartVariables4.xAxisTextLineHeight, xAxisTextWeight = _this$chartVariables4.xAxisTextWeight, selectedBarXAxisLabelTextWeight = _this$chartVariables4.selectedBarXAxisLabelTextWeight, seriesInterGroupMinPadding = _this$chartVariables4.seriesInterGroupMinPadding;
                        var axis = d3__WEBPACK_IMPORTED_MODULE_1__["axisBottom"](xScale);
                        axis.tickPadding(4);
                        var axisHeight = xAxisTextLineHeight;
                        var axisGroup = svg.append("g").attr("class", "x-axis").call(axis).call(function(g) {
                            _newArrowCheck(this, _this11);
                            return g.selectAll(".domain, line").remove();
                        }.bind(this));
                        var xTicks = axisGroup.selectAll("text").attr("class", "x-axis-tick").style("font-weight", function(text, i) {
                            _newArrowCheck(this, _this11);
                            return this._isSelectedBar(i) ? selectedBarXAxisLabelTextWeight : xAxisTextWeight;
                        }.bind(this)).style("visibility", function(text, i) {
                            _newArrowCheck(this, _this11);
                            return i % 2 && this._isSmallerBarWidth() && (MDS.isMobile || Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_6__["getBreakpoint"])() === "xs") ? "hidden" : "visible";
                        }.bind(this));
                        var textMaxWidth = xScale.bandwidth();
                        var _textWrapBreakWord = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["textWrapBreakWord"])(d3__WEBPACK_IMPORTED_MODULE_1__, xTicks, textMaxWidth, xAxisTextLineHeight, "", false, true), extraLines = _textWrapBreakWord.extraLines;
                        axisHeight *= extraLines + 1;
                        axisGroup.attr("transform", "translate(0, ".concat(this.chartHeight ? this.chartHeight : chartMinHeight, ")"));
                        axisGroup.selectAll(".tick").attr("transform", function(text, i) {
                            _newArrowCheck(this, _this11);
                            return "translate(".concat(this._generateLabelXOffset(i), ", 0)");
                        }.bind(this));
                        return axisHeight;
                    }
                }, {
                    key: "_addBars",
                    value: function _addBars() {
                        var _this12 = this;
                        var variant = this.variant, isGroupedBarsVariant = this.isGroupedBarsVariant, formattedSeries = this.formattedSeries, defaultSeries = this.series, _renderGroupedBarsSeries = this._renderGroupedBarsSeries, _renderSeries = this._renderSeries, xAxisLabels = this.xAxisLabels;
                        var seriesDataToUse = isGroupedBarsVariant ? formattedSeries : defaultSeries;
                        var renderSeriesToUse = isGroupedBarsVariant ? _renderGroupedBarsSeries : _renderSeries;
                        seriesDataToUse.forEach(function(series, seriesIndex) {
                            _newArrowCheck(this, _this12);
                            series.labels = xAxisLabels[seriesIndex];
                            renderSeriesToUse(series, seriesIndex, variant);
                        }.bind(this));
                        this._renderInteractiveOverlay(this.variant);
                    }
                }, {
                    key: "_setCustomBarColor",
                    value: function _setCustomBarColor(i) {
                        var isSelected = this._isSelectedBar(i);
                        var styles = "";
                        if (isSelected && this.selectedBarColor) {
                            styles = "fill: ".concat(this.selectedBarColor, "; stroke: ").concat(this.selectedBarColor, ";");
                        }
                        if (!isSelected && this.unselectedBarColor) {
                            styles = "fill: ".concat(this.unselectedBarColor, "; stroke: ").concat(this.unselectedBarColor, ";");
                        }
                        return styles;
                    }
                }, {
                    key: "_addBarLabels",
                    value: function _addBarLabels(bars, seriesIndex, barWidth, seriesData) {
                        var _this13 = this;
                        var labels = bars.append("text").text(function(data) {
                            _newArrowCheck(this, _this13);
                            return data.val >= 0 ? this.valueFormatter(data.val) : null;
                        }.bind(this)).attr("class", function(data, index) {
                            _newArrowCheck(this, _this13);
                            return "bar__label bar__label-".concat(index);
                        }.bind(this)).attr("x", function(data, i) {
                            _newArrowCheck(this, _this13);
                            var defaultXpos = this._generateXOffset(seriesIndex, i) + barWidth / 2;
                            return this.barWidth === this.maxBarWith ? defaultXpos + (this.maxBarWith - this.defaultBarWidth) / 2 : defaultXpos;
                        }.bind(this)).each((function(data) {
                            var currentLabelWidth = this.getBBox().width;
                            if (currentLabelWidth > barWidth) {
                                Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["textWrapByCharacter"])(d3__WEBPACK_IMPORTED_MODULE_1__, d3__WEBPACK_IMPORTED_MODULE_1__["select"](this), barWidth);
                                data.isWrapped = true;
                            }
                            var currentLabelHeight = this.getBBox().height;
                            data.labelHeight = currentLabelHeight;
                            seriesData.push(data);
                        })).attr("y", function(data, i) {
                            _newArrowCheck(this, _this13);
                            var defaultYOffset = this._generateYOffset(data.val, i, seriesIndex) - this.chartVariables.yAxisTopPadding * .75 / 2;
                            var adjustedYOffset = this._generateYOffset(data.val, i, seriesIndex) - (data.labelHeight - this.chartVariables.yAxisTopPadding * .75);
                            return data.isWrapped ? adjustedYOffset : defaultYOffset;
                        }.bind(this)).attr("text-anchor", "middle");
                    }
                }, {
                    key: "variantChangedCallback",
                    value: function variantChangedCallback() {
                        this.renderChart();
                    }
                }, {
                    key: "_renderInteractiveOverlay",
                    value: function _renderInteractiveOverlay(variant) {
                        var _this14 = this;
                        var interactiveRegionsSVG = this.chartVariables.svg.append("g").attr("id", "interactive-regions");
                        var regionsNumbers = variant === "groupedBars" ? this.formattedSeries.map(function(bar, i) {
                            _newArrowCheck(this, _this14);
                            return i;
                        }.bind(this)) : this.series[0].bars.map(function(bar, i) {
                            _newArrowCheck(this, _this14);
                            return i;
                        }.bind(this));
                        var regionWidth = this._getRegionWidth(variant);
                        interactiveRegionsSVG.selectAll("rect").data(regionsNumbers).join("rect").attr("id", function(regionNumber) {
                            _newArrowCheck(this, _this14);
                            return "region-".concat(regionNumber);
                        }.bind(this)).attr("fill", "transparent").attr("x", function(regionNumber) {
                            _newArrowCheck(this, _this14);
                            return this._generateRegionXOffset(regionNumber);
                        }.bind(this)).attr("y", 0).attr("height", this.chartHeight || this.chartVariables.chartMinHeight).attr("width", regionWidth).style("cursor", "pointer").on("click", this._handleClick).on("touchstart", this._handleClick);
                    }
                }, {
                    key: "_getBarClass",
                    value: function _getBarClass(barIndex, isMultiSeries) {
                        var isSelected = this._isSelectedBar(barIndex);
                        var className = "series-bar";
                        if (isSelected) {
                            className = "series-bar--selected";
                        }
                        if (isMultiSeries && isSelected) {
                            className = "multi-series-bar--selected";
                        }
                        return className;
                    }
                }, {
                    key: "_generateXOffset",
                    value: function _generateXOffset(seriesIndex, barIndex) {
                        var bandOffset = this.chartVariables.xScale(this.xAxisLabels[barIndex].axisLabel);
                        var barWidthForScreenSize = this._getBarWidth(seriesIndex);
                        var groupOffset = (this.chartVariables.xScale.bandwidth() - barWidthForScreenSize) / 2;
                        if (this._isSelectedBar(barIndex)) {
                            this.chartVariables.dataMarkerXOffset = bandOffset + groupOffset + this._getBarWidth(0) / 2;
                            if (barWidthForScreenSize === this.chartVariables.barWidthSevenOrMore) {
                                this.chartVariables.dataMarkerXOffset += this.chartVariables.seriesStackedBarInterStackPadding;
                            }
                        }
                        return bandOffset + groupOffset;
                    }
                }, {
                    key: "_generateLabelXOffset",
                    value: function _generateLabelXOffset(barIndex) {
                        var regionWidth = this._getRegionWidth(this.variant);
                        return regionWidth * barIndex + regionWidth / 2;
                    }
                }, {
                    key: "_generateRegionXOffset",
                    value: function _generateRegionXOffset(barIndex) {
                        var regionWidth = this._getRegionWidth(this.variant);
                        return regionWidth * barIndex;
                    }
                }, {
                    key: "_generateBarXOffset",
                    value: function _generateBarXOffset(seriesIndex, barIndex) {
                        var region = this._generateRegionXOffset(barIndex);
                        var regionWidth = this._getRegionWidth(this.variant);
                        var barWidth = this._getBarWidth();
                        return region + (regionWidth - barWidth) / 2;
                    }
                }, {
                    key: "_generateYOffset",
                    value: function _generateYOffset(bar, barIndex, seriesIndex) {
                        var barValue = bar;
                        if (this.series.length > 1) {
                            for (var i = seriesIndex + 1; i < this.series.length; i++) {
                                barValue += this.series[i].bars[barIndex];
                            }
                        }
                        var offset = this.chartVariables.yScale(barValue) + this.chartVariables.yAxisTopPadding;
                        if (this._isSelectedBar(barIndex)) {
                            var defaultDataMarkerYOffset = offset;
                            var isZeroOrNegativeVal = this.series[0].bars[barIndex] < 0;
                            this.chartVariables.dataMarkerYOffset = isZeroOrNegativeVal ? this.chartVariables.yAxisHeight : this.isBarValueVariant && !this.isMultiSeries ? defaultDataMarkerYOffset - this.chartVariables.yAxisTopPadding : defaultDataMarkerYOffset;
                        }
                        return offset;
                    }
                }, {
                    key: "_addBaseline",
                    value: function _addBaseline() {
                        var _this$chartVariables5 = this.chartVariables, xScale = _this$chartVariables5.xScale, yScale = _this$chartVariables5.yScale, svg = _this$chartVariables5.svg;
                        var _yScale$domain = yScale.domain(), _yScale$domain2 = _slicedToArray(_yScale$domain, 2), y0 = _yScale$domain2[0], y1 = _yScale$domain2[1];
                        if (y1 >= 0) {
                            var _xScale$range = xScale.range(), _xScale$range2 = _slicedToArray(_xScale$range, 2), x0 = _xScale$range2[0], x1 = _xScale$range2[1];
                            var y = yScale(0) + this.chartVariables.yAxisTopPadding;
                            svg.append("path").attr("class", "baseline").attr("d", "M".concat(x0, ",").concat(y, "L").concat(x1, ",").concat(y));
                        }
                    }
                }, {
                    key: "_addReferenceLine",
                    value: function _addReferenceLine(referenceLineValue) {
                        var _this$chartVariables6 = this.chartVariables, xScale = _this$chartVariables6.xScale, yScale = _this$chartVariables6.yScale, svg = _this$chartVariables6.svg;
                        if (referenceLineValue > this.yAxis.range[0] && referenceLineValue < this.yAxis.range[1] && !this.isBarValueVariant) {
                            var _xScale$range3 = xScale.range(), _xScale$range4 = _slicedToArray(_xScale$range3, 2), x0 = _xScale$range4[0], x1 = _xScale$range4[1];
                            var yAxisReferenceLineValue = yScale(referenceLineValue) + this.chartVariables.yAxisTopPadding;
                            svg.append("path").attr("class", "reference-line").attr("d", "M".concat(x0, ",").concat(yAxisReferenceLineValue, "L").concat(x1, ",").concat(yAxisReferenceLineValue));
                        }
                    }
                }, {
                    key: "_renderLegendItem",
                    value: function _renderLegendItem(itemData) {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__legend-item"));
                        this.referenceLine && this.referenceLine.label === itemData.label ? Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", "".concat(this.rootClass, "__legend-item__swatch--reference-line")) : Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", "".concat(this.rootClass, "__legend-item-swatch"), "style", {
                            "background-color": this.selectedBarColor || itemData.color
                        });
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "".concat(this.rootClass, "__legend-item-label"));
                        _renderArbitrary(itemData.label);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "".concat(this.rootClass, "__legend-item-value"));
                        _renderArbitrary(itemData.value);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_renderLegend",
                    value: function _renderLegend() {
                        var _this15 = this;
                        var isBarValueVariant = this.variant === "barValue";
                        var isGroupedBarsVariant = this.variant === "groupedBars";
                        var shouldNotShowLegend = isBarValueVariant && !this.isMultiSeries || isGroupedBarsVariant;
                        var rowsOfAllLegendItems = [];
                        var valueFormatter = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["getFormatter"])(d3__WEBPACK_IMPORTED_MODULE_1__, this, this.d3BarLabelFormatString, "formatLegendItemValue");
                        this.valueFormatter = valueFormatter;
                        if (shouldNotShowLegend) return;
                        var allLegendItems = this.series.map(function(series) {
                            _newArrowCheck(this, _this15);
                            return {
                                label: series.legendLabel,
                                color: this.series.length > 1 ? series.color : "",
                                value: valueFormatter(series.bars[this.selectedBar])
                            };
                        }.bind(this));
                        this.referenceLine && allLegendItems.push({
                            label: this.referenceLine.label,
                            value: valueFormatter(this.referenceLine.value)
                        });
                        this.legend.itemsPerRow.forEach(function(numberOfItemsPerRow) {
                            _newArrowCheck(this, _this15);
                            var row = [];
                            for (var i = 0; i < numberOfItemsPerRow; i += 1) {
                                allLegendItems.length && row.push(allLegendItems.shift());
                            }
                            row.length > 0 && rowsOfAllLegendItems.push(row);
                        }.bind(this));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__legend-container"), "aria-hidden", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__legend-heading"));
                        _renderArbitrary(this.xAxisLabels[this.selectedBar].legendLabel);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__legend-item-container"));
                        _renderArbitrary(rowsOfAllLegendItems.length && rowsOfAllLegendItems.map(function(row) {
                            var _this16 = this;
                            _newArrowCheck(this, _this15);
                            return _jsxWrapper(_div$wrapper, [ "".concat(this.rootClass, "__legend-item-row"), row, function(item) {
                                _newArrowCheck(this, _this16);
                                return this._renderLegendItem(item);
                            }.bind(this) ]);
                        }.bind(this)));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_isSelectedBar",
                    value: function _isSelectedBar(barIndex) {
                        return this.selectedBar === barIndex;
                    }
                }, {
                    key: "_isSmallerBarWidth",
                    value: function _isSmallerBarWidth() {
                        var seriesIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
                        return this.series[seriesIndex].bars.length >= 7;
                    }
                }, {
                    key: "_isEmpty",
                    value: function _isEmpty() {
                        var _this17 = this;
                        return !this.series || !this.series.some(function(series) {
                            _newArrowCheck(this, _this17);
                            return series.bars && series.bars.length;
                        }.bind(this));
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback(prop) {
                        var _this18 = this;
                        _get(_getPrototypeOf(MdsBarChartSelectable.prototype), "renderedCallback", this) && _get(_getPrototypeOf(MdsBarChartSelectable.prototype), "renderedCallback", this).call(this, prop);
                        if (this._isEmpty()) {
                            this.chartVariables.svg && this.chartVariables.svg.remove();
                            this.chartVariables.svg = null;
                        } else {
                            var isWidthChanged = !this.chartVariables.container || this.chartVariables.container.offsetWidth && this.chartVariables.container.offsetWidth !== this.chartVariables.width;
                            var container = this.shadowRoot.getElementById("chart-container");
                            var isChartDataChanged = !prop || prop.match(/(series|xAxisLabels|yAxis|d3BarLabelFormatString|selectedBar|referenceLine|legend|selected-bar)/);
                            if (container && (isWidthChanged || isChartDataChanged) && this.isConnected) {
                                setTimeout(function() {
                                    _newArrowCheck(this, _this18);
                                    this.renderChart(prop);
                                }.bind(this));
                            }
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var chartBodyClasses = {
                            "bar-chart-selectable__chart-body": true,
                            "bar-chart-selectable__with-bgc": this.backgroundColor
                        };
                        var idAccessibleTitle = "".concat(this.id, "-accessible-title");
                        var isEmpty = this._isEmpty();
                        if (!isEmpty && Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_6__["isNonZeroFalsy"])(this.selectedBar)) {
                            this.selectedBar = this._setInitalSelectedBar(this.series);
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", this.rootClass);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", chartBodyClasses);
                        _renderArbitrary(!isEmpty && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text", "role", "img", "aria-labelledby", idAccessibleTitle), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true", "id", idAccessibleTitle), 
                        _renderArbitrary(this.shortDescription), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__data-container"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "chart-container");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "".concat(this.rootClass, "__chart-container"));
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_6__["conditionalAttribute"])({
                            "aria-hidden": true
                        }, !this._isEmpty()));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        _renderArbitrary(isEmpty ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__empty-chart")), 
                        _renderArbitrary(this.noDataPointText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")) : (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__svg-container"), "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(!isEmpty && this._renderLegend());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "isBarValueVariant",
                    get: function get() {
                        return this.variant === "barValue";
                    }
                }, {
                    key: "isGroupedBarsVariant",
                    get: function get() {
                        return this.variant === "groupedBars";
                    }
                } ]);
                return MdsBarChartSelectable;
            }(_abstract_chart__WEBPACK_IMPORTED_MODULE_4__["default"]), _class2.styles = _mds_bar_chart_selectable_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsBarChartSelectable;
        },
        "./src/bar-chart-selectable/mds-bar-chart-selectable.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/bar-chart-selectable/mds-bar-chart-selectable.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/bar-chart/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "barEntity", (function() {
                return barEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "seriesEntity", (function() {
                return seriesEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "axisEntity", (function() {
                return axisEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "axisLabelEntity", (function() {
                return axisLabelEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var d3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d3");
            var d3__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(d3__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_2__);
            var _mds_bar_chart_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/bar-chart/mds-bar-chart.scss");
            var _mds_bar_chart_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_bar_chart_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _abstract_chart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/abstract-chart/index.jsx");
            var _utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/chart-utils.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/data-utils.js");
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            var _span$wrapper = function _span$wrapper(_backgroundColor$c, _series$legendLabel) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "bar-chart__legend-item");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", "bar-chart__legend-swatch", "style", _backgroundColor$c);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "bar-chart__legend-text");
                _renderArbitrary(_series$legendLabel);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _slicedToArray(arr, i) {
                return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
            }
            function _nonIterableRest() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _iterableToArrayLimit(arr, i) {
                var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
                if (null != _i) {
                    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
                    try {
                        if (_x = (_i = _i.call(arr)).next, 0 === i) {
                            if (Object(_i) !== _i) return;
                            _n = !1;
                        } else for (;!(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) ;
                    } catch (err) {
                        _d = !0, _e = err;
                    } finally {
                        try {
                            if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
                        } finally {
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
            }
            function _arrayWithHoles(arr) {
                if (Array.isArray(arr)) return arr;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_2__["mixins"].AttributeMarshallingMixin, boolean = _mixins$AttributeMars.boolean, string = _mixins$AttributeMars.string, number = _mixins$AttributeMars.number, arrayOf = _mixins$AttributeMars.arrayOf, satisfies = _mixins$AttributeMars.satisfies, enumerables = _mixins$AttributeMars.enumerables;
            var barEntity = {
                value: number,
                projection: boolean,
                secondaryLabel: string,
                secondaryLabelColor: string,
                highlightedBarColor: string
            };
            var seriesEntity = {
                color: string,
                legendLabel: string,
                bars: arrayOf(satisfies(barEntity))
            };
            var axisEntity = {
                numTickLabels: number,
                range: arrayOf(number).withMaxLength(2).withMinLength(2),
                visible: boolean,
                d3TickFormatString: string
            };
            var axisLabelEntity = {
                primaryLabel: string,
                secondaryLabel: string,
                secondaryLabelColor: string
            };
            var entity = _objectSpread({}, _abstract_chart__WEBPACK_IMPORTED_MODULE_4__["entity"], {
                series: arrayOf(satisfies(seriesEntity)).withMaxLength(4),
                xAxisLabels: arrayOf(satisfies(axisLabelEntity)),
                yAxis: satisfies(axisEntity),
                groupType: enumerables(string, "stacked", "grouped"),
                barWidth: enumerables(number, 8, 16, 24, 32, 48, 64),
                interBarWidth: number,
                legendPosition: enumerables(string, "top", "left"),
                leftLegendWidth: string,
                d3BarLabelFormatString: string,
                hasBarLabels: boolean
            });
            var tokens = {
                xAxisMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("4px"),
                xAxisTickLineHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("1.25rem"),
                xAxisTickLabelHorizontalMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("4px"),
                xAxisSecondaryTickLabelTopMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("4px"),
                yAxisMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("16px"),
                barLabelTextSize: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("0.875rem"),
                barLabelLineHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("1.25rem"),
                barLabelBottomMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("2px"),
                barLabelHorizontalMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("4px"),
                chartMinWidth: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("240px"),
                chartTrailingPadding: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("16px"),
                chartLeadingPadding: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("16px"),
                chartTopPadding: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])("10px")
            };
            var MdsBarChart = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_2__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractChart) {
                _inherits(MdsBarChart, _AbstractChart);
                _createClass(MdsBarChart, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsBarChart";
                    }
                } ]);
                function MdsBarChart(props) {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsBarChart);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsBarChart).call(this, props));
                    _this._calculateSeriesXTranslates = function(seriesIndex) {
                        _newArrowCheck(this, _this2);
                        return "translate(".concat(seriesIndex > 0 ? seriesIndex * 2 : 0, ", 0)");
                    }.bind(this);
                    _this.rootClass = "bar-chart";
                    _extends(_this.chartVariables, tokens);
                    return _this;
                }
                _createClass(MdsBarChart, [ {
                    key: "renderChart",
                    value: function renderChart() {
                        if (this._isEmpty()) {
                            return;
                        }
                        this._setDimensionVariables();
                        this._createSVG();
                        this._addAxes();
                        this._addBars();
                        this._addBaseline();
                    }
                }, {
                    key: "_setDimensionVariables",
                    value: function _setDimensionVariables() {
                        this.chartVariables.container = this.shadowRoot.getElementById("chart-container");
                        this.chartVariables.width = this.chartVariables.container && this.chartVariables.container.offsetWidth || this._getDefaultWidth();
                        this.chartVariables.height = this.chartHeight;
                        this._paddingTop = this.yAxis.visible ? this.chartVariables.chartTopPadding : 0;
                    }
                }, {
                    key: "_getDefaultWidth",
                    value: function _getDefaultWidth() {
                        var _this$chartVariables = this.chartVariables, chartTrailingPadding = _this$chartVariables.chartTrailingPadding, chartLeadingPadding = _this$chartVariables.chartLeadingPadding, chartMinWidth = _this$chartVariables.chartMinWidth;
                        var legendWidth = 0;
                        var padding = chartLeadingPadding + chartTrailingPadding;
                        var chartWidth = this.offsetWidth - padding;
                        if (this.showLegend && this.legendPosition === "left") {
                            legendWidth = this._getLegendLeftWidth(chartWidth);
                        }
                        return Math.max(chartMinWidth, chartWidth - legendWidth);
                    }
                }, {
                    key: "_getLegendLeftWidth",
                    value: function _getLegendLeftWidth(chartWidth) {
                        var legend = this.shadowRoot.getElementById("legend-left");
                        if (legend && legend.offsetWidth) {
                            return legend.offsetWidth;
                        }
                        var maxWidthPercent = parseFloat("25%") / 100;
                        var maxWidth = chartWidth * maxWidthPercent;
                        var expectedWidth;
                        if (this.leftLegendWidth && this.leftLegendWidth.match(/%/)) {
                            expectedWidth = chartWidth * (parseFloat(this.leftLegendWidth) / 100);
                        } else if (this.leftLegendWidth) {
                            expectedWidth = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_7__["cleanCssToPx"])(this.leftLegendWidth);
                        } else {
                            expectedWidth = maxWidth;
                        }
                        return Math.min(maxWidth, expectedWidth);
                    }
                }, {
                    key: "_createSVG",
                    value: function _createSVG() {
                        this.chartVariables.svg && this.chartVariables.svg.remove();
                        var svgContainer = this.shadowRoot.querySelector(".bar-chart__svg-container");
                        this.chartVariables.svg = d3__WEBPACK_IMPORTED_MODULE_1__["select"](svgContainer).append("svg").attr("width", this.chartVariables.width).attr("height", this.chartVariables.height);
                    }
                }, {
                    key: "_addAxes",
                    value: function _addAxes() {
                        this.chartVariables.yAxisWidth = this._addYAxis(this.chartVariables.xAxisMargin + this.chartVariables.xAxisTickLineHeight);
                        var newXAxisHeight = this._addXAxis();
                        var legendTop = this.shadowRoot.getElementById("legend-top");
                        if (legendTop && legendTop.style.paddingBottom) {
                            legendTop.style.paddingBottom = 0;
                        }
                        if (newXAxisHeight !== this.chartVariables.xAxisHeight) {
                            this.chartVariables.yAxis && this.chartVariables.yAxis.remove();
                            this.chartVariables.yAxisWidth = this._addYAxis(newXAxisHeight);
                        }
                        if (this.yAxis.range[0] < 0) {
                            this._addNegativeRegionBackgroundColor();
                            this.chartVariables.yAxis && Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["colorNegativeAxisTicks"])(d3__WEBPACK_IMPORTED_MODULE_1__, this.chartVariables.yAxis);
                        }
                        if (this.legendPosition === "left") {
                            var legendLeft = this.shadowRoot.getElementById("legend-left");
                            if (legendLeft) {
                                legendLeft.style.paddingBottom = "".concat(newXAxisHeight, "px");
                            }
                        }
                    }
                }, {
                    key: "_addYAxis",
                    value: function _addYAxis(xAxisHeight) {
                        var _this3 = this;
                        this.chartVariables.xAxisHeight = xAxisHeight;
                        this.chartVariables.yAxisHeight = this.chartVariables.height - xAxisHeight;
                        this.chartVariables.extraLines = this.chartVariables.extraLines || 0;
                        this.chartVariables.extraLines = this.chartVariables.extraLines > 1 ? this.chartVariables.extraLines : this.chartVariables.extraLines;
                        var _this$chartVariables2 = this.chartVariables, yAxisHeight = _this$chartVariables2.yAxisHeight, extraLines = _this$chartVariables2.extraLines, xAxisTickLineHeight = _this$chartVariables2.xAxisTickLineHeight, xAxisMargin = _this$chartVariables2.xAxisMargin, chartTopPadding = _this$chartVariables2.chartTopPadding;
                        var heightXAxisLines = extraLines > 0 ? xAxisTickLineHeight * extraLines - xAxisMargin * extraLines + xAxisTickLineHeight : xAxisHeight + xAxisMargin * 2;
                        var range = [ yAxisHeight - xAxisHeight, -(heightXAxisLines * 2 + chartTopPadding / 4) ];
                        this.chartVariables.yScale = d3__WEBPACK_IMPORTED_MODULE_1__["scaleLinear"]().domain(this.yAxis.range).range(range);
                        if (!this.yAxis.visible) {
                            this.chartVariables.yAxis = null;
                            return 0;
                        }
                        var domainAndLineOffset = 9;
                        var axis = d3__WEBPACK_IMPORTED_MODULE_1__["axisRight"](this.chartVariables.yScale);
                        this._specifyTicks(axis);
                        axis.tickFormat(Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["getFormatter"])(d3__WEBPACK_IMPORTED_MODULE_1__, this, this.yAxis.d3TickFormatString, "formatYAxis"));
                        this.chartVariables.yAxis = this.chartVariables.svg.append("g").attr("class", "y-axis").attr("transform", "translate(".concat(this.chartVariables.width - domainAndLineOffset, ", ").concat(-(this.chartVariables.xAxisTickLineHeight - xAxisHeight + this.chartVariables.xAxisMargin - this._paddingTop), ")")).call(axis).call(function(g) {
                            _newArrowCheck(this, _this3);
                            return g.select(".domain").remove();
                        }.bind(this)).call(function(g) {
                            _newArrowCheck(this, _this3);
                            return g.selectAll("line").remove();
                        }.bind(this));
                        this.chartVariables.yAxis.selectAll("text").style("text-anchor", "end");
                        if (MDS.isFireFox) {
                            return Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["getLargestTextWidth"])(this.chartVariables.yAxis, "text");
                        }
                        return this.chartVariables.yAxis.node().getBBox().width;
                    }
                }, {
                    key: "_specifyTicks",
                    value: function _specifyTicks(axis) {
                        var _this$yAxis = this.yAxis, numTickLabels = _this$yAxis.numTickLabels, range = _this$yAxis.range;
                        if (numTickLabels) {
                            var ticks = [];
                            var increment = Math.abs((range[1] - range[0]) / numTickLabels);
                            for (var i = 0; i < numTickLabels; i += 1) {
                                ticks.push(range[0] + increment * i);
                            }
                            axis.tickValues(ticks);
                        }
                    }
                }, {
                    key: "_addXAxis",
                    value: function _addXAxis() {
                        var _this4 = this;
                        var _this$chartVariables3 = this.chartVariables, yAxis = _this$chartVariables3.yAxis, yAxisWidth = _this$chartVariables3.yAxisWidth, yAxisMargin = _this$chartVariables3.yAxisMargin, width = _this$chartVariables3.width, xAxisMargin = _this$chartVariables3.xAxisMargin, xAxisSecondaryTickLabelTopMargin = _this$chartVariables3.xAxisSecondaryTickLabelTopMargin;
                        var newXAxisHeight = xAxisMargin;
                        var yAxisOffset = yAxis ? yAxisWidth + yAxisMargin : 0;
                        this.chartVariables.xScale = d3__WEBPACK_IMPORTED_MODULE_1__["scaleBand"](this.xAxisLabels.map(function(label) {
                            _newArrowCheck(this, _this4);
                            return label.primaryLabel;
                        }.bind(this)), [ 0, width - yAxisOffset ]);
                        var secondaryXScale = this.groupType !== "stacked" && this.series.length <= 2 && this.xAxisLabels.some(function(label) {
                            _newArrowCheck(this, _this4);
                            return label.secondaryLabel;
                        }.bind(this)) && d3__WEBPACK_IMPORTED_MODULE_1__["scaleBand"](this.xAxisLabels.map(function(label, i) {
                            _newArrowCheck(this, _this4);
                            return label.secondaryLabel || " ".repeat(i);
                        }.bind(this)), [ 0, width - yAxisOffset ]);
                        if (this.interBarWidth && this.barWidth) {
                            var outerPadding = this._generateOuterPadding();
                            this.chartVariables.xScale.paddingOuter(outerPadding);
                            secondaryXScale && secondaryXScale.paddingOuter(outerPadding);
                        }
                        if (secondaryXScale) {
                            var secondaryXAxisHeight = this._renderXAxis(secondaryXScale, newXAxisHeight, {
                                class: function _class(_, i) {
                                    _newArrowCheck(this, _this4);
                                    return this.xAxisLabels[i].secondaryLabelColor ? "" : "secondary-tick-label";
                                }.bind(this),
                                color: function color(_, i) {
                                    _newArrowCheck(this, _this4);
                                    return this.xAxisLabels[i].secondaryLabelColor;
                                }.bind(this)
                            });
                            newXAxisHeight += xAxisSecondaryTickLabelTopMargin + secondaryXAxisHeight;
                            var secondaryXAxisText = this.chartVariables.svg.selectAll("text");
                            secondaryXAxisText.attr("class", "secondary-label").attr("color", function(_, idx) {
                                _newArrowCheck(this, _this4);
                                return this.xAxisLabels[idx] && this.xAxisLabels[idx].secondaryLabelColor;
                            }.bind(this));
                        }
                        newXAxisHeight += this._renderXAxis(this.chartVariables.xScale, newXAxisHeight);
                        return newXAxisHeight;
                    }
                }, {
                    key: "_renderXAxis",
                    value: function _renderXAxis(xScale, axisOffset) {
                        var _this5 = this;
                        var _this$chartVariables4 = this.chartVariables, height = _this$chartVariables4.height, svg = _this$chartVariables4.svg, xAxisTickLineHeight = _this$chartVariables4.xAxisTickLineHeight, xAxisTickLabelHorizontalMargin = _this$chartVariables4.xAxisTickLabelHorizontalMargin;
                        var axis = d3__WEBPACK_IMPORTED_MODULE_1__["axisBottom"](xScale);
                        var axisHeight = xAxisTickLineHeight;
                        var axisGroup = svg.append("g").attr("class", "x-axis").call(axis).call(function(g) {
                            _newArrowCheck(this, _this5);
                            return g.select(".domain").remove();
                        }.bind(this)).call(function(g) {
                            _newArrowCheck(this, _this5);
                            return g.selectAll("line").remove();
                        }.bind(this));
                        var xTicks = axisGroup.selectAll("text");
                        var maxWidth = xScale.bandwidth() - 2 * xAxisTickLabelHorizontalMargin;
                        var _textWrapBreakFullWor = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["textWrapBreakFullWord"])(d3__WEBPACK_IMPORTED_MODULE_1__, xTicks, maxWidth, xAxisTickLineHeight, "", false, true), extraLines = _textWrapBreakFullWor.extraLines;
                        this.chartVariables.extraLines = extraLines;
                        axisHeight += extraLines * xAxisTickLineHeight;
                        axisGroup.attr("transform", "translate(0, ".concat(height - axisHeight - axisOffset - this._paddingTop, ")"));
                        return axisHeight;
                    }
                }, {
                    key: "_generateOuterPadding",
                    value: function _generateOuterPadding() {
                        var barWidth = this.barWidth, interBarWidth = this.interBarWidth, series = this.series, xAxisLabels = this.xAxisLabels, groupType = this.groupType;
                        var width = this.chartVariables.width;
                        var groupWidth = groupType === "grouped" ? series.length * barWidth : barWidth;
                        var intendedBandWidth = groupWidth + interBarWidth;
                        var barAreaWidth = intendedBandWidth * xAxisLabels.length;
                        var outerPaddingInPx = (width - barAreaWidth) / 2;
                        var outerPaddingInPercentage = outerPaddingInPx / intendedBandWidth;
                        return outerPaddingInPercentage;
                    }
                }, {
                    key: "_addNegativeRegionBackgroundColor",
                    value: function _addNegativeRegionBackgroundColor() {
                        var width = this.chartVariables.xScale.range()[1];
                        var y = this.chartVariables.yScale(0);
                        var height = this.chartVariables.yScale(this.yAxis.range[0]) - y;
                        this.chartVariables.svg.append("rect").attr("class", "negative-region").attr("width", width).attr("height", height).attr("transform", "translate(0, ".concat(y + this.chartVariables.xAxisHeight - this._paddingTop, ")"));
                    }
                }, {
                    key: "_hasSecondaryBarLabels",
                    value: function _hasSecondaryBarLabels() {
                        for (var i = 0; i < this.series.length; i++) {
                            for (var j = 0; j < this.series[i].bars.length; j++) {
                                if (this.series[i].bars[j].secondaryLabel) {
                                    return true;
                                }
                            }
                        }
                        return false;
                    }
                }, {
                    key: "_addBars",
                    value: function _addBars() {
                        var _this6 = this;
                        this.chartVariables.innerGroupScale = d3__WEBPACK_IMPORTED_MODULE_1__["scaleBand"](Array(this.series.length).fill("").map(function(_, i) {
                            _newArrowCheck(this, _this6);
                            return i;
                        }.bind(this)), [ 0, this.series.length * this.barWidth ]);
                        this.chartVariables.barLabelConfig = this.series.map(function() {
                            _newArrowCheck(this, _this6);
                            return [];
                        }.bind(this));
                        var labelFormatter = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["getFormatter"])(d3__WEBPACK_IMPORTED_MODULE_1__, this, this.d3BarLabelFormatString, "formatBarLabel");
                        var allowBarLabelForGroupedChart = this.groupType === "grouped" ? this.series.length <= 2 && !this._hasSecondaryBarLabels() : true;
                        this.series.forEach(function(series, seriesIndex) {
                            var _this7 = this;
                            _newArrowCheck(this, _this6);
                            this.chartVariables.primaryWrapped = false;
                            this.chartVariables.secondaryWrapped = false;
                            var seriesSVG = this._renderSeries(series, seriesIndex);
                            this.hasBarLabels && this.groupType !== "stacked" && this.yAxis.range.every(function(num) {
                                _newArrowCheck(this, _this7);
                                return num >= 0;
                            }.bind(this)) && !this.chartVariables.yAxis && allowBarLabelForGroupedChart && this._addBarLabels(series, seriesIndex, seriesSVG, labelFormatter);
                        }.bind(this));
                    }
                }, {
                    key: "_barColor",
                    value: function _barColor(series, bar) {
                        if (this.groupType && this.series.length > 1) {
                            return series.color;
                        }
                        if (bar.highlightedBarColor && bar.value > 0) {
                            this._selectedBar = bar;
                            return bar.highlightedBarColor;
                        }
                        if (this._selectedBar === bar) {
                            return this._selectedBar.highlightedBarColor;
                        }
                        return series.color;
                    }
                }, {
                    key: "_getBarClass",
                    value: function _getBarClass(bar) {
                        if (bar.projection && this.series.length === 1) {
                            return " bar--projection";
                        }
                        if (this.groupType) {
                            return " bar--group";
                        }
                        if (bar.highlightedBarColor && bar.value > 0) {
                            return " bar--highlighted";
                        }
                        return " bar--primary";
                    }
                }, {
                    key: "_renderSeries",
                    value: function _renderSeries(series, seriesIndex) {
                        var _this8 = this;
                        var additionalAttrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        var classSuffix = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";
                        var seriesSVG = this.chartVariables.svg.append("g").attr("class", "series-".concat(seriesIndex).concat(classSuffix)).attr("transform", this._calculateSeriesXTranslates(seriesIndex));
                        seriesSVG.selectAll("rect").data(series.bars).join("rect").attr("class", function(bar) {
                            _newArrowCheck(this, _this8);
                            return "bar".concat(this._getBarClass(bar));
                        }.bind(this)).attr("fill", function(bar) {
                            _newArrowCheck(this, _this8);
                            return this._barColor(series, bar);
                        }.bind(this)).attr("x", function(bar, i) {
                            _newArrowCheck(this, _this8);
                            return this._generateXOffset(i, seriesIndex);
                        }.bind(this)).attr("y", function(bar, i) {
                            _newArrowCheck(this, _this8);
                            return this._generateYOffset(bar, i, seriesIndex);
                        }.bind(this)).attr("height", function(bar) {
                            _newArrowCheck(this, _this8);
                            return Math.abs(this.chartVariables.yScale(0) - this.chartVariables.yScale(bar.value));
                        }.bind(this)).attr("width", this.barWidth).attr("transform", "translate(0, ".concat(this.chartVariables.xAxisHeight - this._paddingTop, ")"));
                        Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["applyAttributes"])(seriesSVG, additionalAttrs);
                        return seriesSVG;
                    }
                }, {
                    key: "_generateXOffset",
                    value: function _generateXOffset(barIndex, seriesIndex) {
                        var bandOffset = this.chartVariables.xScale(this.xAxisLabels[barIndex].primaryLabel);
                        var groupWidth = this.groupType === "stacked" ? this.barWidth : this.series.length * this.barWidth;
                        var groupOffset = (this.chartVariables.xScale.bandwidth() - groupWidth) / 2;
                        var innerGroupOffset = this.groupType === "grouped" ? this.chartVariables.innerGroupScale(seriesIndex) : 0;
                        return bandOffset + groupOffset + innerGroupOffset;
                    }
                }, {
                    key: "_generateYOffset",
                    value: function _generateYOffset(bar, barIndex, seriesIndex) {
                        var value = bar.value;
                        if (value < 0) {
                            return this.chartVariables.yScale(0);
                        }
                        if (this.groupType === "stacked") {
                            for (var i = seriesIndex + 1; i < this.series.length; i++) {
                                value += this.series[i].bars[barIndex].value;
                            }
                        }
                        return this.chartVariables.yScale(value);
                    }
                }, {
                    key: "_addBarLabels",
                    value: function _addBarLabels(series, seriesIndex, seriesSVG, formatter) {
                        var _this9 = this;
                        this.chartVariables.barLabelConfig[seriesIndex] = series.bars.map(function() {
                            _newArrowCheck(this, _this9);
                            return {};
                        }.bind(this));
                        var clonedBarsWithIndex = series.bars.map(function(bar, i) {
                            _newArrowCheck(this, _this9);
                            return _extends({
                                index: i
                            }, bar);
                        }.bind(this));
                        var labelGroups = seriesSVG.selectAll("g").data(clonedBarsWithIndex).join("g").attr("class", "bar__label-group").attr("transform", "translate(0, ".concat(this.chartVariables.xAxisHeight - this._paddingTop, ")"));
                        var sharedAttributes = {
                            "text-anchor": "middle",
                            x: function x(bar) {
                                _newArrowCheck(this, _this9);
                                return this._generateBarLabelXOffset(bar.index, seriesIndex);
                            }.bind(this)
                        };
                        var secondaryLabels = this._addSecondaryLabels(labelGroups, seriesIndex, sharedAttributes);
                        this._addPrimaryLabels(labelGroups, seriesIndex, sharedAttributes, formatter);
                        secondaryLabels && secondaryLabels.filter(function(bar) {
                            _newArrowCheck(this, _this9);
                            var barConfig = this.chartVariables.barLabelConfig[seriesIndex][bar.index];
                            return barConfig.inset || barConfig.wrapped;
                        }.bind(this)).attr("y", function(bar) {
                            _newArrowCheck(this, _this9);
                            return this._generateBarLabelYOffset(bar, bar.index, seriesIndex, true);
                        }.bind(this));
                        labelGroups.filter(function(bar) {
                            _newArrowCheck(this, _this9);
                            return bar.value < 0;
                        }.bind(this)).remove();
                    }
                }, {
                    key: "_addSecondaryLabels",
                    value: function _addSecondaryLabels(labelGroups, seriesIndex, attributes) {
                        var _this10 = this;
                        var secondaryLabels = labelGroups.filter(function(bar) {
                            _newArrowCheck(this, _this10);
                            return !!bar.secondaryLabel && !bar.projection;
                        }.bind(this)).append("text").text(function(bar) {
                            _newArrowCheck(this, _this10);
                            return bar.secondaryLabel;
                        }.bind(this)).attr("fill", function(bar) {
                            _newArrowCheck(this, _this10);
                            return bar.secondaryLabelColor;
                        }.bind(this)).attr("y", function(bar) {
                            _newArrowCheck(this, _this10);
                            return this._generateBarLabelYOffset(bar, bar.index, seriesIndex, true);
                        }.bind(this)).attr("class", function(bar) {
                            _newArrowCheck(this, _this10);
                            return !bar.secondaryLabelColor && this._generateBarLabelClasses(bar, bar.index, seriesIndex, true);
                        }.bind(this));
                        Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["applyAttributes"])(secondaryLabels, attributes);
                        this._wrapLabels(labelGroups.selectAll(".bar__label--secondary"), seriesIndex, "secondary");
                        return secondaryLabels;
                    }
                }, {
                    key: "_wrapLabels",
                    value: function _wrapLabels(selectionToWrap, seriesIndex, type) {
                        var chartContext = this;
                        selectionToWrap.each((function applyWrap(bar) {
                            var barWidth = chartContext.barWidth;
                            var _chartContext$chartVa = chartContext.chartVariables, barLabelLineHeight = _chartContext$chartVa.barLabelLineHeight, barLabelHorizontalMargin = _chartContext$chartVa.barLabelHorizontalMargin, barLabelBottomMargin = _chartContext$chartVa.barLabelBottomMargin, barLabelConfig = _chartContext$chartVa.barLabelConfig, xScale = _chartContext$chartVa.xScale;
                            var barConfig = barLabelConfig[seriesIndex][bar.index];
                            var maxWidth = chartContext.groupType === "grouped" ? barWidth : (barConfig.inset ? barWidth : xScale.bandwidth()) - 2 * barLabelHorizontalMargin;
                            var _textWrapByCharacter = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["textWrapByCharacter"])(d3__WEBPACK_IMPORTED_MODULE_1__, d3__WEBPACK_IMPORTED_MODULE_1__["select"](this), maxWidth, barLabelLineHeight, "px"), extraLines = _textWrapByCharacter.extraLines;
                            if (extraLines) {
                                barConfig.wrapped = true;
                                chartContext.chartVariables["".concat(type, "Wrapped")] = true;
                                barConfig["".concat(type, "Height")] = barLabelLineHeight * (extraLines + 1) + barLabelBottomMargin;
                                barConfig["".concat(type, "ExtraLines")] = extraLines;
                            }
                        }));
                    }
                }, {
                    key: "_addPrimaryLabels",
                    value: function _addPrimaryLabels(labelGroups, seriesIndex, attributes, formatter) {
                        var _this11 = this;
                        var primaryLabels = labelGroups.append("text").text(function(bar) {
                            _newArrowCheck(this, _this11);
                            return formatter(bar.value);
                        }.bind(this)).attr("y", function(bar) {
                            _newArrowCheck(this, _this11);
                            return this._generateBarLabelYOffset(bar, bar.index, seriesIndex);
                        }.bind(this)).attr("class", function(bar) {
                            _newArrowCheck(this, _this11);
                            return this._generateBarLabelClasses(bar, bar.index, seriesIndex);
                        }.bind(this));
                        Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["applyAttributes"])(primaryLabels, attributes);
                        this._wrapLabels(labelGroups.selectAll(".bar__label--primary"), seriesIndex, "primary");
                        if (this.chartVariables.primaryWrapped) {
                            primaryLabels.filter(function(bar) {
                                _newArrowCheck(this, _this11);
                                return this.chartVariables.barLabelConfig[seriesIndex][bar.index].wrapped;
                            }.bind(this)).attr("y", function(bar) {
                                _newArrowCheck(this, _this11);
                                return this._generateBarLabelYOffset(bar, bar.index, seriesIndex);
                            }.bind(this));
                            primaryLabels.attr("class", function(bar) {
                                _newArrowCheck(this, _this11);
                                return this._generateBarLabelClasses(bar, bar.index, seriesIndex);
                            }.bind(this));
                        }
                        return primaryLabels;
                    }
                }, {
                    key: "_generateBarLabelXOffset",
                    value: function _generateBarLabelXOffset(barIndex, seriesIndex) {
                        var barOffset = this._generateXOffset(barIndex, seriesIndex);
                        return barOffset + this.barWidth / 2;
                    }
                }, {
                    key: "_generateBarLabelYOffset",
                    value: function _generateBarLabelYOffset(bar, barIndex, seriesIndex) {
                        var isSecondary = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                        var _this$chartVariables5 = this.chartVariables, barLabelLineHeight = _this$chartVariables5.barLabelLineHeight, barLabelTextSize = _this$chartVariables5.barLabelTextSize, barLabelBottomMargin = _this$chartVariables5.barLabelBottomMargin, barLabelConfig = _this$chartVariables5.barLabelConfig;
                        var labelGroupConfig = barLabelConfig[seriesIndex][barIndex];
                        var isOffsetByOtherLabel = isSecondary && labelGroupConfig.inset || !isSecondary && !labelGroupConfig.inset && bar.secondaryLabel && this.groupType !== "stacked" && this.series.length <= 2;
                        var otherLabelOffset = labelGroupConfig[isSecondary ? "primaryHeight" : "secondaryHeight"] || barLabelLineHeight + barLabelBottomMargin;
                        var offsetFromOtherLabel = isOffsetByOtherLabel && otherLabelOffset || 0;
                        var barOffset = this._generateYOffset(bar, barIndex, seriesIndex);
                        var extraLineOffset = (labelGroupConfig[isSecondary ? "secondaryExtraLines" : "primaryExtraLines"] || 0) * barLabelLineHeight;
                        var lineHeightOffset = (barLabelLineHeight - barLabelTextSize) / 2;
                        var offset = barOffset - extraLineOffset - lineHeightOffset - barLabelBottomMargin - offsetFromOtherLabel;
                        var topOffset = offset - barLabelLineHeight + lineHeightOffset - (isSecondary ? barLabelLineHeight + barLabelBottomMargin : 0);
                        if (topOffset < 0 || labelGroupConfig.inset) {
                            offset = barOffset + barLabelTextSize + barLabelBottomMargin + offsetFromOtherLabel;
                            labelGroupConfig.inset = true;
                        }
                        offset -= this._paddingTop;
                        return offset;
                    }
                }, {
                    key: "_generateBarLabelClasses",
                    value: function _generateBarLabelClasses(bar, barIndex, seriesIndex) {
                        var isSecondary = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
                        var baseClass = "bar__label";
                        var projectionClass = bar.projection ? " ".concat(baseClass, "--projection") : "";
                        var typeClass = isSecondary ? " ".concat(baseClass, "--secondary") : " ".concat(baseClass, "--primary");
                        var insetClass = this.chartVariables.barLabelConfig[seriesIndex][barIndex].inset ? " ".concat(baseClass, "--inset") : "";
                        return "bar__label".concat(projectionClass).concat(insetClass).concat(typeClass);
                    }
                }, {
                    key: "_addBaseline",
                    value: function _addBaseline() {
                        var _this$chartVariables6 = this.chartVariables, xScale = _this$chartVariables6.xScale, yScale = _this$chartVariables6.yScale, svg = _this$chartVariables6.svg;
                        var _yScale$domain = yScale.domain(), _yScale$domain2 = _slicedToArray(_yScale$domain, 2), y0 = _yScale$domain2[0], y1 = _yScale$domain2[1];
                        if (y0 <= 0 && y1 >= 0) {
                            var _xScale$range = xScale.range(), _xScale$range2 = _slicedToArray(_xScale$range, 2), x0 = _xScale$range2[0], x1 = _xScale$range2[1];
                            var y = yScale(0);
                            svg.append("path").attr("class", "baseline").attr("d", "M".concat(x0, ",").concat(y, "L").concat(x1, ",").concat(y)).attr("transform", "translate(0, ".concat(this.chartVariables.xAxisHeight - this._paddingTop, ")"));
                        }
                    }
                }, {
                    key: "_renderLegend",
                    value: function _renderLegend() {
                        var _this12 = this;
                        var customWidthLegend = this.leftLegendWidth && this.legendPosition === "left";
                        var style = "width: ".concat(this.leftLegendWidth, ";");
                        var classes = _defineProperty({
                            "bar-chart__legend": true
                        }, "bar-chart__legend--".concat(this.legendPosition || "top"), true);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-hidden", "true");
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_6__["conditionalAttribute"])({
                            style: style
                        }, customWidthLegend));
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_6__["conditionalAttribute"])({
                            id: "legend-".concat(this.legendPosition)
                        }, this.legendPosition));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        _renderArbitrary(this.series.map(function(series) {
                            _newArrowCheck(this, _this12);
                            return _jsxWrapper(_span$wrapper, [ "background-color: ".concat(series.color), series.legendLabel ]);
                        }.bind(this)));
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_isEmpty",
                    value: function _isEmpty() {
                        var _this13 = this;
                        return !this.series || !this.series.some(function(series) {
                            _newArrowCheck(this, _this13);
                            return series.bars && series.bars.length;
                        }.bind(this));
                    }
                }, {
                    key: "_renderEmptyChart",
                    value: function _renderEmptyChart() {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__empty-chart"));
                        _renderArbitrary(this.noDataPointText);
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback(prop) {
                        var _this14 = this;
                        _get(_getPrototypeOf(MdsBarChart.prototype), "renderedCallback", this) && _get(_getPrototypeOf(MdsBarChart.prototype), "renderedCallback", this).call(this, prop);
                        if (this._isEmpty()) {
                            this.chartVariables.svg && this.chartVariables.svg.remove();
                            this.chartVariables.svg = null;
                        } else {
                            var isWidthChanged = !this.chartVariables.container || this.chartVariables.container.offsetWidth && this.chartVariables.container.offsetWidth !== this.chartVariables.width;
                            var container = this.shadowRoot.getElementById("chart-container");
                            var isChartDataChanged = !prop || prop.match(/(series|xAxisLabels|groupType|yAxis|barWidth|interBarWidth|d3BarLabelFormatString|hasBarLabels|chartHeight)/);
                            this.series.forEach(function(series) {
                                var _this15 = this;
                                _newArrowCheck(this, _this14);
                                if (this.groupType === "stacked") {
                                    series.bars.forEach(function(bar) {
                                        _newArrowCheck(this, _this15);
                                        if (bar.value < 0) {
                                            bar.value = 0;
                                        }
                                    }.bind(this));
                                }
                            }.bind(this));
                            if (container && (isWidthChanged || isChartDataChanged) && this.isConnected) {
                                setTimeout(function() {
                                    _newArrowCheck(this, _this14);
                                    this.renderChart(prop);
                                }.bind(this));
                            }
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _root, _dataContainer, _container;
                        var showLegend = this.series && this.series.length > 1 && !!this.groupType;
                        var classes = {
                            root: (_root = {}, _defineProperty(_root, "".concat(this.rootClass), true), _defineProperty(_root, "".concat(this.rootClass, "--").concat(this.chartSize), this.chartSize === true), 
                            _root),
                            dataContainer: (_dataContainer = {}, _defineProperty(_dataContainer, "".concat(this.rootClass, "__data-container"), true), 
                            _defineProperty(_dataContainer, "".concat(this.rootClass, "__data-container--").concat(this.legendPosition), showLegend && !!this.legendPosition), 
                            _dataContainer),
                            container: (_container = {}, _defineProperty(_container, "".concat(this.rootClass, "__chart-container"), true), 
                            _defineProperty(_container, "".concat(this.rootClass, "__chart-container--with-axis"), this.yAxis.visible), 
                            _container),
                            chartBody: _defineProperty({}, "".concat(this.rootClass, "__chart-body"), true)
                        };
                        var idAccessibleTitle = "".concat(this.id, "-accessible-title");
                        var isEmpty = this._isEmpty();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.root);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.chartBody);
                        _renderArbitrary(!isEmpty && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text", "role", "img", "aria-labelledby", idAccessibleTitle), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true", "id", idAccessibleTitle), 
                        _renderArbitrary(this.shortDescription), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.dataContainer);
                        _renderArbitrary(!isEmpty && showLegend && this._renderLegend());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes.container);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "chart-container");
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_6__["conditionalAttribute"])({
                            "aria-hidden": true
                        }, !this._isEmpty()));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("style", "height: ".concat(this.chartHeight, "px;"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        _renderArbitrary(isEmpty ? this._renderEmptyChart() : (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "bar-chart__svg-container", "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsBarChart;
            }(_abstract_chart__WEBPACK_IMPORTED_MODULE_4__["default"]), _class2.styles = _mds_bar_chart_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsBarChart;
        },
        "./src/bar-chart/mds-bar-chart.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/bar-chart/mds-bar-chart.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/bullet-chart/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_bullet_chart_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/bullet-chart/mds-bullet-chart.scss");
            var _mds_bullet_chart_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_bullet_chart_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/data-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, numberRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].numberRequired, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired;
            var entity = {
                accessibleName: stringRequired,
                accessibleDescription: string,
                benchmark: numberRequired,
                featuredMeasure: numberRequired,
                maxValue: numberRequired
            };
            var tokens = {
                featuredMeasureMaxHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("60px"),
                featuredMeasureMinHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("2px"),
                benchmarkMaxHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("42px"),
                benchmarkMinHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("4px"),
                plotAreaWidth: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("96px"),
                referenceLineThickness: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("1px"),
                referenceLineDashLength: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("1px")
            };
            var svgViewBoxWidth = tokens.plotAreaWidth + 3;
            var MdsBulletChart = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsBulletChart, _AgaveComponent);
                function MdsBulletChart() {
                    _classCallCheck(this, MdsBulletChart);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsBulletChart).apply(this, arguments));
                }
                _createClass(MdsBulletChart, [ {
                    key: "_getbenchmarkHeight",
                    value: function _getbenchmarkHeight() {
                        var calculatedBenchmarkHeight = this.benchmark * (tokens.featuredMeasureMaxHeight / this.maxValue) < tokens.benchmarkMinHeight ? tokens.benchmarkMinHeight : this.benchmark * (tokens.featuredMeasureMaxHeight / this.maxValue);
                        return calculatedBenchmarkHeight > tokens.benchmarkMaxHeight ? tokens.benchmarkMaxHeight : calculatedBenchmarkHeight;
                    }
                }, {
                    key: "_getfeaturedMeasureHeight",
                    value: function _getfeaturedMeasureHeight() {
                        if (this.featuredMeasure > 0) {
                            var calculatedfeaturedMeasureHeight = this.featuredMeasure * (tokens.featuredMeasureMaxHeight / this.maxValue) < tokens.featuredMeasureMinHeight ? tokens.featuredMeasureMinHeight : this.featuredMeasure * (tokens.featuredMeasureMaxHeight / this.maxValue);
                            return calculatedfeaturedMeasureHeight > tokens.featuredMeasureMaxHeight ? tokens.featuredMeasureMaxHeight : calculatedfeaturedMeasureHeight;
                        }
                        return 0;
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var variant = this.featuredMeasure < this.benchmark ? "critical" : "success";
                        var benchmarkClasses = _defineProperty({
                            "bullet-chart__benchmark": true
                        }, "bullet-chart__benchmark--".concat(variant), true);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "bullet-chart");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                        _renderArbitrary(this.accessibleName);
                        _renderArbitrary(this.accessibleDescription);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "bullet-chart__reference-line");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("svg", null, null, "width", "".concat(tokens.plotAreaWidth, "px"), "height", "".concat(tokens.referenceLineThickness, "px"), "viewBox", "0 0 ".concat(svgViewBoxWidth, " 1"), "xmlns", "http://www.w3.org/2000/svg");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("line", null, null, "x1", "0", "y1", "1", "x2", svgViewBoxWidth, "y2", "1", "stroke", "black", "stroke-dasharray", "3");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("svg");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", benchmarkClasses, "style", {
                            height: "".concat(this._getbenchmarkHeight(), "px")
                        });
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "bullet-chart__featured-measure", "style", {
                            height: "".concat(this._getfeaturedMeasureHeight(), "px")
                        });
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsBulletChart";
                    }
                } ]);
                return MdsBulletChart;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_bullet_chart_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsBulletChart;
        },
        "./src/bullet-chart/mds-bullet-chart.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/bullet-chart/mds-bullet-chart.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/cash-flow-chart/CashFlowChart.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            function renderLegendItem(itemData) {
                if (this._seriesArray && JSON.stringify(this._seriesArray) !== "{}") {
                    var legendValue = this.chartVariables.dataPointDetailYFormatter(itemData === "net" ? this._seriesArray[itemData][this.selectedIndex] : Math.abs(this._seriesArray[itemData][this.selectedIndex]));
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "cash-flow-chart__legend-item");
                    _renderArbitrary(itemData !== "net" && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "cash-flow-chart__swatch-square cash-flow-chart__swatch-square--".concat(itemData)));
                    _renderArbitrary(itemData === "net" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "cash-flow-chart__swatch-wrapper"), 
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "cash-flow-chart__swatch-circle"), 
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "cash-flow-chart__swatch-line"), 
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "cash-flow-chart__legend-key");
                    _renderArbitrary(this.series[itemData].label);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "cash-flow-chart__legend-value");
                    _renderArbitrary(legendValue);
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                }
            }
            function CashFlowChart() {
                if (Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["isNonZeroFalsy"])(this.selectedIndex)) {
                    this.selectedIndex = this.xAxisLabels.length - 1;
                }
                var isEmpty = this._isEmpty();
                var idAccessibleTitle = "".concat(this.id, "-accessible-title");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "cash-flow-chart");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "cash-flow-chart__chart-body");
                _renderArbitrary(!isEmpty && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text", "role", "img", "aria-labelledby", idAccessibleTitle), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true", "id", idAccessibleTitle), 
                _renderArbitrary(this.shortDescription), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "cash-flow-chart__data-container");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "cash-flow-chart__chart-container");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "chart-container");
                _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_1__["conditionalAttribute"])({
                    "aria-hidden": true
                }, !isEmpty));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                _renderArbitrary(isEmpty ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "cash-flow-chart__empty-chart"), 
                _renderArbitrary(this.noDataPointText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")) : (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "cash-flow-chart__svg-container", "__skip", "true"), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                _renderArbitrary(!isEmpty && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "cash-flow-chart__legend-container", "aria-hidden", "true"), 
                _renderArbitrary(this.legendTitle && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "cash-flow-chart__legend-heading"), 
                _renderArbitrary(this.legendTitle), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div"))), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "cash-flow-chart__legend-items-container"), 
                _renderArbitrary(this.constructor._legendItems.map(renderLegendItem.bind(this))), 
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
            }
            __webpack_exports__["default"] = CashFlowChart;
        },
        "./src/cash-flow-chart/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "dataEntity", (function() {
                return dataEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "seriesEntity", (function() {
                return seriesEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "axisEntity", (function() {
                return axisEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "axisLabelEntity", (function() {
                return axisLabelEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var d3__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d3");
            var d3__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(d3__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_cash_flow_chart_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/cash-flow-chart/mds-cash-flow-chart.scss");
            var _mds_cash_flow_chart_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_cash_flow_chart_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _abstract_chart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/abstract-chart/index.jsx");
            var _CashFlowChart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/cash-flow-chart/CashFlowChart.jsx");
            var _utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/chart-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/data-utils.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/common-utils.js");
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _slicedToArray(arr, i) {
                return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
            }
            function _nonIterableRest() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _iterableToArrayLimit(arr, i) {
                var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
                if (null != _i) {
                    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
                    try {
                        if (_x = (_i = _i.call(arr)).next, 0 === i) {
                            if (Object(_i) !== _i) return;
                            _n = !1;
                        } else for (;!(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) ;
                    } catch (err) {
                        _d = !0, _e = err;
                    } finally {
                        try {
                            if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
                        } finally {
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
            }
            function _arrayWithHoles(arr) {
                if (Array.isArray(arr)) return arr;
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["mixins"].AttributeMarshallingMixin, string = _mixins$AttributeMars.string, number = _mixins$AttributeMars.number, arrayOf = _mixins$AttributeMars.arrayOf, satisfies = _mixins$AttributeMars.satisfies, stringRequired = _mixins$AttributeMars.stringRequired, numberRequired = _mixins$AttributeMars.numberRequired;
            var dataEntity = {
                width: number,
                label: stringRequired,
                value: arrayOf(numberRequired).withMinLength(2).withMaxLength(12)
            };
            var seriesEntity = {
                inflows: satisfies(dataEntity),
                outflows: satisfies(dataEntity),
                net: satisfies(dataEntity)
            };
            var axisEntity = {
                numTickLabels: number.defaultsTo(7).withMinSize(2),
                range: arrayOf(number).withMaxLength(2).withMinLength(2),
                d3TickFormatString: string
            };
            var axisLabelEntity = {
                label: stringRequired
            };
            var entity = _objectSpread({}, _abstract_chart__WEBPACK_IMPORTED_MODULE_3__["entity"], {
                series: satisfies(seriesEntity),
                selectedIndex: number.withChangedCallback(),
                yAxis: satisfies(axisEntity),
                xAxisLabels: arrayOf(satisfies(axisLabelEntity)).withMinLength(2).withMaxLength(12),
                legendTitle: string,
                d3LegendFormatString: string
            });
            var tokens = {
                chartMinWidth: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("240px"),
                chartTrailingPadding: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px"),
                chartLeadingPadding: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px"),
                xAxisMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("4px"),
                yAxisLeadingMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("4px"),
                yAxisTopMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("8px"),
                yAxisBottomMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("8px"),
                xAxisTickLabelHorizontalMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("4px"),
                xAxisTickLineHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("1.25rem"),
                barWidth: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("32px")
            };
            var MdsCashFlowChart = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractChart) {
                _inherits(MdsCashFlowChart, _AbstractChart);
                _createClass(MdsCashFlowChart, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsCashFlowChart";
                    }
                } ]);
                function MdsCashFlowChart(props) {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsCashFlowChart);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsCashFlowChart).call(this, props));
                    _this._getXAxisLabel = function(condition, index, label) {
                        _newArrowCheck(this, _this2);
                        if (condition) {
                            return Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_7__["isEven"])(index) ? label : "";
                        }
                        return label;
                    }.bind(this);
                    _this._handleClick = _this._handleClick.bind(_assertThisInitialized(_this));
                    _this.defineObservedProperty("_seriesArray");
                    _extends(_this.chartVariables, tokens);
                    return _this;
                }
                _createClass(MdsCashFlowChart, [ {
                    key: "selectedIndexChangedCallback",
                    value: function selectedIndexChangedCallback(_, oldValue) {
                        var _this3 = this;
                        if (this.chartVariables.svg) {
                            this.constructor._barTypes.forEach(function(type) {
                                _newArrowCheck(this, _this3);
                                this._selectBar(type, oldValue);
                            }.bind(this));
                        }
                    }
                }, {
                    key: "_selectBar",
                    value: function _selectBar(type, oldValue) {
                        var seriesSVG = this.chartVariables.svg.select(".cash-flow-chart__graph-area");
                        seriesSVG.select("#".concat(type, "-").concat(this.selectedIndex)).attr("class", "rect-".concat(type, "--selected"));
                        seriesSVG.select("#".concat(type, "-").concat(oldValue)).attr("class", "rect-".concat(type));
                        seriesSVG.selectAll("circle").remove();
                        this._renderDot(seriesSVG);
                    }
                }, {
                    key: "renderChart",
                    value: function renderChart() {
                        if (this._isEmpty()) {
                            return;
                        }
                        this._setDimensionVariables();
                        this._createSVG();
                        this._addAxes();
                        this._addBars();
                        this._addBaseline();
                        this._renderLine();
                    }
                }, {
                    key: "_setDimensionVariables",
                    value: function _setDimensionVariables() {
                        this.chartVariables.container = this.shadowRoot.getElementById("chart-container");
                        this.chartVariables.width = this.chartVariables.container && this.chartVariables.container.offsetWidth || this._getDefaultWidth();
                        this.chartVariables.height = this.chartHeight;
                        if (!this.chartVariables.dataPointDetailYFormatter) {
                            this.chartVariables.dataPointDetailYFormatter = this.d3LegendFormatString ? d3__WEBPACK_IMPORTED_MODULE_0__["format"](this.d3LegendFormatString) : "";
                        }
                    }
                }, {
                    key: "_getDefaultWidth",
                    value: function _getDefaultWidth() {
                        var _this$chartVariables = this.chartVariables, chartTrailingPadding = _this$chartVariables.chartTrailingPadding, chartLeadingPadding = _this$chartVariables.chartLeadingPadding, chartMinWidth = _this$chartVariables.chartMinWidth;
                        var legendWidth = 0;
                        var padding = chartLeadingPadding + chartTrailingPadding;
                        var chartWidth = this.offsetWidth - padding;
                        if (this.showLegend && this.legendPosition === "left") {
                            legendWidth = this._getLegendLeftWidth(chartWidth);
                        }
                        return Math.max(chartMinWidth, chartWidth - legendWidth);
                    }
                }, {
                    key: "_createSVG",
                    value: function _createSVG() {
                        this.chartVariables.svg && this.chartVariables.svg.remove();
                        var svgContainer = this.shadowRoot.querySelector(".cash-flow-chart__svg-container");
                        if (svgContainer && svgContainer.hasChildNodes()) {
                            var numChildNodes = svgContainer.childNodes.length;
                            for (var i = 0; i < numChildNodes; i++) {
                                var currentNode = svgContainer.childNodes[i];
                                if (!currentNode.hasChildNodes()) {
                                    currentNode.style.display = "none";
                                }
                            }
                        }
                        this.chartVariables.svg = d3__WEBPACK_IMPORTED_MODULE_0__["select"](svgContainer).append("svg").attr("width", this.chartVariables.width).attr("height", this.chartVariables.height).append("g").attr("transform", "translate(".concat(this.chartVariables.yAxisTopMargin, ", ").concat(this.chartVariables.yAxisBottomMargin * 2, ")"));
                    }
                }, {
                    key: "_addAxes",
                    value: function _addAxes() {
                        this.chartVariables.yAxisWidth = this._addYAxis(this.chartVariables.xAxisMargin);
                        var newXAxisHeight = this._addXAxis();
                        if (newXAxisHeight !== this.chartVariables.xAxisHeight) {
                            this.chartVariables.yAxis && this.chartVariables.yAxis.remove();
                            this.chartVariables.yAxisWidth = this._addYAxis(newXAxisHeight);
                        }
                    }
                }, {
                    key: "_addYAxis",
                    value: function _addYAxis(xAxisHeight) {
                        var _this4 = this;
                        this.chartVariables.xAxisHeight = xAxisHeight;
                        this.chartVariables.yAxisHeight = this.chartVariables.height - xAxisHeight;
                        var range = [ this.chartVariables.yAxisHeight, 0 ];
                        this.chartVariables.yScale = d3__WEBPACK_IMPORTED_MODULE_0__["scaleLinear"]().domain(this.yAxis.range).range(range);
                        var domainAndLineOffset = 9;
                        var axis = d3__WEBPACK_IMPORTED_MODULE_0__["axisRight"](this.chartVariables.yScale);
                        this._specifyTicks(axis);
                        axis.tickFormat(Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["getFormatter"])(d3__WEBPACK_IMPORTED_MODULE_0__, this, this.yAxis.d3TickFormatString));
                        this.chartVariables.yAxis = this.chartVariables.svg.append("g").attr("class", "y-axis").attr("transform", "translate(".concat(this.chartVariables.width - domainAndLineOffset, ", 0)")).call(axis).call(function(g) {
                            _newArrowCheck(this, _this4);
                            return g.select(".domain").remove();
                        }.bind(this)).call(function(g) {
                            _newArrowCheck(this, _this4);
                            return g.selectAll("line").remove();
                        }.bind(this));
                        this.chartVariables.yAxis.selectAll("text").attr("class", function(d) {
                            _newArrowCheck(this, _this4);
                            if (d < 0) {
                                return "y-axis__text--neg";
                            } else if (d === 0) {
                                return "y-axis__text y-axis__text--zero";
                            } else {
                                return "y-axis__text";
                            }
                        }.bind(this)).style("text-anchor", "end");
                        if (MDS.isFireFox) {
                            return Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["getLargestTextWidth"])(this.chartVariables.yAxis, "text");
                        }
                        return this.chartVariables.yAxis.node().getBBox().width;
                    }
                }, {
                    key: "_specifyTicks",
                    value: function _specifyTicks(axis) {
                        var _this$yAxis = this.yAxis, numTickLabels = _this$yAxis.numTickLabels, range = _this$yAxis.range;
                        if (numTickLabels) {
                            var ticks = [];
                            var zeroIndex;
                            var increment = Math.abs((range[1] - range[0]) / numTickLabels);
                            for (var i = 0; i < numTickLabels; i += 1) {
                                var tick = range[0] + increment * (i + 1);
                                if (tick !== 0 && Math.abs(tick) - increment < 0 && ticks[ticks.length - 1] !== 0) {
                                    tick = 0;
                                    zeroIndex = i;
                                }
                                ticks.push(tick);
                            }
                            for (var _i = zeroIndex - 1; _i >= 0; _i -= 1) {
                                ticks[_i] = ticks[_i + 1] - increment;
                            }
                            for (var _i2 = zeroIndex + 1; _i2 < numTickLabels; _i2 += 1) {
                                ticks[_i2] = ticks[_i2 - 1] + increment;
                            }
                            axis.tickValues(ticks);
                        }
                    }
                }, {
                    key: "_addXAxis",
                    value: function _addXAxis() {
                        var _this5 = this;
                        var _this$chartVariables2 = this.chartVariables, yAxis = _this$chartVariables2.yAxis, yAxisWidth = _this$chartVariables2.yAxisWidth, yAxisLeadingMargin = _this$chartVariables2.yAxisLeadingMargin, width = _this$chartVariables2.width, xAxisMargin = _this$chartVariables2.xAxisMargin;
                        var newXAxisHeight = xAxisMargin;
                        var yAxisOffset = yAxis ? yAxisWidth + yAxisLeadingMargin : 0;
                        this.chartVariables.xScale = d3__WEBPACK_IMPORTED_MODULE_0__["scaleBand"](this.xAxisLabels.map(function(label) {
                            _newArrowCheck(this, _this5);
                            return label.label;
                        }.bind(this)), [ 0, width - yAxisOffset ]);
                        newXAxisHeight += this._renderXAxis(this.chartVariables.xScale, newXAxisHeight);
                        return newXAxisHeight;
                    }
                }, {
                    key: "_renderXAxis",
                    value: function _renderXAxis(xScale, axisOffset) {
                        var _this6 = this;
                        var _this$chartVariables3 = this.chartVariables, height = _this$chartVariables3.height, svg = _this$chartVariables3.svg, xAxisTickLineHeight = _this$chartVariables3.xAxisTickLineHeight, xAxisTickLabelHorizontalMargin = _this$chartVariables3.xAxisTickLabelHorizontalMargin;
                        var axis = d3__WEBPACK_IMPORTED_MODULE_0__["axisBottom"](xScale);
                        var axisHeight = xAxisTickLineHeight;
                        var axisGroup = svg.append("g").attr("class", "x-axis").call(axis).call(function(g) {
                            _newArrowCheck(this, _this6);
                            return g.select(".domain").remove();
                        }.bind(this)).call(function(g) {
                            _newArrowCheck(this, _this6);
                            return g.selectAll("line").remove();
                        }.bind(this));
                        var xTicks = axisGroup.selectAll("text").text(function(label, index, arr) {
                            _newArrowCheck(this, _this6);
                            var isMobile = MDS.isMobile;
                            var isMoreThan8Ticks = arr.length > 8;
                            var condition = isMobile && isMoreThan8Ticks;
                            return this._getXAxisLabel(condition, index, label);
                        }.bind(this));
                        var maxWidth = xScale.bandwidth() - 2 * xAxisTickLabelHorizontalMargin;
                        var _textWrap = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["textWrap"])(d3__WEBPACK_IMPORTED_MODULE_0__, xTicks, maxWidth, xAxisTickLineHeight, "", false, true), extraLines = _textWrap.extraLines;
                        axisHeight += extraLines * xAxisTickLineHeight;
                        axisGroup.attr("transform", "translate(0, ".concat(height - axisHeight - axisOffset, ")"));
                        return axisHeight;
                    }
                }, {
                    key: "_addBars",
                    value: function _addBars() {
                        var _this7 = this;
                        var seriesSVG = this.chartVariables.svg.append("g").attr("class", "cash-flow-chart__graph-area");
                        var updateFlow = function updateFlow(flowArray) {
                            _newArrowCheck(this, _this7);
                            var flowLength = flowArray.length;
                            for (var i = 0; i < flowLength; i++) {
                                var inRange = flowArray[i] >= this.yAxis.range[0] && flowArray[i] <= this.yAxis.range[1];
                                if (!inRange) {
                                    flowArray[i] = 0;
                                }
                            }
                        }.bind(this);
                        if (!this._seriesArray) {
                            this._seriesArray = {};
                            if (this.series.inflows.values.length > this.xAxisLabels.length) {
                                this._valuesLarger = true;
                                this._seriesArray = {
                                    inflows: this.series.inflows.values.slice(-this.xAxisLabels.length),
                                    outflows: this.series.outflows.values.slice(-this.xAxisLabels.length),
                                    net: this.series.net.values.slice(-this.xAxisLabels.length)
                                };
                            } else {
                                this._valuesLarger = false;
                                this._seriesArray = {
                                    inflows: this.series.inflows.values,
                                    outflows: this.series.outflows.values,
                                    net: this.series.net.values
                                };
                            }
                            updateFlow(this._seriesArray.inflows);
                            updateFlow(this._seriesArray.outflows);
                        }
                        this.constructor._legendItems.forEach(function(key) {
                            _newArrowCheck(this, _this7);
                            if (key === "inflows" || key === "outflows") {
                                this._renderBar(this._seriesArray, key, seriesSVG);
                            }
                        }.bind(this));
                        return seriesSVG;
                    }
                }, {
                    key: "_renderBar",
                    value: function _renderBar(series, key, seriesSVG) {
                        var _this8 = this;
                        seriesSVG.selectAll("rect-".concat(key)).data(series[key]).join("rect").attr("class", function(_, i) {
                            _newArrowCheck(this, _this8);
                            return i === this.selectedIndex ? "rect-".concat(key, "--selected") : "rect-".concat(key);
                        }.bind(this)).attr("x", function(_, i) {
                            _newArrowCheck(this, _this8);
                            return this._generateXOffset(i);
                        }.bind(this)).attr("y", function(bar) {
                            _newArrowCheck(this, _this8);
                            return this.chartVariables.yScale(Math.max(0, bar));
                        }.bind(this)).attr("height", function(bar) {
                            _newArrowCheck(this, _this8);
                            return Math.abs(this.chartVariables.yScale(0) - this.chartVariables.yScale(bar));
                        }.bind(this)).attr("id", function(_, i) {
                            _newArrowCheck(this, _this8);
                            return "".concat(key, "-").concat(i);
                        }.bind(this)).on("click", this._handleClick).on("touchstart", this._handleClick);
                    }
                }, {
                    key: "_handleClick",
                    value: function _handleClick() {
                        this.selectedIndex = d3__WEBPACK_IMPORTED_MODULE_0__["event"].target.id.match(/(\d+)/)[0];
                    }
                }, {
                    key: "_renderLine",
                    value: function _renderLine() {
                        var _this9 = this;
                        var seriesSVG = this.chartVariables.svg.select(".cash-flow-chart__graph-area");
                        var lineGenerator = d3__WEBPACK_IMPORTED_MODULE_0__["line"]().x(function(_, i) {
                            _newArrowCheck(this, _this9);
                            var labelIndex = this._valuesLarger ? i - 1 : i;
                            var xAxisLabel = this._valuesLarger && i === 0 ? 0 : this.chartVariables.xScale(this.xAxisLabels[labelIndex].label) + this.chartVariables.xScale.bandwidth() / 2;
                            return xAxisLabel;
                        }.bind(this)).y(function(d) {
                            _newArrowCheck(this, _this9);
                            return this.chartVariables.yScale(d);
                        }.bind(this));
                        var borderGenerator = function borderGenerator() {
                            var _this10 = this;
                            _newArrowCheck(this, _this9);
                            return d3__WEBPACK_IMPORTED_MODULE_0__["line"]().x(function(_, i) {
                                _newArrowCheck(this, _this10);
                                var labelIndex = this._valuesLarger ? i - 1 : i;
                                var xAxisLabel = this._valuesLarger && i === 0 ? 0 : this.chartVariables.xScale(this.xAxisLabels[labelIndex].label) + this.chartVariables.xScale.bandwidth() / 2;
                                return xAxisLabel;
                            }.bind(this)).y(function(d) {
                                _newArrowCheck(this, _this10);
                                return this.chartVariables.yScale(d);
                            }.bind(this));
                        }.bind(this);
                        var lineData = this._seriesArray.net;
                        if (this._valuesLarger) {
                            lineData = this.series.net.values.slice(-(this.xAxisLabels.length + 1));
                        }
                        seriesSVG.append("path").datum(lineData).attr("d", borderGenerator()).attr("class", "borderline");
                        seriesSVG.append("path").datum(lineData).attr("d", lineGenerator).attr("class", "line");
                        this._renderDot(seriesSVG);
                    }
                }, {
                    key: "_renderDot",
                    value: function _renderDot(seriesSVG) {
                        var _this11 = this;
                        seriesSVG.append("circle").datum(this._seriesArray.net[this.selectedIndex]).attr("cx", function() {
                            _newArrowCheck(this, _this11);
                            return this.chartVariables.xScale(this.xAxisLabels[this.selectedIndex].label) + this.chartVariables.xScale.bandwidth() / 2;
                        }.bind(this)).attr("cy", function(d) {
                            _newArrowCheck(this, _this11);
                            return this.chartVariables.yScale(d);
                        }.bind(this)).attr("r", Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("10px") / 2 + Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("1px")).attr("class", "dot");
                    }
                }, {
                    key: "_generateXOffset",
                    value: function _generateXOffset(barIndex) {
                        var bandOffset = this.chartVariables.xScale(this.xAxisLabels[barIndex].label);
                        var widthOffset = this.chartVariables.xScale.bandwidth() / 2 - this.chartVariables.barWidth / 2;
                        return bandOffset + widthOffset;
                    }
                }, {
                    key: "_addBaseline",
                    value: function _addBaseline() {
                        var _this$chartVariables4 = this.chartVariables, xScale = _this$chartVariables4.xScale, yScale = _this$chartVariables4.yScale, svg = _this$chartVariables4.svg;
                        var _yScale$domain = yScale.domain(), _yScale$domain2 = _slicedToArray(_yScale$domain, 2), y0 = _yScale$domain2[0], y1 = _yScale$domain2[1];
                        if (y0 <= 0 && y1 >= 0) {
                            var _xScale$range = xScale.range(), _xScale$range2 = _slicedToArray(_xScale$range, 2), x0 = _xScale$range2[0], x1 = _xScale$range2[1];
                            var y = yScale(0);
                            svg.select(".cash-flow-chart__graph-area").append("path").attr("class", "baseline").attr("d", "M".concat(x0, ",").concat(y, "L").concat(x1, ",").concat(y));
                        }
                    }
                }, {
                    key: "_isEmpty",
                    value: function _isEmpty() {
                        var noSeries = !this.series || !(this.series.inflows && this.series.inflows.values.length > 0);
                        var noRange = this.yAxis && this.yAxis.range[0] === this.yAxis.range[1];
                        return noSeries || noRange;
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback(prop) {
                        var _this12 = this;
                        _get(_getPrototypeOf(MdsCashFlowChart.prototype), "renderedCallback", this) && _get(_getPrototypeOf(MdsCashFlowChart.prototype), "renderedCallback", this).call(this, prop);
                        if (this._isEmpty()) {
                            this.chartVariables.svg && this.chartVariables.svg.remove();
                            this.chartVariables.svg = null;
                        } else {
                            var isWidthChanged = !this.chartVariables.container || this.chartVariables.container.offsetWidth && this.chartVariables.container.offsetWidth !== this.chartVariables.width;
                            var container = this.shadowRoot.getElementById("chart-container");
                            var lastChild = container.lastChild;
                            var isChartDataChanged = !prop || prop.match(/(series|xAxisLabels|yAxis|d3LegendFormatString|)/);
                            if (container.lastChild && (isWidthChanged || isChartDataChanged) && this.isConnected) {
                                setTimeout(function() {
                                    _newArrowCheck(this, _this12);
                                    this.renderChart(prop);
                                }.bind(this));
                            }
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        _CashFlowChart__WEBPACK_IMPORTED_MODULE_4__["default"].call(this);
                    }
                } ]);
                return MdsCashFlowChart;
            }(_abstract_chart__WEBPACK_IMPORTED_MODULE_3__["default"]), _class2.styles = _mds_cash_flow_chart_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2._barTypes = [ "inflows", "outflows" ], _class2._legendItems = [ "net", "inflows", "outflows" ], 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsCashFlowChart;
        },
        "./src/cash-flow-chart/mds-cash-flow-chart.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/cash-flow-chart/mds-cash-flow-chart.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/donut-chart/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var d3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d3");
            var d3__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(d3__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_2__);
            var _mds_donut_chart_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/donut-chart/mds-donut-chart.scss");
            var _mds_donut_chart_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_donut_chart_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _abstract_chart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/abstract-chart/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/data-utils.js");
            var _utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/chart-utils.js");
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_2__["mixins"].AttributeMarshallingMixin, arrayOf = _mixins$AttributeMars.arrayOf, boolean = _mixins$AttributeMars.boolean, number = _mixins$AttributeMars.number, numberRequired = _mixins$AttributeMars.numberRequired, satisfies = _mixins$AttributeMars.satisfies, string = _mixins$AttributeMars.string;
            var strokeWidth = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("2px");
            var leadingPadding = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px");
            var containerBottomPadding = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px");
            var chartSizeLookup = {
                small: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("24px"),
                medium: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("32px"),
                large: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("40px")
            };
            var segmentEntity = {
                value: number.or(string),
                color: string
            };
            var entity = _objectSpread({}, _abstract_chart__WEBPACK_IMPORTED_MODULE_4__["entity"], {
                chartHeight: numberRequired.withMinSize(Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("120px")).defaultsTo(Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("120px")).withChangedCallback(),
                sortSegments: boolean.defaultsTo(false).withChangedCallback(),
                segments: arrayOf(satisfies(segmentEntity)).withChangedCallback(),
                interactive: boolean.defaultsTo(false),
                selectedIndex: number
            });
            var MdsDonutChart = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_2__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractChart) {
                _inherits(MdsDonutChart, _AbstractChart);
                _createClass(MdsDonutChart, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsDonutChart";
                    }
                } ]);
                function MdsDonutChart() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsDonutChart);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsDonutChart).call(this));
                    _this._changeCenterTextDisplayOrder = function() {
                        _newArrowCheck(this, _this2);
                        var paths = _this.shadowRoot.querySelector(".donut-chart__actual-svg").childNodes[0];
                        var content = _this.shadowRoot.querySelector(".donut-chart__actual-svg").childNodes[1];
                        _this.shadowRoot.querySelector(".donut-chart__actual-svg").appendChild(content);
                        _this.shadowRoot.querySelector(".donut-chart__actual-svg").appendChild(paths);
                    }.bind(this);
                    _this.rootClass = "donut-chart";
                    _this.defineObservedProperty("changeSegmentFn", function(_) {
                        _newArrowCheck(this, _this2);
                        return _;
                    }.bind(this));
                    _this.defineObservedProperty("hoverSegmentFn", function(_) {
                        _newArrowCheck(this, _this2);
                        return _;
                    }.bind(this));
                    _this.defineObservedProperty("hoverOutSegmentFn", function(_) {
                        _newArrowCheck(this, _this2);
                        return _;
                    }.bind(this));
                    _this.defineObservedProperty("connectedFlag", false);
                    _this.isOpeningCache = {};
                    _this.changeSegmentCache = {
                        currentD: null,
                        previousD: null
                    };
                    _this._mouseoverSegment = _this._mouseoverSegment.bind(_assertThisInitialized(_this));
                    _this._mouseoutSegment = _this._mouseoutSegment.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsDonutChart, [ {
                    key: "chartHeightChangedCallback",
                    value: function chartHeightChangedCallback(newValue) {
                        this._setDimensionVariables();
                    }
                }, {
                    key: "renderChart",
                    value: function renderChart() {
                        if (this._isEmpty()) {
                            this._adjustEmptyChart();
                            return;
                        }
                        if (this._noDisplayData()) {
                            this._adjustNoDisplayDataChart();
                            return;
                        }
                        this._setDimensionVariables();
                        var additionalTranslate = this.chartVariables.additionalTranslate ? this.chartVariables.additionalTranslate + 2 * strokeWidth : 0;
                        this._createSVG(additionalTranslate);
                        this._addSegments(this.chartVariables.svg);
                        this._addCenterText(this.chartVariables.actualSvg, additionalTranslate);
                        this._changeCenterTextDisplayOrder();
                    }
                }, {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        _get(_getPrototypeOf(MdsDonutChart.prototype), "connectedCallback", this).call(this);
                        this.connectedFlag = true;
                        if (this.selectedIndex && !this._noDisplayData() && this.selectedIndex >= 0 && this.selectedIndex < this.segments.length) {
                            this.growArc(this.selectedIndex);
                        }
                    }
                }, {
                    key: "sortSegmentsChangedCallback",
                    value: function sortSegmentsChangedCallback() {
                        this.connectedFlag && this._sortData();
                        this.isOpeningCache = {};
                    }
                }, {
                    key: "segmentsChangedCallback",
                    value: function segmentsChangedCallback() {
                        var _this3 = this;
                        if (!this.segments || Array.isArray(this.segments) && this.segments.length === 0) {
                            this.sortSegments = this.sortSegments || false;
                            return;
                        }
                        this.data = this.segments.filter(function(x) {
                            _newArrowCheck(this, _this3);
                            return x.value > 0;
                        }.bind(this));
                        this._sortData();
                    }
                }, {
                    key: "_sortData",
                    value: function _sortData() {
                        var _this4 = this;
                        if (this.sortSegments) {
                            var dataDescending = this.data.sort(function(a, b) {
                                _newArrowCheck(this, _this4);
                                return b.value - a.value;
                            }.bind(this));
                            var presortedData = new Array(dataDescending.length);
                            dataDescending.forEach(function(curVal, i) {
                                _newArrowCheck(this, _this4);
                                var newIndex = i % 2 === 0 ? i / 2 : dataDescending.length - Math.ceil(i / 2);
                                presortedData[newIndex] = curVal;
                            }.bind(this));
                            var sortSegmentsFn = d3__WEBPACK_IMPORTED_MODULE_1__["pie"]().sort(null).value(function(d) {
                                _newArrowCheck(this, _this4);
                                return d.value;
                            }.bind(this));
                            this.chartVariables.data_sorted = sortSegmentsFn(presortedData);
                        } else {
                            var _sortSegmentsFn = d3__WEBPACK_IMPORTED_MODULE_1__["pie"]().sort(null).value(function(d) {
                                _newArrowCheck(this, _this4);
                                return d.value;
                            }.bind(this));
                            this.chartVariables.data_sorted = _sortSegmentsFn(this.data);
                        }
                    }
                }, {
                    key: "_resizeRerender",
                    value: function _resizeRerender() {
                        if (this.chartVariables.container) {
                            var isWidthChanged = this.chartVariables.container.offsetWidth !== this.chartVariables.width;
                            this._isEmpty() ? this._adjustEmptyChart() : isWidthChanged && this.renderChart();
                        }
                    }
                }, {
                    key: "_setDimensionVariables",
                    value: function _setDimensionVariables() {
                        this.chartVariables.container = this.chartVariables.container || this.shadowRoot.getElementById("chart-container");
                        this.chartVariables.width = this.chartVariables.height = this.chartHeight;
                        var _this$chartVariables = this.chartVariables, width = _this$chartVariables.width, height = _this$chartVariables.height;
                        this.chartVariables.svgSquareSideSize = Math.min(width, height);
                        this.chartVariables.maxVisualExpandedDiameter = Math.min(width, height + containerBottomPadding) - 2 * strokeWidth;
                        this.chartVariables.visualHoverOuterRadius = this.chartVariables.maxVisualExpandedDiameter / 2;
                        this.chartVariables.visualOuterRadius = this.chartVariables.visualHoverOuterRadius / 1.05 - strokeWidth;
                        var _this$chartVariables2 = this.chartVariables, visualHoverOuterRadius = _this$chartVariables2.visualHoverOuterRadius, visualOuterRadius = _this$chartVariables2.visualOuterRadius;
                        this.chartVariables.additionalTranslate = !this.interactive ? 0 : Math.max(0, visualHoverOuterRadius - visualOuterRadius - leadingPadding - strokeWidth);
                        if (this.chartVariables.additionalTranslate === 0) {
                            this.chartVariables.visualOuterRadius = this.chartVariables.svgSquareSideSize / 2;
                            this.chartVariables.visualHoverOuterRadius = this.chartVariables.visualOuterRadius * 1.05;
                        }
                        var visualOuterDiameter = this.chartVariables.visualHoverOuterRadius * 2;
                        if (visualOuterDiameter >= 280) {
                            this.chartSize = "large";
                        } else if (visualOuterDiameter >= 160) {
                            this.chartSize = "medium";
                        } else if (visualOuterDiameter >= 120) {
                            this.chartSize = "small";
                        } else {
                            this.chartSize = this.chartVariables.width === 0 ? "large" : "invalidSize";
                        }
                        this.chartVariables.segmentWidth = chartSizeLookup[this.chartSize];
                        this.chartVariables.innerRadius = this.chartVariables.visualOuterRadius - this.chartVariables.segmentWidth;
                    }
                }, {
                    key: "_createSVG",
                    value: function _createSVG(additionalTranslate) {
                        this.chartVariables.svg && this.chartVariables.svg.remove();
                        this.chartVariables.actualSvg && this.chartVariables.actualSvg.remove();
                        this.chartVariables.actualSvg = d3__WEBPACK_IMPORTED_MODULE_1__["select"](this.shadowRoot.getElementById("chart-container")).append("svg").style("font-family", "Open Sans").attr("class", "donut-chart__actual-svg").attr("width", this.chartVariables.svgSquareSideSize).attr("height", this.chartVariables.svgSquareSideSize).attr("transform", "translate( ".concat(additionalTranslate, ", ").concat(additionalTranslate, ")"));
                        this.chartVariables.svg = this.chartVariables.actualSvg.append("g").attr("class", "donut-chart__svg-content").attr("transform", "translate( ".concat(this.chartVariables.visualOuterRadius + additionalTranslate, ", ").concat(this.chartVariables.visualOuterRadius + additionalTranslate, ")"));
                    }
                }, {
                    key: "_addCenterText",
                    value: function _addCenterText(svg, additionalTranslate) {
                        var _this$chartVariables3 = this.chartVariables, innerRadius = _this$chartVariables3.innerRadius, visualOuterRadius = _this$chartVariables3.visualOuterRadius;
                        var diameterOfCenteredBox = innerRadius * 2;
                        var translateForeignObject = visualOuterRadius + additionalTranslate - diameterOfCenteredBox / 2;
                        svg.append("foreignObject").attr("width", diameterOfCenteredBox).attr("height", diameterOfCenteredBox).attr("transform", "translate(".concat(translateForeignObject, ", ").concat(translateForeignObject, ")")).append("xhtml:div").attr("class", "donut-chart__center-text").append("xhtml:slot").attr("name", "donut-content-area");
                    }
                }, {
                    key: "_addSegments",
                    value: function _addSegments(svg) {
                        var _this5 = this;
                        var initialOuterRadius = this.chartVariables.visualOuterRadius + strokeWidth;
                        if (!this.interactive) {
                            this.chartVariables.arc = d3__WEBPACK_IMPORTED_MODULE_1__["arc"]().innerRadius(this.chartVariables.innerRadius - strokeWidth).outerRadius(initialOuterRadius);
                            svg.selectAll("allSlices").data(this.chartVariables.data_sorted).enter().append("path").attr("d", this.chartVariables.arc).attr("fill", function(d) {
                                _newArrowCheck(this, _this5);
                                return d.data.color;
                            }.bind(this)).attr("stroke", "white").style("stroke-width", strokeWidth);
                        } else {
                            this.shrinkTimeouts = {};
                            this.chartVariables.arc = d3__WEBPACK_IMPORTED_MODULE_1__["arc"]().innerRadius(this.chartVariables.innerRadius - strokeWidth);
                            var boundArcTween = this._generateArcTween.bind(this, this.chartVariables.arc, this.chartVariables.visualHoverOuterRadius + strokeWidth, this.chartVariables.visualOuterRadius + strokeWidth, 350, 150);
                            this.chartVariables.arcGrow = boundArcTween(true);
                            this.chartVariables.arcShrink = boundArcTween(false);
                            var componentContext = this;
                            this.allSegments = svg.selectAll("allSlices").data(this.chartVariables.data_sorted).enter().append("path").each(function(d, i) {
                                _newArrowCheck(this, _this5);
                                d.outerRadius = initialOuterRadius;
                                d.index = i;
                            }.bind(this)).attr("d", this.chartVariables.arc).attr("fill", function(d) {
                                _newArrowCheck(this, _this5);
                                return d.data.color;
                            }.bind(this)).attr("data-index", function(d) {
                                _newArrowCheck(this, _this5);
                                return d.index;
                            }.bind(this)).attr("stroke", "white").style("stroke-width", strokeWidth).attr("pointer-events", "all").on("mouseover", (function(d) {
                                componentContext._mouseoverSegment(d, this);
                            })).on("mouseout", (function(d) {
                                componentContext._mouseoutSegment(d, this);
                            }))._groups[0];
                            MDS.isMobile && svg.selectAll("allSlices").on("touchstart", (function(d) {
                                componentContext._mouseoverSegment(d, this);
                            })).on("touchend", (function(d) {
                                componentContext._mouseoutSegment(d, this);
                            }));
                        }
                    }
                }, {
                    key: "_mouseoverSegment",
                    value: function _mouseoverSegment(d, contextSVG) {
                        var _this6 = this;
                        this.changeSegmentCache.previousD = this.changeSegmentCache.currentD;
                        this.changeSegmentCache.currentD = d;
                        var _this$changeSegmentCa = this.changeSegmentCache, currentD = _this$changeSegmentCa.currentD, previousD = _this$changeSegmentCa.previousD;
                        if (currentD.index !== this.selectedIndex) {
                            this.changeSegmentFn(currentD, previousD);
                            this.chartVariables.arcGrow.call(contextSVG);
                        }
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this6);
                            return "mouseover-segment";
                        }.bind(this), this)({
                            index: currentD.index
                        });
                    }
                }, {
                    key: "_mouseoutSegment",
                    value: function _mouseoutSegment(d, contextSVG) {
                        var _this7 = this;
                        var currentD = this.changeSegmentCache.currentD;
                        if (currentD.index !== this.selectedIndex) {
                            this.changeSegmentFn(null, d);
                            this.chartVariables.arcShrink.call(contextSVG);
                        }
                        Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                            _newArrowCheck(this, _this7);
                            return "mouseout-segment";
                        }.bind(this), this)({
                            index: currentD.index
                        });
                    }
                }, {
                    key: "_generateArcTween",
                    value: function _generateArcTween(arc, largerRadius, smallerRadius, timeGrow, timeShrink, isMouseover) {
                        var componentContext = this;
                        return function() {
                            var _this8 = this;
                            var hoverSegmentFn = componentContext.hoverSegmentFn.bind(componentContext);
                            var hoverOutSegmentFn = componentContext.hoverOutSegmentFn.bind(componentContext);
                            var segmentIndex = this.getAttribute("data-index");
                            var isOpening = !!componentContext.isOpeningCache[segmentIndex];
                            if (isMouseover) {
                                clearTimeout(componentContext.shrinkTimeouts[segmentIndex]);
                                if (!isOpening) {
                                    componentContext.isOpeningCache[segmentIndex] = true;
                                    _utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["runArcTween"].call(this, d3__WEBPACK_IMPORTED_MODULE_1__, arc, smallerRadius, largerRadius, timeGrow, Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["runOnce"])(hoverSegmentFn));
                                    window.setTimeout(function() {
                                        _newArrowCheck(this, _this8);
                                        componentContext.isOpeningCache[segmentIndex] = false;
                                    }.bind(this), timeGrow);
                                }
                            } else if (isOpening) {
                                componentContext.shrinkTimeouts[segmentIndex] = window.setTimeout(function() {
                                    _newArrowCheck(this, _this8);
                                    _utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["runArcTween"].call(this, d3__WEBPACK_IMPORTED_MODULE_1__, arc, largerRadius, smallerRadius, timeShrink, Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["runOnce"])(hoverOutSegmentFn));
                                }.bind(this), timeGrow);
                            } else {
                                _utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["runArcTween"].call(this, d3__WEBPACK_IMPORTED_MODULE_1__, arc, largerRadius, smallerRadius, timeShrink, Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["runOnce"])(hoverOutSegmentFn));
                            }
                        };
                    }
                }, {
                    key: "hoverArc",
                    value: function hoverArc(index) {
                        var _this9 = this;
                        var timeGrow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 350;
                        if (index !== this.selectedIndex) {
                            Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["runOnce"])(this.chartVariables.arcGrow.call(this.allSegments[index]));
                            setTimeout(function() {
                                _newArrowCheck(this, _this9);
                                return this.shrinkArc(index);
                            }.bind(this), timeGrow);
                        }
                    }
                }, {
                    key: "growArc",
                    value: function growArc(index) {
                        var _this10 = this;
                        if (index >= 0 && index < this.segments.length) {
                            this.selectedIndex = index;
                            Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["runOnce"])(this.chartVariables.arcGrow.call(this.allSegments[index]));
                            Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                                _newArrowCheck(this, _this10);
                                return "selected-segment";
                            }.bind(this), this)({
                                index: index
                            });
                        }
                    }
                }, {
                    key: "shrinkArc",
                    value: function shrinkArc(index) {
                        Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["runOnce"])(this.chartVariables.arcShrink.call(this.allSegments[index]));
                    }
                }, {
                    key: "_adjustEmptyChart",
                    value: function _adjustEmptyChart() {
                        var emptyChart = this.shadowRoot.getElementById("empty-chart");
                        emptyChart.setAttribute("class", "".concat(this.rootClass, "__empty-chart"));
                        try {
                            this._setDimensionVariables();
                        } catch (error) {
                            return "";
                        }
                        var _this$chartVariables4 = this.chartVariables, visualOuterRadius = _this$chartVariables4.visualOuterRadius, visualHoverOuterRadius = _this$chartVariables4.visualHoverOuterRadius, additionalTranslate = _this$chartVariables4.additionalTranslate;
                        var dimension = this.interactive ? 2 * (visualHoverOuterRadius - additionalTranslate - leadingPadding) : 2 * visualOuterRadius;
                        var marginDifference = additionalTranslate > leadingPadding ? additionalTranslate - leadingPadding : 0;
                        emptyChart.setAttribute("style", "\n      height: ".concat(dimension, "px;\n      width: ").concat(dimension, "px;\n      margin-left: ").concat(marginDifference, "px;\n      margin-top: ").concat(marginDifference, "px;\n    "));
                    }
                }, {
                    key: "_isEmpty",
                    value: function _isEmpty() {
                        return !this.segments || this.segments.length === 0 || this.segments.length === 0;
                    }
                }, {
                    key: "_adjustNoDisplayDataChart",
                    value: function _adjustNoDisplayDataChart() {
                        var outerCircle = this.shadowRoot.getElementById("no-display-data-outer-circle");
                        var innerCircle = this.shadowRoot.getElementById("no-display-data-inner-circle");
                        var centerText = this.shadowRoot.getElementById("no-display-data-center-text");
                        outerCircle.setAttribute("class", "".concat(this.rootClass, "__no-display-data ").concat(this.rootClass, "__no-display-data--outer-circle"));
                        innerCircle.setAttribute("class", "".concat(this.rootClass, "__no-display-data"));
                        try {
                            this._setDimensionVariables();
                        } catch (error) {
                            return "";
                        }
                        var _this$chartVariables5 = this.chartVariables, innerRadius = _this$chartVariables5.innerRadius, visualOuterRadius = _this$chartVariables5.visualOuterRadius, visualHoverOuterRadius = _this$chartVariables5.visualHoverOuterRadius, additionalTranslate = _this$chartVariables5.additionalTranslate;
                        var outerDimension = this.interactive ? 2 * (visualHoverOuterRadius - additionalTranslate - leadingPadding) : 2 * visualOuterRadius;
                        var innerDimension = this.interactive ? 2 * (innerRadius - additionalTranslate - leadingPadding) : 2 * innerRadius;
                        var marginDifference = additionalTranslate > leadingPadding ? additionalTranslate - leadingPadding : 0;
                        var diameterOfCenteredBox = 2 * (innerRadius / Math.SQRT2);
                        outerCircle.setAttribute("style", "\n      height: ".concat(outerDimension, "px;\n      width: ").concat(outerDimension, "px;\n      margin-left: ").concat(marginDifference, "px;\n      margin-top: ").concat(marginDifference, "px;\n    "));
                        innerCircle.setAttribute("style", "\n      height: ".concat(innerDimension, "px;\n      width: ").concat(innerDimension, "px;\n      margin-left: ").concat(marginDifference, "px;\n      margin-top: ").concat(marginDifference, "px;\n    "));
                        centerText.setAttribute("style", "\n      width: ".concat(diameterOfCenteredBox, "px;\n      height: ").concat(diameterOfCenteredBox, "px;\n    "));
                    }
                }, {
                    key: "_noDisplayData",
                    value: function _noDisplayData() {
                        var _this11 = this;
                        var flag = true;
                        if (this.segments) {
                            this.segments.forEach(function(segment) {
                                _newArrowCheck(this, _this11);
                                if (segment.value > 0) {
                                    flag = false;
                                }
                            }.bind(this));
                        }
                        return flag;
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback(prop) {
                        _get(_getPrototypeOf(MdsDonutChart.prototype), "renderedCallback", this) && _get(_getPrototypeOf(MdsDonutChart.prototype), "renderedCallback", this).call(this, prop);
                        var container = this.shadowRoot.getElementById("chart-container");
                        var isChartDataChanged = !prop || /(segments)/.test(prop);
                        var isChangeSegmentsFnChanged = /(change-segment-fn|changeSegmentFn)/.test(prop);
                        var isSortSegmentsChanged = /(sort-segments|sortSegments)/.test(prop);
                        var isHeightChanged = /(chartHeight)/.test(prop);
                        var isSelectedIndexChanged = /(selectedIndex|selected-index)/.test(prop);
                        var isWidthChanged = !this.chartVariables.container || this.chartVariables.container.offsetWidth && this.chartVariables.container.offsetWidth !== this.chartVariables.width;
                        if (container && (isWidthChanged || isHeightChanged || isChartDataChanged || isSortSegmentsChanged || isSelectedIndexChanged || isChangeSegmentsFnChanged) && this.connectedFlag) {
                            this.renderChart();
                            if (isSelectedIndexChanged && this.selectedIndex >= 0 && this.selectedIndex < this.segments.length) {
                                this.growArc(this.selectedIndex);
                            }
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var classes = {
                            root: {
                                "donut-chart": true,
                                "donut-chart--small": this.chartSize === "small"
                            },
                            container: {
                                "donut-chart__chart-container": true
                            },
                            chartBody: {
                                "donut-chart__chart-body": true
                            }
                        };
                        var idAccesssibleTitle = "".concat(this.id, "-accessible-title");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.root);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.chartBody);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text", "role", "img", "aria-labelledby", idAccesssibleTitle);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "id", idAccesssibleTitle, "aria-hidden", "true");
                        _renderArbitrary(this.accessibleName);
                        _renderArbitrary(this.shortDescription);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.container, "id", "chart-container", "aria-hidden", "true");
                        _renderArbitrary(this._isEmpty() ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "empty-chart"), 
                        _renderArbitrary(this.noDataPointText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")) : this._noDisplayData() && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "no-display-data-outer-circle"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "no-display-data-inner-circle"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "no-display-data-center-text", "class", "donut-chart__center-text donut-chart__center-text--no-display-data", "aria-hidden", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "donut-content-area", "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsDonutChart;
            }(_abstract_chart__WEBPACK_IMPORTED_MODULE_4__["default"]), _class2.styles = _mds_donut_chart_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsDonutChart;
        },
        "./src/donut-chart/mds-donut-chart.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/donut-chart/mds-donut-chart.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/gauge-chart-linear/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_gauge_chart_linear_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/gauge-chart-linear/mds-gauge-chart-linear.scss");
            var _mds_gauge_chart_linear_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_gauge_chart_linear_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/common-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function _toConsumableArray(arr) {
                return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
            }
            function _nonIterableSpread() {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _iterableToArray(iter) {
                if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
            }
            function _arrayWithoutHoles(arr) {
                if (Array.isArray(arr)) return _arrayLikeToArray(arr);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired, numberRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].numberRequired, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables;
            var entity = {
                accessibleName: stringRequired,
                accessibleDescription: string,
                valueColor: string,
                pinType: enumerables(string, "none", "icon", "text").defaultsTo("none"),
                pinIcon: enumerables.apply(void 0, [ string ].concat(_toConsumableArray(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["ICON_TYPES"]))),
                pinText: string,
                pinPosition: number,
                primaryLabel: string,
                secondaryLabel: string,
                secondaryLabelValue: string,
                trailingBarLabel: enumerables(string, "percent", "value", "none").defaultsTo("none"),
                currentValue: numberRequired,
                minValue: number.defaultsTo(0),
                maxValue: numberRequired,
                position: enumerables(string, "above", "below").defaultsTo("above"),
                primaryLabelWidth: number.defaultsTo(60).withMaxSize(100),
                componentRole: string.defaultsTo("gauge chart"),
                variant: enumerables(string, "regular", "range").defaultsTo("regular")
            };
            var MdsGaugeChartLinear = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsGaugeChartLinear, _AgaveComponent);
                _createClass(MdsGaugeChartLinear, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsGaugeChartLinear";
                    }
                } ]);
                function MdsGaugeChartLinear() {
                    var _this;
                    _classCallCheck(this, MdsGaugeChartLinear);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsGaugeChartLinear).call(this));
                    _this._getPercentage = _this._getPercentage.bind(_assertThisInitialized(_this));
                    return _this;
                }
                _createClass(MdsGaugeChartLinear, [ {
                    key: "_getPercentage",
                    value: function _getPercentage(currentValue) {
                        if (this.minValue >= 0) {
                            var decimalVal = (currentValue - this.minValue) / (this.maxValue - this.minValue) * 100;
                            return "".concat(Math.round(decimalVal * 100 + Number.EPSILON) / 100, "%");
                        }
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        var _this2 = this;
                        setTimeout(function() {
                            _newArrowCheck(this, _this2);
                            var pin = this.shadowRoot.querySelector("#gauge-chart-linear__pin");
                            if (pin) {
                                var pinRect = pin.getBoundingClientRect();
                                var pinText = this.shadowRoot.querySelector(".gauge-chart-linear__pin-text");
                                var pinTextRect;
                                if (pinText) {
                                    pinTextRect = pinText.getBoundingClientRect();
                                }
                                var container = this.shadowRoot.querySelector(".gauge-chart-linear__gauge-container");
                                var containerRect = container.getBoundingClientRect();
                                var pinMostRight = Math.max(pinRect.left + pinRect.width, pinTextRect ? pinTextRect.left + pinTextRect.width : Number.NEGATIVE_INFINITY);
                                var trackMarginRight = pinMostRight - (containerRect.left + containerRect.width);
                                var track = this.shadowRoot.querySelector(".gauge-chart-linear__track");
                                track.style.marginRight = trackMarginRight > 0 ? "".concat(trackMarginRight, "px") : "";
                                var pinMostLeft = Math.min(pinRect.left, pinTextRect ? pinTextRect.left : Number.POSITIVE_INFINITY);
                                var trackMarginLeft = containerRect.left - pinMostLeft;
                                track.style.marginLeft = trackMarginLeft > 0 ? "".concat(trackMarginLeft, "px") : "";
                            }
                            this.shadowRoot.querySelector(".gauge-chart-linear__gauge-container").style.opacity = 1;
                        }.bind(this));
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _classes, _this3 = this;
                        if (this.maxValue < this.minValue) {
                            this.throwConstraintError("maxValue must be greater than minValue");
                        }
                        if (this.currentValue < this.minValue) {
                            this.throwConstraintError("currentValue must be greater than or equal to minValue");
                        }
                        if (this.currentValue > this.maxValue) {
                            this.throwConstraintError("currentValue must be less than or equal to maxValue");
                        }
                        if (this.pinType !== "none" && Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["isNonZeroFalsy"])(this.pinPosition)) {
                            throw new Error("when pinType is not none, pinPosition needs to be set");
                        }
                        if (this.pinPosition < this.minValue) {
                            this.throwConstraintError("pinPosition must be greater than or equal to minValue");
                        }
                        if (this.pinPosition > this.maxValue) {
                            this.throwConstraintError("pinPosition must be less than or equal to maxValue");
                        }
                        if (this.pinType !== "none" && this.position === "above") {
                            this.throwConstraintError("position must be below when pinType is not none");
                        }
                        if (!this.primaryLabel && this.trailingBarLabel === "none") {
                            this.throwConstraintError("component must either have trailingBarLabel or primaryLabel");
                        }
                        if (this.secondaryLabel && !this.primaryLabel) {
                            this.throwConstraintError("secondaryLabel requires primaryLabel");
                        }
                        if (!this.secondaryLabel && this.secondaryLabelValue) {
                            this.throwConstraintError("secondaryLabelValue requires secondaryLabel");
                        }
                        if (this.primaryLabelWidth < 0) {
                            this.primaryLabelWidth = 0;
                        }
                        if (this.variant === "range" && (!this.maxValue || !this.pinPosition || !this.accessibleName || !this.secondaryLabel || !this.primaryLabel)) {
                            this.throwConstraintError("When the variant is range, the max value, pinPosition, accessible name, primaryLabel, secondaryLabel, and the pin type must be present");
                        }
                        var classes = (_classes = {
                            "gauge-chart-linear": true
                        }, _defineProperty(_classes, "gauge-chart-linear--".concat(this.position), true), 
                        _defineProperty(_classes, "gauge-chart-linear--pin", this.pinType !== "none"), _defineProperty(_classes, "gauge-chart-linear--trailingBarLabel", this.trailingBarLabel !== "none"), 
                        _classes);
                        var getIndicatorClasses = function getIndicatorClasses() {
                            _newArrowCheck(this, _this3);
                            switch (this.variant) {
                              case "regular":
                                return {
                                    "gauge-chart-linear__indicator": true,
                                    "gauge-chart-linear__indicator--empty": this.currentValue === this.minValue || this.minValue < 0
                                };

                              case "range":
                                return {
                                    "gauge-chart-linear__indicator--range": true
                                };

                              default:
                                return "";
                            }
                        }.bind(this);
                        var getTrackClasses = function getTrackClasses() {
                            _newArrowCheck(this, _this3);
                            switch (this.variant) {
                              case "regular":
                                return {
                                    "gauge-chart-linear__track": true
                                };

                              case "range":
                                return {
                                    "gauge-chart-linear__track--range": true
                                };

                              default:
                                return "";
                            }
                        }.bind(this);
                        var currentPercent = this._getPercentage(this.currentValue);
                        var getAccessibleText = function getAccessibleText() {
                            var _this4 = this;
                            _newArrowCheck(this, _this3);
                            switch (this.variant) {
                              case "regular":
                                return [ this.accessibleName, this.accessibleDescription ].filter(function(val) {
                                    _newArrowCheck(this, _this4);
                                    return val;
                                }.bind(this)).join(", ");

                              case "range":
                                return [ this.accessibleName, this.accessibleDescription ].filter(function(val) {
                                    _newArrowCheck(this, _this4);
                                    return val;
                                }.bind(this)).join(", ");

                              default:
                                return "";
                            }
                        }.bind(this);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                        _renderArbitrary(getAccessibleText());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        _renderArbitrary(this.primaryLabel && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "gauge-chart-linear__labels"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "gauge-chart-linear__primary-label", "style", {
                            maxWidth: "".concat(this.primaryLabelWidth, "%")
                        }, "aria-hidden", "true"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" "), 
                        _renderArbitrary(this.primaryLabel), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                        _renderArbitrary(this.secondaryLabel && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "gauge-chart-linear__secondary-label-container"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "gauge-chart-linear__secondary-label", "aria-hidden", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" "), _renderArbitrary(this.secondaryLabel), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" "), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                        _renderArbitrary(this.secondaryLabelValue && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "gauge-chart-linear__secondary-label-value", "aria-hidden", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" "), _renderArbitrary(this.secondaryLabelValue), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" "), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"))), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div"))), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "gauge-chart-linear__gauge-container");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", getTrackClasses());
                        _renderArbitrary(this.pinType !== "none" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "gauge-chart-linear__pin-container", "style", {
                            left: "".concat(this._getPercentage(this.pinPosition))
                        }), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "gauge-chart-linear__pin-background-icon", "innerHTML-prop", MDS.svgs["ico_pin_background"], "aria-hidden", "true", "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                        _renderArbitrary(this.pinType === "icon" ? (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "innerHTML-prop", MDS.svgs[this.pinIcon], "class", "gauge-chart-linear__pin-icon", "aria-hidden", "true", "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")) : (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("span"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "gauge-chart-linear__pin-text"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-hidden", "true"), 
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_3__["conditionalAttribute"])({
                            style: {
                                backgroundColor: this.valueColor
                            }
                        }, this.valueColor)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("span"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(" "), _renderArbitrary(this.pinText), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"))), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", getIndicatorClasses(), "style", this.variant === "regular" && {
                            width: currentPercent,
                            backgroundColor: this.valueColor || ""
                        });
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(this.trailingBarLabel !== "none" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "gauge-chart-linear__trailing-bar-label", "aria-hidden", "true"), 
                        _renderArbitrary(this.trailingBarLabel === "percent" ? currentPercent : Math.round(this.currentValue)), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsGaugeChartLinear;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_gauge_chart_linear_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2._pinColor = {
                cpo: "#0060f0",
                jpo: "#115880",
                cpc: "#0a4386",
                bcb: "#0a4386",
                cmb: "#005eb8",
                jmb: "#096183"
            }, _class2)) || _class);
            __webpack_exports__["default"] = MdsGaugeChartLinear;
        },
        "./src/gauge-chart-linear/mds-gauge-chart-linear.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/gauge-chart-linear/mds-gauge-chart-linear.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/gauge-chart-radial/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_gauge_chart_radial_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/gauge-chart-radial/mds-gauge-chart-radial.scss");
            var _mds_gauge_chart_radial_scss__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_gauge_chart_radial_scss__WEBPACK_IMPORTED_MODULE_2__);
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/utils/data-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2, _this3 = undefined;
            var _circle$wrapper = function _circle$wrapper(_dataMarkerRadius, _this$_secondaryArcEn, _this$_secondaryArcEn2) {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("circle", null, null, "class", "gauge-chart-radial__secondary-data-marker", "r", _dataMarkerRadius, "cx", _this$_secondaryArcEn, "cy", _this$_secondaryArcEn2);
            }, _path$wrapper = function _path$wrapper(_d) {
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("path", null, null, "class", "gauge-chart-radial__secondary-indicator", "d", _d);
            };
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].string, stringRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].stringRequired, number = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].number, numberRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].numberRequired, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].enumerables, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_1__["MarshalerTypes"].boolean;
            var entity = {
                accessibleName: stringRequired,
                primaryValue: numberRequired,
                secondaryValue: number,
                maxValue: numberRequired,
                thickness: enumerables(string, "regular", "thin").defaultsTo("regular"),
                primaryValueAccessibleName: string.defaultsTo("primary value"),
                secondaryValueAccessibleName: string.defaultsTo("secondary value"),
                minValueAccessibleName: string.defaultsTo("minimum value"),
                maxValueAccessibleName: string.defaultsTo("maximum value"),
                dataMarker: boolean.defaultsTo(false),
                barLabel: boolean.defaultsTo(false),
                secondaryDataMarkerIcon: boolean.defaultsTo(false),
                componentRole: string.defaultsTo("gauge chart").withChangedCallback(),
                contentAccessibleText: string,
                formattedMinValue: string,
                formattedMaxValue: string
            };
            var MdsGaugeChartRadial = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_1__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsGaugeChartRadial, _AgaveComponent);
                _createClass(MdsGaugeChartRadial, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsGaugeChartRadial";
                    }
                } ]);
                function MdsGaugeChartRadial() {
                    var _this;
                    _classCallCheck(this, MdsGaugeChartRadial);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsGaugeChartRadial).call(this));
                    _this._getArcEnd = _this._getArcEnd.bind(_assertThisInitialized(_this));
                    _this.defineObservedProperty("_trailingPadding", 0);
                    return _this;
                }
                _createClass(MdsGaugeChartRadial, [ {
                    key: "componentRoleChangedCallback",
                    value: function componentRoleChangedCallback() {
                        console.error("MDS Gauge Chart Radial: do not use componentRole property, deprecated in favor of accessibleName, Nov 2020.");
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        var _this2 = this;
                        setTimeout(function() {
                            _newArrowCheck(this, _this2);
                            var textWidthHalved = this.barLabel ? Math.round(this.shadowRoot.querySelector(".gauge-chart-radial__bar-label-trailing").getBBox().width / 2) : 0;
                            var dataMarkerRadius = MdsGaugeChartRadial["_".concat(this.thickness)].dataMarkerRadius;
                            this._trailingPadding = Math.max(textWidthHalved, dataMarkerRadius);
                            this.shadowRoot.querySelector(".gauge-chart-radial").setAttribute("style", "opacity: 1");
                        }.bind(this));
                    }
                }, {
                    key: "_getArcEnd",
                    value: function _getArcEnd(val) {
                        var _MdsGaugeChartRadial = MdsGaugeChartRadial["_".concat(this.thickness)], arcLeftX = _MdsGaugeChartRadial.arcLeftX, arcLeftY = _MdsGaugeChartRadial.arcLeftY, arcRadius = _MdsGaugeChartRadial.arcRadius;
                        var arcPercentFilled = (val + (0 - MdsGaugeChartRadial._minValue)) / (this.maxValue - MdsGaugeChartRadial._minValue);
                        var arcRadianFilled = arcPercentFilled * Math.PI;
                        var x = arcLeftX + arcRadius - arcRadius * Math.cos(arcRadianFilled);
                        var y = arcLeftY - arcRadius * Math.sin(arcRadianFilled);
                        return {
                            x: x,
                            y: y
                        };
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (this.maxValue < MdsGaugeChartRadial._minValue) {
                            this.throwConstraintError("maxValue must be greater than minValue");
                        }
                        if (this.primaryValue < MdsGaugeChartRadial._minValue || this.secondaryValue < MdsGaugeChartRadial._minValue) {
                            this._pathIsNeg = true;
                        }
                        if (this.primaryValue > this.maxValue) {
                            this.throwConstraintError("primaryValue must be less than or equal to maxValue");
                        }
                        if (this.secondaryValue > this.maxValue) {
                            this.throwConstraintError("secondaryValue must be less than or equal to maxValue");
                        }
                        if (this.secondaryValue < this.primaryValue) {
                            this.throwConstraintError("secondaryValue must be greater than primaryValue");
                        }
                        var _MdsGaugeChartRadial2 = MdsGaugeChartRadial["_".concat(this.thickness)], arcLeftX = _MdsGaugeChartRadial2.arcLeftX, arcLeftY = _MdsGaugeChartRadial2.arcLeftY, arcRadius = _MdsGaugeChartRadial2.arcRadius, dataMarkerRadius = _MdsGaugeChartRadial2.dataMarkerRadius, labelAndMarginHeight = _MdsGaugeChartRadial2.labelAndMarginHeight;
                        this._height = arcRadius + (this.barLabel ? labelAndMarginHeight : dataMarkerRadius) + dataMarkerRadius;
                        this._width = arcRadius * 2 + dataMarkerRadius + this._trailingPadding;
                        this._primaryArcEnd = this._getArcEnd(this.primaryValue);
                        this._secondaryArcEnd = typeof this.secondaryValue === "number" ? this._getArcEnd(this.secondaryValue) : {};
                        if (this._pathIsNeg) {
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("svg", null, null, "class", _defineProperty({
                                "gauge-chart-radial": true,
                                "gauge-chart-radial--secondary": typeof this.secondaryValue === "number"
                            }, "gauge-chart-radial--".concat(this.thickness), true), "viewBox", "0 0 ".concat(this._width, " ").concat(this._height), "xmlns", "http://www.w3.org/2000/svg", "preserveAspectRatio", "none", "aria-hidden", "true");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("path", null, null, "class", "gauge-chart-radial__track", "d", "M ".concat(arcLeftX, ",").concat(arcLeftY, " A ").concat(arcRadius, " ").concat(arcRadius, " 0,0,1 ").concat(arcLeftX + arcRadius * 2, ", ").concat(arcLeftY));
                            _renderArbitrary(this.barLabel && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("text", null, null, "class", "gauge-chart-radial__bar-label-leading", "x", arcLeftX, "y", this._height, "aria-hidden", "true"), 
                            _renderArbitrary(new Intl.NumberFormat("en-US").format(MdsGaugeChartRadial._minValue)), 
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("text")));
                            _renderArbitrary(this.barLabel && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("text", null, null, "class", "gauge-chart-radial__bar-label-trailing", "x", arcLeftX + 2 * arcRadius, "y", this._height - 1, "aria-hidden", "true"), 
                            _renderArbitrary(new Intl.NumberFormat("en-US").format(this.maxValue)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("text")));
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("svg");
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "gauge-chart-radial__container");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text");
                        _renderArbitrary([ this.accessibleName, `${this.primaryValueAccessibleName} ${this.primaryValue}`, `${typeof this.secondaryValue === "number" ? `${this.secondaryValueAccessibleName} ${this.secondaryValue}` : ""}`, `${this.minValueAccessibleName} ${MdsGaugeChartRadial._minValue}`, `${this.maxValueAccessibleName} ${this.maxValue}` ].filter((val => val)).join(", "));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        _renderArbitrary(this.contentAccessibleText && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text"), 
                        _renderArbitrary(this.contentAccessibleText), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("svg", null, null, "class", {
                            "gauge-chart-radial": true,
                            "gauge-chart-radial--secondary": typeof this.secondaryValue === "number",
                            [`gauge-chart-radial--${this.thickness}`]: true
                        }, "viewBox", `0 0 ${this._width} ${this._height}`, "xmlns", "http://www.w3.org/2000/svg", "preserveAspectRatio", "none", "aria-hidden", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("path", null, null, "class", "gauge-chart-radial__track", "d", `M ${arcLeftX},${arcLeftY} A ${arcRadius} ${arcRadius} 0,0,1 ${arcLeftX + arcRadius * 2}, ${arcLeftY}`);
                        _renderArbitrary(typeof this.secondaryValue === "number" && [ _jsxWrapper(_circle$wrapper, [ dataMarkerRadius, this._secondaryArcEnd.x, this._secondaryArcEnd.y ]), _jsxWrapper(_path$wrapper, [ `M ${arcLeftX},${arcLeftY} A ${arcRadius} ${arcRadius} 0,0,1 ${this._secondaryArcEnd.x}, ${this._secondaryArcEnd.y}` ]) ]);
                        _renderArbitrary(!(this.dataMarker || typeof this.secondaryValue === "number") && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("path", null, null, "class", "gauge-chart-radial__primary-indicator--outer-border", "d", `M ${arcLeftX},${arcLeftY} A ${arcRadius} ${arcRadius} 0,0,1 ${this._primaryArcEnd.x}, ${this._primaryArcEnd.y}`));
                        _renderArbitrary((this.dataMarker || typeof this.secondaryValue === "number") && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("circle", null, null, "class", "gauge-chart-radial__primary-data-marker", "r", dataMarkerRadius, "cx", this._primaryArcEnd.x, "cy", this._primaryArcEnd.y));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("path", null, null, "class", "gauge-chart-radial__primary-indicator", "d", `M ${arcLeftX},${arcLeftY} A ${arcRadius} ${arcRadius} 0,0,1 ${this._primaryArcEnd.x}, ${this._primaryArcEnd.y}`);
                        _renderArbitrary(this.barLabel && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("text", null, null, "class", "gauge-chart-radial__bar-label-leading", "x", arcLeftX, "y", this._height, "aria-hidden", "true"), 
                        _renderArbitrary(this.formattedMinValue ? this.formattedMinValue : new Intl.NumberFormat("en-US").format(MdsGaugeChartRadial._minValue)), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("text")));
                        _renderArbitrary(this.barLabel && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("text", null, null, "class", "gauge-chart-radial__bar-label-trailing", "x", arcLeftX + 2 * arcRadius, "y", this._height - 1, "aria-hidden", "true"), 
                        _renderArbitrary(this.formattedMaxValue ? this.formattedMaxValue : new Intl.NumberFormat("en-US").format(this.maxValue)), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("text")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("foreignObject", null, null, "x", this._width / 4, "y", this._height / 3, "width", this._width / 2, "height", this._height * 2 / 3);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("slot", null, null, "name", "content", "aria-hidden", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("foreignObject");
                        _renderArbitrary(typeof this.secondaryValue === "number" && this.secondaryDataMarkerIcon && this.thickness === "regular" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("foreignObject", null, null, "x", this._secondaryArcEnd.x - Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("24px") / 2 + 1, "y", this._secondaryArcEnd.y - Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("24px") / 2, "width", "24px", "height", "24px"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "innerHTML-prop", MDS.svgs.ico_star_filled, "class", "gauge-chart-radial__datamarker-icon", "aria-hidden", "true", "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("foreignObject")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("svg");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsGaugeChartRadial;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_1___default.a), _class2.styles = _mds_gauge_chart_radial_scss__WEBPACK_IMPORTED_MODULE_2___default.a, 
            _class2._minValue = 0, _class2._regular = {
                arcRadius: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("210px"),
                arcLeftY: [ "18px", "210px" ].reduce(function(acc, val) {
                    _newArrowCheck(this, _this3);
                    return acc + Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])(val);
                }.bind(undefined), 0),
                arcLeftX: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("18px"),
                dataMarkerRadius: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("18px"),
                labelAndMarginHeight: [ "16px", "0.875rem" ].reduce(function(acc, val) {
                    _newArrowCheck(this, _this3);
                    return acc + Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])(val);
                }.bind(undefined), 0)
            }, _class2._thin = {
                arcRadius: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("106px"),
                arcLeftY: [ "8px", "106px" ].reduce(function(acc, val) {
                    _newArrowCheck(this, _this3);
                    return acc + Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])(val);
                }.bind(undefined), 0),
                arcLeftX: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("8px"),
                width: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("8px") * 2 + Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("106px") * 2,
                dataMarkerRadius: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])("8px"),
                labelAndMarginHeight: [ "12px", "0.875rem" ].reduce(function(acc, val) {
                    _newArrowCheck(this, _this3);
                    return acc + Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_3__["cleanCssToPx"])(val);
                }.bind(undefined), 0)
            }, _class2)) || _class);
            __webpack_exports__["default"] = MdsGaugeChartRadial;
        },
        "./src/gauge-chart-radial/mds-gauge-chart-radial.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/gauge-chart-radial/mds-gauge-chart-radial.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/index-chart.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            var _polyfills__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./src/polyfills.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_1__);
            var _index_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/index-core.js");
            var _area_chart__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/area-chart/index.jsx");
            var _bar_chart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/bar-chart/index.jsx");
            var _bar_chart_segmented__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/bar-chart-segmented/index.jsx");
            var _bar_chart_selectable__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/bar-chart-selectable/index.jsx");
            var _bullet_chart__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/bullet-chart/index.jsx");
            var _cash_flow_chart__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("./src/cash-flow-chart/index.jsx");
            var _donut_chart__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("./src/donut-chart/index.jsx");
            var _gauge_chart_linear__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("./src/gauge-chart-linear/index.jsx");
            var _gauge_chart_radial__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("./src/gauge-chart-radial/index.jsx");
            var _line_chart__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("./src/line-chart/index.jsx");
            var _projection_bar_chart__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__("./src/projection-bar-chart/index.jsx");
            var _projection_line_chart__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__("./src/projection-line-chart/index.jsx");
            var _projection_chart__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__("./src/projection-chart/index.js");
            var _sparkline__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__("./src/sparkline/index.jsx");
            __webpack_exports__["default"] = {
                indexCore: _index_core__WEBPACK_IMPORTED_MODULE_2__,
                AreaChart: _area_chart__WEBPACK_IMPORTED_MODULE_3__["default"],
                BarChart: _bar_chart__WEBPACK_IMPORTED_MODULE_4__["default"],
                BarChartSegmented: _bar_chart_segmented__WEBPACK_IMPORTED_MODULE_5__["default"],
                BarChartSelectable: _bar_chart_selectable__WEBPACK_IMPORTED_MODULE_6__["default"],
                BulletChart: _bullet_chart__WEBPACK_IMPORTED_MODULE_7__["default"],
                CashFlowChart: _cash_flow_chart__WEBPACK_IMPORTED_MODULE_8__["default"],
                DonutChart: _donut_chart__WEBPACK_IMPORTED_MODULE_9__["default"],
                GaugeChartLinear: _gauge_chart_linear__WEBPACK_IMPORTED_MODULE_10__["default"],
                GaugeChartRadial: _gauge_chart_radial__WEBPACK_IMPORTED_MODULE_11__["default"],
                LineChart: _line_chart__WEBPACK_IMPORTED_MODULE_12__["default"],
                ProjectionBarChart: _projection_bar_chart__WEBPACK_IMPORTED_MODULE_13__["default"],
                ProjectionLineChart: _projection_line_chart__WEBPACK_IMPORTED_MODULE_14__["default"],
                ProjectionChartDeprecated: _projection_chart__WEBPACK_IMPORTED_MODULE_15__["default"],
                Sparkline: _sparkline__WEBPACK_IMPORTED_MODULE_16__["default"]
            };
        },
        "./src/line-chart/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "lineEntity", (function() {
                return lineEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var d3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d3");
            var d3__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(d3__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_2__);
            var _mds_line_chart_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/line-chart/mds-line-chart.scss");
            var _mds_line_chart_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_line_chart_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _abstract_xy_chart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/abstract-xy-chart/index.jsx");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/data-utils.js");
            var _utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/chart-utils.js");
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _slicedToArray(arr, i) {
                return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
            }
            function _nonIterableRest() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _iterableToArrayLimit(arr, i) {
                var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
                if (null != _i) {
                    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
                    try {
                        if (_x = (_i = _i.call(arr)).next, 0 === i) {
                            if (Object(_i) !== _i) return;
                            _n = !1;
                        } else for (;!(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) ;
                    } catch (err) {
                        _d = !0, _e = err;
                    } finally {
                        try {
                            if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
                        } finally {
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
            }
            function _arrayWithHoles(arr) {
                if (Array.isArray(arr)) return arr;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_2__["mixins"].AttributeMarshallingMixin, string = _mixins$AttributeMars.string, arrayOf = _mixins$AttributeMars.arrayOf, satisfies = _mixins$AttributeMars.satisfies, object = _mixins$AttributeMars.object, boolean = _mixins$AttributeMars.boolean, enumerables = _mixins$AttributeMars.enumerables, number = _mixins$AttributeMars.number;
            var additionalDataEntity = {
                key: string,
                value: string
            };
            var legendEntity = {
                itemsPerRow: arrayOf(number),
                additionalData: satisfies(additionalDataEntity).or(object),
                paddedColumn: boolean
            };
            var lineEntity = _objectSpread({}, _abstract_xy_chart__WEBPACK_IMPORTED_MODULE_4__["abstractLineEntity"], {
                lineColor: string
            });
            var entity = _objectSpread({}, _abstract_xy_chart__WEBPACK_IMPORTED_MODULE_4__["entity"], {
                singleLineLegend: enumerables(string, "legend", "dataTip").defaultsTo("dataTip"),
                legend: satisfies(legendEntity).defaultsTo({
                    itemsPerRow: [ 4, 3 ]
                }),
                lines: arrayOf(satisfies(lineEntity)).withChangedCallback(),
                legendType: enumerables(string, "inline", "xHeading").defaultsTo("xHeading"),
                hideTopBorder: boolean.defaultsTo(false),
                showLegend: boolean.defaultsTo(true)
            });
            var tokens = {
                tickLabelLineHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("1.25rem"),
                tickLabelFontSize: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("0.875rem"),
                yAxisMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px"),
                xAxisMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("4px"),
                xAxisTickMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px"),
                detailHeightTokens: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("1rem") + Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("4px") + Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("4px")
            };
            var MdsLineChart = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_2__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractXYChart) {
                _inherits(MdsLineChart, _AbstractXYChart);
                _createClass(MdsLineChart, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsLineChart";
                    }
                } ]);
                function MdsLineChart() {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsLineChart);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsLineChart).call(this));
                    _this.rootClass = "line-chart";
                    _extends(_this.chartVariables, tokens);
                    _this.defineObservedProperty("legendItems", []);
                    _this._dispatchMouseOverEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["debounce"])(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "mouseover-chartarea";
                    }.bind(this), _assertThisInitialized(_this)), 100);
                    return _this;
                }
                _createClass(MdsLineChart, [ {
                    key: "connectedCallback",
                    value: function connectedCallback() {
                        var _get2;
                        for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
                            props[_key] = arguments[_key];
                        }
                        (_get2 = _get(_getPrototypeOf(MdsLineChart.prototype), "connectedCallback", this)).call.apply(_get2, [ this ].concat(props));
                        if (this.lines && this.lines.length === 1 && this.singleLineLegend === "dataTip") {
                            this.showLegend = false;
                            this.lines[0].showDataPointDetail = true;
                        }
                        this._generateStartingLegend();
                        this.renderChart("from callback");
                    }
                }, {
                    key: "linesChangedCallback",
                    value: function linesChangedCallback() {
                        if (this.lines && this.lines.length === 1 && this.singleLineLegend === "dataTip") {
                            this.showLegend = false;
                            this.lines[0].showDataPointDetail = true;
                        }
                        if (this.showLegend && !this._isEmpty()) {
                            this._setUpLegend();
                        }
                        _get(_getPrototypeOf(MdsLineChart.prototype), "linesChangedCallback", this).call(this);
                    }
                }, {
                    key: "_setUpLegend",
                    value: function _setUpLegend() {
                        this.chartVariables.orderedLines = this.orderLinesByLastYValue();
                        this.chartVariables.dataPointDetailXFormatter = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["getFormatter"])(d3__WEBPACK_IMPORTED_MODULE_1__, this, this.d3DataPointDetailXFormatString, "formatDataPointDetailX", this.xAxis.d3TickFormatString, true);
                        this.chartVariables.dataPointDetailYFormatter = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["getFormatter"])(d3__WEBPACK_IMPORTED_MODULE_1__, this, this.d3DataPointDetailYFormatString, "formatDataPointDetailY", this.yAxis.d3TickFormatString);
                    }
                }, {
                    key: "_generateStartingLegend",
                    value: function _generateStartingLegend() {
                        var _this3 = this;
                        if (this.legendItems.length === 0 && this.showLegend && !this._isEmpty()) {
                            var legendItems = [];
                            var xValue = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["isNonZeroFalsy"])(this.hoverVariables.xValue) ? this._getInitialHoverValue() : this.hoverVariables.xValue;
                            this.hoverVariables.xValue = xValue;
                            this.chartVariables.orderedLines = this.orderLinesByLastYValue();
                            this.chartVariables.orderedLines.forEach(function(line, index) {
                                _newArrowCheck(this, _this3);
                                var lastDataPoint = line.dataPoints[line.dataPoints.length - 1];
                                var yValue = lastDataPoint.x === xValue ? lastDataPoint.y : "—";
                                legendItems.push({
                                    index: index,
                                    xValue: xValue,
                                    yValue: yValue
                                });
                            }.bind(this));
                            this.legendItems = legendItems;
                        }
                    }
                }, {
                    key: "_moveDetail",
                    value: function _moveDetail() {
                        _get(_getPrototypeOf(MdsLineChart.prototype), "_moveDetail", this).call(this);
                        this._updateLegend();
                    }
                }, {
                    key: "_renderDetailInitial",
                    value: function _renderDetailInitial() {
                        _get(_getPrototypeOf(MdsLineChart.prototype), "_renderDetailInitial", this).call(this);
                        this._updateLegend();
                    }
                }, {
                    key: "_renderChartCb",
                    value: function _renderChartCb() {
                        var _this4 = this;
                        var lineGen = this._drawLine();
                        var _this$chartVariables$ = this.chartVariables.yScale.domain(), _this$chartVariables$2 = _slicedToArray(_this$chartVariables$, 2), y0 = _this$chartVariables$2[0], y1 = _this$chartVariables$2[1];
                        var isNegativeYExist = this.lines.map(function(l) {
                            var _this5 = this;
                            _newArrowCheck(this, _this4);
                            return l.dataPoints.some(function(dp) {
                                _newArrowCheck(this, _this5);
                                return dp.y < 0;
                            }.bind(this));
                        }.bind(this)).includes(true);
                        if ((!this.yAxis.hideBaseline || isNegativeYExist) && y0 <= 0) {
                            this._renderHorizontalLine(lineGen, 0, {
                                class: "baseline"
                            });
                        }
                        this.chartVariables.orderedLines = this.orderLinesByLastYValue();
                        this.chartVariables.orderedLines.forEach(function(line) {
                            _newArrowCheck(this, _this4);
                            return this._renderLine(lineGen, line);
                        }.bind(this));
                        this.referenceLines && this.referenceLines.forEach(function(lineVal) {
                            _newArrowCheck(this, _this4);
                            return this._renderReferenceLine(lineGen, lineVal.y, {
                                class: "reference-line"
                            });
                        }.bind(this));
                    }
                }, {
                    key: "renderChart",
                    value: function renderChart(prop) {
                        var newHeight = this.chartVariables.container && this.chartVariables.height !== this.chartVariables.container.offsetHeight;
                        if (prop !== "legendItems" || newHeight) {
                            _get(_getPrototypeOf(MdsLineChart.prototype), "renderChart", this).call(this, prop);
                        }
                    }
                }, {
                    key: "_updateLegend",
                    value: function _updateLegend() {
                        var _this6 = this;
                        if (this.showLegend) {
                            this.legendItems = this.hoverVariables.dataMarkers.slice().reverse();
                        } else {
                            var legendDetails = [];
                            var dataMarkers = this.hoverVariables.dataMarkers.slice().reverse();
                            var legendItemsRows = dataMarkers.slice().concat(this.referenceLines || []).concat(this.legend.additionalData && [ this.legend.additionalData ] || []);
                            legendItemsRows.forEach(function(itemData) {
                                _newArrowCheck(this, _this6);
                                var isEmptySlot = itemData.name ? itemData.name === "legend-item-blank" : false;
                                var isReferenceLine = itemData.name ? itemData.name !== "legend-item-blank" && itemData.name !== "legend-item-break" : false;
                                var isAdditionalData = this.legend && this.legend.additionalData && (itemData.key !== undefined || itemData.value !== undefined);
                                var line = !isReferenceLine && !isEmptySlot && this.chartVariables.orderedLines[itemData.index] ? this.chartVariables.orderedLines[itemData.index] : itemData;
                                var xValue = this.hoverVariables.xValue;
                                var yValue = isReferenceLine ? itemData.y : isAdditionalData ? itemData.value : itemData.yValue;
                                var isPrimary = line && line.isPrimary;
                                var lineColor = line && line.lineColor;
                                var lineName = isReferenceLine ? itemData.name : isAdditionalData ? itemData.key : line.lineName;
                                legendDetails.push({
                                    xValue: xValue,
                                    yValue: yValue,
                                    isReferenceLine: isReferenceLine,
                                    isPrimary: isPrimary,
                                    isAdditionalData: isAdditionalData,
                                    lineColor: lineColor,
                                    lineName: lineName
                                });
                            }.bind(this));
                            this._handleMouseOver(legendDetails);
                        }
                    }
                }, {
                    key: "_handleMouseOver",
                    value: function _handleMouseOver(event) {
                        if (this.lines.length === 1 && this.singleLineLegend !== "dataTip" || this.lines.length > 1) {
                            this._dispatchMouseOverEvent(event);
                        }
                    }
                }, {
                    key: "_renderLegendItem",
                    value: function _renderLegendItem(formattedXLegendHeading, itemData) {
                        var isBreak = itemData.name ? itemData.name === "legend-item-break" : false;
                        var isEmptySlot = itemData.name ? itemData.name === "legend-item-blank" : false;
                        var isReferenceLine = itemData.name ? itemData.name !== "legend-item-blank" && itemData.name !== "legend-item-break" : false;
                        var isAdditionalData = this.legend && this.legend.additionalData && (itemData.key !== undefined || itemData.value !== undefined);
                        var height = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("10px");
                        var width = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("10px");
                        var radius = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("10px") / 2;
                        if (isBreak) {
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", "line-chart__legend-item-break");
                        }
                        if (isEmptySlot) {
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "line-chart__legend-item");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "line-chart__swatch-wrapper");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", "line-chart__swatch-circle");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", "line-chart__swatch");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", "line-chart__line-label");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", "line-chart__legend-value");
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        }
                        if (isAdditionalData) {
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "line-chart__legend-item");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "line-chart__swatch-wrapper");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", "line-chart__swatch-circle");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", "line-chart__swatch");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "line-chart__line-label");
                            _renderArbitrary(itemData.key);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "line-chart__legend-value");
                            _renderArbitrary(itemData.value);
                            Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                            return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        }
                        var line = itemData;
                        var lineColor;
                        var yValue = isReferenceLine ? itemData.y : itemData.yValue;
                        if (!isReferenceLine && !isEmptySlot && this.chartVariables.orderedLines[itemData.index]) {
                            line = this.chartVariables.orderedLines[itemData.index];
                            lineColor = !line.isPrimary && line.lineColor;
                        }
                        var classes = {
                            root: {
                                "line-chart__legend-item": true,
                                "line-chart__legend-item--reference-line": isReferenceLine
                            },
                            yValue: {
                                "line-chart__legend-value": true,
                                "line-chart__legend-value--negative": Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["isNegative"])(yValue.toString())
                            },
                            swatch: {
                                "line-chart__swatch": true,
                                "line-chart__swatch--primary": line.isPrimary,
                                "line-chart__swatch--reference-line": isReferenceLine
                            },
                            swatchCircle: {
                                "line-chart__swatch-circle": true,
                                "line-chart__swatch-circle--primary": line.isPrimary,
                                "line-chart__swatch-circle--reference-line": isReferenceLine
                            }
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.root);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "line-chart__swatch-wrapper");
                        _renderArbitrary(!isReferenceLine && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.swatchCircle), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("svg"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("version", "1.1"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("xmlns", "http://www.w3.org/2000/svg"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("height", height), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("width", width), _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["conditionalAttribute"])({
                            style: {
                                fill: lineColor
                            }
                        }, !isReferenceLine)), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("svg"), 
                        _renderArbitrary(itemData.index === this.chartVariables.orderedLines.length - 1 && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("circle", null, null, "r", radius, "cx", radius, "cy", radius, "fill", "false", "stroke", "false", "stroke-width", "0")), 
                        _renderArbitrary(itemData.index === this.chartVariables.orderedLines.length - 2 && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("rect", null, null, "width", width, "height", height)), 
                        _renderArbitrary(itemData.index === this.chartVariables.orderedLines.length - 3 && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("polygon", null, null, "points", `${radius},0 ${height},${width} 0,${width}`)), 
                        _renderArbitrary(itemData.index === this.chartVariables.orderedLines.length - 4 && Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("polygon", null, null, "points", `${radius},0 ${height},${radius} ${radius},${width} 0,${radius}`)), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("svg"), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes.swatch);
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["conditionalAttribute"])({
                            style: {
                                "background-color": lineColor
                            }
                        }, !isReferenceLine));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "line-chart__line-label");
                        _renderArbitrary(line.lineName || line.name);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        _renderArbitrary(this.legendType === "inline" && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "line-chart__legend-value"), 
                        _renderArbitrary(formattedXLegendHeading), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", classes.yValue);
                        _renderArbitrary(this.chartVariables.dataPointDetailYFormatter ? this.chartVariables.dataPointDetailYFormatter(yValue) : Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["getFormatter"])(d3__WEBPACK_IMPORTED_MODULE_1__, this, this.d3DataPointDetailYFormatString, "formatDataPointDetailY", this.yAxis.d3TickFormatString)(yValue));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_renderLegend",
                    value: function _renderLegend() {
                        var _this7 = this;
                        var formattedXLegendHeading = this.chartVariables.dataPointDetailXFormatter ? this.chartVariables.dataPointDetailXFormatter(this.hoverVariables.xValue) : Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_7__["getFormatter"])(d3__WEBPACK_IMPORTED_MODULE_1__, this, this.d3DataPointDetailXFormatString, "formatDataPointDetailX", this.xAxis.d3TickFormatString, true)(this.hoverVariables.xValue);
                        var allLegendItems = [];
                        var legendItems = this.legendItems.slice().concat(this.referenceLines || []).concat(this.legend.additionalData && [ this.legend.additionalData ] || []);
                        this.legend.itemsPerRow.forEach(function(numberOfItemsPerRow) {
                            _newArrowCheck(this, _this7);
                            var row = [];
                            for (var i = 0; i < numberOfItemsPerRow; i += 1) {
                                legendItems.length && row.push(legendItems.shift());
                            }
                            var emptySlot = {
                                name: "legend-item-blank"
                            };
                            if (this.legend.paddedColumn && numberOfItemsPerRow <= 2 && numberOfItemsPerRow > 0 && legendItems.length) {
                                row.unshift(emptySlot);
                                row.push(emptySlot);
                            }
                            var legendItemBreakSlot = {
                                name: "legend-item-break"
                            };
                            row.push(legendItemBreakSlot);
                            allLegendItems.push(row);
                        }.bind(this));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "line-chart__legend-container", "aria-hidden", "true");
                        _renderArbitrary(this.legendType === "xHeading" && !Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["isNonZeroFalsy"])(this.hoverVariables.xValue) && (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "line-chart__legend-heading"), 
                        _renderArbitrary(formattedXLegendHeading), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "line-chart__legend-item-container");
                        _renderArbitrary(allLegendItems[0] && allLegendItems[0].map(this._renderLegendItem.bind(this, formattedXLegendHeading)));
                        _renderArbitrary(allLegendItems[1] && allLegendItems[1].map(this._renderLegendItem.bind(this, formattedXLegendHeading)));
                        _renderArbitrary(allLegendItems[2] && allLegendItems[2].map(this._renderLegendItem.bind(this, formattedXLegendHeading)));
                        _renderArbitrary(allLegendItems[3] && allLegendItems[3].map(this._renderLegendItem.bind(this, formattedXLegendHeading)));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var classes = {
                            container: {
                                "line-chart__chart-container": true,
                                "line-chart__chart-container--with-legend": this.showLegend
                            }
                        };
                        return _get(_getPrototypeOf(MdsLineChart.prototype), "render", this).call(this, classes);
                    }
                } ]);
                return MdsLineChart;
            }(_abstract_xy_chart__WEBPACK_IMPORTED_MODULE_4__["default"]), _class2.styles = _mds_line_chart_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsLineChart;
        },
        "./src/line-chart/mds-line-chart.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/line-chart/mds-line-chart.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/projection-bar-chart/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "barEntity", (function() {
                return barEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "barsEntity", (function() {
                return barsEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var d3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d3");
            var d3__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(d3__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_2__);
            var _projection_bar_chart_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/projection-bar-chart/projection-bar-chart.scss");
            var _projection_bar_chart_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_projection_bar_chart_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _abstract_chart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/abstract-chart/index.jsx");
            var _utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/chart-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/data-utils.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/common-utils.js");
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _jsxWrapper = function _jsxWrapper(func, args) {
                return {
                    __jsxDOMWrapper: true,
                    func: func,
                    args: args
                };
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            var _li$wrapper = function _li$wrapper(_class3, _series$key, _deferred, _args) {
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("li", null, null, "class", "projection-bar-chart__legend-list");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "projection-bar-chart__legend-item");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", _class3);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "projection-bar-chart__legend-text");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span");
                _renderArbitrary(_series$key);
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "projection-bar-chart__legend-value");
                _renderArbitrary(_deferred(_args));
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("li");
            };
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_2__["mixins"].AttributeMarshallingMixin, boolean = _mixins$AttributeMars.boolean, string = _mixins$AttributeMars.string, stringRequired = _mixins$AttributeMars.stringRequired, number = _mixins$AttributeMars.number, numberRequired = _mixins$AttributeMars.numberRequired, satisfies = _mixins$AttributeMars.satisfies;
            var barEntity = {
                key: stringRequired,
                value: numberRequired
            };
            var barsEntity = {
                highProjectionBar: satisfies(barEntity),
                mediumProjectionBar: satisfies(barEntity),
                lowProjectionBar: satisfies(barEntity),
                currentMeasureBar: satisfies(barEntity)
            };
            var entity = _objectSpread({}, _abstract_chart__WEBPACK_IMPORTED_MODULE_4__["entity"], {
                d3BarLabelFormatString: string,
                graphWidth: number,
                graphHeight: numberRequired,
                highProjectionBarWidth: number.defaultsTo(150).withMinSize(66).withMaxSize(150),
                legendWidth: string,
                bars: satisfies(barsEntity),
                legendLabel: string,
                d3PrefixFormatter: boolean.defaultsTo(false),
                currentMeasureBarBackgroundColor: string,
                message: string
            });
            var tokens = {
                annotationLabelTextSize: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("0.875rem"),
                annotationLabelLineHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("1.25rem"),
                annotationValueTextSize: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("0.875rem"),
                annotationValueLineHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("1.25rem"),
                annotationKeyTextSize: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("0.875rem"),
                annotationKeyLineHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("1.25rem"),
                projectionAnnotationBottomMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("8px"),
                currentMeasureAnnotationBottomMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("4px"),
                projectionAnnotationLeadingMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px"),
                interBarMinPadding: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px"),
                maxBarValueRatioThreshold: .8,
                minBarHeightSensitivity: .5,
                maxBarHeightSensitivity: .5,
                annotationSwatchWidth: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("14px"),
                annotationSwatchHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("14px"),
                annotationTextLeadingMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("8px"),
                chartTopPadding: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px"),
                chartBottomPadding: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px"),
                chartTrailingPadding: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px"),
                chartLeadingPadding: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("16px"),
                chartMinHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("200px"),
                chartMinWidth: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("240px"),
                legendMaxWidth: "45%",
                highProjectionBarTransitionDelay: 150,
                mediumProjectionBarTransitionDelay: 100,
                lowProjectionBarTransitionDelay: 50
            };
            var MdsProjectionBarChart = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_2__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractChart) {
                _inherits(MdsProjectionBarChart, _AbstractChart);
                _createClass(MdsProjectionBarChart, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsProjectionBarChart";
                    }
                } ]);
                function MdsProjectionBarChart(props) {
                    var _this;
                    _classCallCheck(this, MdsProjectionBarChart);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsProjectionBarChart).call(this, props));
                    _this.rootClass = "projection-bar-chart";
                    _extends(_this.chartVariables, tokens);
                    _this._series = {};
                    return _this;
                }
                _createClass(MdsProjectionBarChart, [ {
                    key: "renderChart",
                    value: function renderChart() {
                        if (this._isEmpty() || !this._hasPositiveCurrentMeasure()) {
                            return;
                        }
                        this._setDimensionVariables();
                        this._createScales();
                        this._createSVG();
                        this._addBars();
                        this._addBaseline();
                        this._repositionLegend();
                    }
                }, {
                    key: "_setDimensionVariables",
                    value: function _setDimensionVariables() {
                        this.chartVariables.container = this.chartVariables.container || this.shadowRoot.getElementById("chart-data-container");
                        this.chartVariables.baselineLength = this.graphWidth || this.chartVariables.container && this.chartVariables.container.offsetWidth || this._getDefaultBaselineLength();
                        this.chartVariables.width = this._getDefaultWidth();
                        this.chartVariables.height = this.graphHeight;
                    }
                }, {
                    key: "_getDefaultBaselineLength",
                    value: function _getDefaultBaselineLength() {
                        var _this$chartVariables = this.chartVariables, chartTrailingPadding = _this$chartVariables.chartTrailingPadding, chartLeadingPadding = _this$chartVariables.chartLeadingPadding;
                        var padding = chartLeadingPadding + chartTrailingPadding;
                        return Math.max(this.offsetWidth - padding, this.chartVariables.chartMinWidth);
                    }
                }, {
                    key: "_getDefaultWidth",
                    value: function _getDefaultWidth() {
                        var _this$chartVariables2 = this.chartVariables, chartTrailingPadding = _this$chartVariables2.chartTrailingPadding, chartLeadingPadding = _this$chartVariables2.chartLeadingPadding, chartMinWidth = _this$chartVariables2.chartMinWidth;
                        var padding = chartLeadingPadding + chartTrailingPadding;
                        var chartWidth = this.offsetWidth - padding;
                        var annotationWidth = this._getAnnotationWidth(this.graphWidth || chartWidth);
                        var annotationLeadingMargin = this.chartVariables.projectionAnnotationLeadingMargin;
                        if (this.graphWidth) {
                            return this.graphWidth - annotationWidth - annotationLeadingMargin;
                        }
                        var offsetWidth = this.chartVariables.container && this.chartVariables.container.offsetWidth;
                        var totalWidth = offsetWidth - padding - annotationWidth - annotationLeadingMargin;
                        return Math.max(chartMinWidth, totalWidth);
                    }
                }, {
                    key: "_getAnnotationWidth",
                    value: function _getAnnotationWidth(chartWidth) {
                        var annotation = this.shadowRoot.getElementById("legend-right");
                        if (annotation && annotation.offsetWidth) {
                            return annotation.offsetWidth;
                        }
                        var legendMaxWidth = this.chartVariables.legendMaxWidth;
                        var maxWidthPercent = parseFloat(legendMaxWidth) / 100;
                        var maxWidth = chartWidth * maxWidthPercent;
                        var expectedWidth;
                        if (this.legendWidth && this.legendWidth.match(/%/)) {
                            expectedWidth = chartWidth * (parseFloat(this.legendWidth) / 100);
                        } else if (this.legendWidth) {
                            expectedWidth = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])(this.legendWidth);
                        } else {
                            expectedWidth = maxWidth;
                        }
                        return Math.min(maxWidth, expectedWidth);
                    }
                }, {
                    key: "_createSeries",
                    value: function _createSeries() {
                        var _this2 = this;
                        var barOrder = {
                            highProjectionBar: 0,
                            mediumProjectionBar: 1,
                            lowProjectionBar: 2,
                            currentMeasureBar: 3
                        };
                        this._series = Object.keys(this.bars).map(function(key) {
                            _newArrowCheck(this, _this2);
                            var _this$_calculateDimen = this._calculateDimensions(key, this.bars[key].value), height = _this$_calculateDimen.height, width = _this$_calculateDimen.width;
                            return {
                                barOrder: barOrder[key],
                                key: this.bars[key].key,
                                barHeight: height,
                                barWidth: width,
                                type: key === "currentMeasureBar" ? "currentMeasure" : "reference",
                                value: this.bars[key].value
                            };
                        }.bind(this));
                        this._series.sort(function(a, b) {
                            _newArrowCheck(this, _this2);
                            return a.barOrder - b.barOrder;
                        }.bind(this));
                        this._adjustWidthThreshold();
                    }
                }, {
                    key: "_createSVG",
                    value: function _createSVG() {
                        this.chartVariables.svg && this.chartVariables.svg.remove();
                        var svgContainer = this.shadowRoot.querySelector(".projection-bar-chart__svg-container");
                        this.chartVariables.svg = d3__WEBPACK_IMPORTED_MODULE_1__["select"](svgContainer).append("svg").attr("width", this.chartVariables.width).attr("height", this.graphHeight);
                    }
                }, {
                    key: "_calculateDimensions",
                    value: function _calculateDimensions(key, value) {
                        var maxWidth = this.highProjectionBarWidth;
                        var maxHeight = this.graphHeight;
                        var strongValue = this.bars.highProjectionBar.value;
                        var mediumValue = this.bars.mediumProjectionBar.value;
                        var threshold = mediumValue / strongValue >= this.chartVariables.maxBarValueRatioThreshold;
                        var heightSensitivity = threshold ? this.chartVariables.maxBarHeightSensitivity : this.chartVariables.minBarHeightSensitivity;
                        var ratio = value / strongValue;
                        var height = maxHeight * Math.pow(ratio, heightSensitivity);
                        var width = maxWidth * Math.pow(ratio, 1 - heightSensitivity);
                        if (key === "highProjectionBar") {
                            return {
                                height: maxHeight,
                                width: maxWidth
                            };
                        }
                        return {
                            height: height,
                            width: width
                        };
                    }
                }, {
                    key: "_adjustWidthThreshold",
                    value: function _adjustWidthThreshold() {
                        var _this3 = this;
                        this._series.forEach(function(bar) {
                            _newArrowCheck(this, _this3);
                            if (bar.barOrder === 1) {
                                if (bar.barWidth > this._series[0].barWidth - 8) {
                                    var obj = {
                                        barWidth: this._series[0].barWidth - 8
                                    };
                                    _extends(bar, obj);
                                }
                            } else if (bar.barOrder === 2) {
                                if (bar.barWidth > this._series[1].barWidth - 8) {
                                    var _obj = {
                                        barWidth: this._series[1].barWidth - 8
                                    };
                                    _extends(bar, _obj);
                                }
                            }
                        }.bind(this));
                    }
                }, {
                    key: "_createScales",
                    value: function _createScales() {
                        var xRange = [ 0, this.chartVariables.width ];
                        var xDomain = [ "currentMeasure", "reference" ];
                        var yRange = [ this.graphHeight, 0 ];
                        var yDomain = [ 0, this.graphHeight ];
                        this.chartVariables.xScale = d3__WEBPACK_IMPORTED_MODULE_1__["scaleBand"]().range(xRange).domain(xDomain);
                        this.chartVariables.yScale = d3__WEBPACK_IMPORTED_MODULE_1__["scaleLinear"]().domain(yDomain).range(yRange);
                    }
                }, {
                    key: "_addBars",
                    value: function _addBars() {
                        var _this4 = this;
                        var barsSVG = this.chartVariables.svg.selectAll("rect").data(this._series);
                        barsSVG.enter().append("rect").attr("x", function(d) {
                            _newArrowCheck(this, _this4);
                            return this._generateXOffset(d.type);
                        }.bind(this)).attr("y", function(d) {
                            _newArrowCheck(this, _this4);
                            return d.type === "currentMeasure" ? this.chartVariables.yScale(d.barHeight) : this.chartVariables.yScale(0);
                        }.bind(this)).attr("width", function(d) {
                            _newArrowCheck(this, _this4);
                            return d.type === "currentMeasure" ? d.barWidth : 0;
                        }.bind(this)).attr("height", function(d) {
                            _newArrowCheck(this, _this4);
                            return d.type === "currentMeasure" ? this.chartVariables.yScale(0) - this.chartVariables.yScale(d.barHeight) : 0;
                        }.bind(this)).attr("stroke-dasharray", function(d) {
                            _newArrowCheck(this, _this4);
                            return d.barWidth + d.barHeight;
                        }.bind(this));
                        var t = d3__WEBPACK_IMPORTED_MODULE_1__["transition"]();
                        barsSVG.enter().selectAll("rect").transition(t).attr("class", function(d) {
                            _newArrowCheck(this, _this4);
                            return "bar--".concat(this._mapBarSize(d));
                        }.bind(this)).attr("y", function(d) {
                            _newArrowCheck(this, _this4);
                            return this.chartVariables.yScale(d.barHeight);
                        }.bind(this)).attr("width", function(d) {
                            _newArrowCheck(this, _this4);
                            return d.barWidth;
                        }.bind(this)).attr("height", function(d) {
                            _newArrowCheck(this, _this4);
                            return this.chartVariables.yScale(0) - this.chartVariables.yScale(d.barHeight);
                        }.bind(this));
                        this._renderBarAnnotations();
                    }
                }, {
                    key: "_mapTransitionDelay",
                    value: function _mapTransitionDelay(bar) {
                        if (bar.value === this.bars.highProjectionBar.value) {
                            return "".concat(this.chartVariables.highProjectionBarTransitionDelay, "ms");
                        } else if (bar.value === this.bars.mediumProjectionBar.value) {
                            return "".concat(this.chartVariables.mediumProjectionBarTransitionDelay, "ms");
                        }
                        return "".concat(this.chartVariables.lowProjectionBarTransitionDelay, "ms");
                    }
                }, {
                    key: "_mapBarSize",
                    value: function _mapBarSize(bar) {
                        if (bar.value === this.bars.highProjectionBar.value) {
                            return "high";
                        } else if (bar.value === this.bars.mediumProjectionBar.value) {
                            return "medium";
                        } else if (bar.value === this.bars.lowProjectionBar.value) {
                            return "low";
                        }
                        return "current";
                    }
                }, {
                    key: "_generateXOffset",
                    value: function _generateXOffset(type) {
                        var _this5 = this;
                        if (type === "reference") {
                            var currentMeasureBarWidth = this._series.filter(function(bar) {
                                _newArrowCheck(this, _this5);
                                return bar.type === "currentMeasure";
                            }.bind(this))[0].barWidth;
                            var projectedOffset = this.chartVariables.width - this.highProjectionBarWidth;
                            return Math.max(projectedOffset, currentMeasureBarWidth + this.chartVariables.interBarMinPadding);
                        }
                        return this.chartVariables.xScale(type);
                    }
                }, {
                    key: "_wrapLabels",
                    value: function _wrapLabels(selectionToWrap, type) {
                        var chartContext = this;
                        selectionToWrap.each((function applyWrap() {
                            var _chartContext$chartVa = chartContext.chartVariables, annotationLabelLineHeight = _chartContext$chartVa.annotationLabelLineHeight, interBarMinPadding = _chartContext$chartVa.interBarMinPadding, currentMeasureAnnotationBottomMargin = _chartContext$chartVa.currentMeasureAnnotationBottomMargin, barLabelConfig = _chartContext$chartVa.barLabelConfig;
                            var maxWidth = chartContext._generateXOffset("reference") - chartContext._generateXOffset("currentMeasure") - interBarMinPadding;
                            var _textWrap = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["textWrap"])(d3__WEBPACK_IMPORTED_MODULE_1__, d3__WEBPACK_IMPORTED_MODULE_1__["select"](this), maxWidth, annotationLabelLineHeight, "px"), extraLines = _textWrap.extraLines;
                            if (extraLines) {
                                barLabelConfig["".concat(type, "Wrapped")] = true;
                                barLabelConfig["".concat(type, "Height")] = annotationLabelLineHeight * (extraLines + 1) + currentMeasureAnnotationBottomMargin;
                                barLabelConfig["".concat(type, "ExtraLines")] = extraLines;
                            }
                        }));
                    }
                }, {
                    key: "_renderBarAnnotations",
                    value: function _renderBarAnnotations() {
                        var _this6 = this;
                        var filteredSeries = this._series.filter(function(bar) {
                            _newArrowCheck(this, _this6);
                            return bar.type === "currentMeasure";
                        }.bind(this));
                        var formatter = this._getFormatter(this.d3BarLabelFormatString);
                        this.chartVariables.barLabelConfig = {};
                        var attributes = {
                            "font-size": this.chartVariables.annotationKeyTextSize,
                            x: this.chartVariables.xScale("currentMeasure")
                        };
                        this.chartVariables.labelGroups = this.chartVariables.svg.selectAll("g").data(filteredSeries).join("g").attr("class", "bar__label--group");
                        var secondaryLabels = this.chartVariables.labelGroups.append("text").text(function(bar) {
                            _newArrowCheck(this, _this6);
                            return formatter(bar.value);
                        }.bind(this)).attr("y", function(d) {
                            _newArrowCheck(this, _this6);
                            return this._generateBarLabelYOffset(d, true);
                        }.bind(this)).attr("class", "bar__label--secondary");
                        Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["applyAttributes"])(secondaryLabels, attributes);
                        this._wrapLabels(this.chartVariables.labelGroups.selectAll(".bar__label--secondary"), "secondary");
                        var primaryLabel = this.chartVariables.labelGroups.append("text").text(function(bar) {
                            _newArrowCheck(this, _this6);
                            return bar.key;
                        }.bind(this)).attr("y", function(d) {
                            _newArrowCheck(this, _this6);
                            return this._generateBarLabelYOffset(d);
                        }.bind(this)).attr("class", "bar__label--primary");
                        Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_5__["applyAttributes"])(primaryLabel, attributes);
                        this._wrapLabels(this.chartVariables.labelGroups.selectAll(".bar__label--primary"), "primary");
                        if (this.chartVariables.barLabelConfig.primaryWrapped) {
                            primaryLabel.attr("y", function(d) {
                                _newArrowCheck(this, _this6);
                                return this._generateBarLabelYOffset(d);
                            }.bind(this));
                            primaryLabel.selectAll("tspan").attr("y", function(d) {
                                _newArrowCheck(this, _this6);
                                return this._generateBarLabelYOffset(d);
                            }.bind(this));
                        }
                        if (this.chartVariables.barLabelConfig.secondaryWrapped) {
                            secondaryLabels.attr("y", function(d) {
                                _newArrowCheck(this, _this6);
                                return this._generateBarLabelYOffset(d, true);
                            }.bind(this));
                            secondaryLabels.selectAll("tspan").attr("y", function(d) {
                                _newArrowCheck(this, _this6);
                                return this._generateBarLabelYOffset(d);
                            }.bind(this));
                        }
                    }
                }, {
                    key: "_repositionLegend",
                    value: function _repositionLegend() {
                        var content = this.shadowRoot.getElementById("legend-content");
                        var annotation = this.shadowRoot.getElementById("legend-right");
                        var labelRect = this.chartVariables.labelGroups.node().getBoundingClientRect();
                        var svgRect = this.chartVariables.svg.node().getBoundingClientRect();
                        var marginTopBarLabel = Math.max(svgRect.top - labelRect.top, 0);
                        var marginTopRightLegend = 0;
                        if (content.scrollHeight > this.graphHeight) {
                            annotation.style.alignSelf = "flex-end";
                            marginTopRightLegend = content.offsetHeight - this.graphHeight;
                        } else {
                            annotation.style.alignSelf = "";
                        }
                        var marginTop = Math.max(marginTopRightLegend, marginTopBarLabel);
                        this.chartVariables.container.style.marginTop = "".concat(marginTop, "px");
                    }
                }, {
                    key: "_generateBarLabelYOffset",
                    value: function _generateBarLabelYOffset(bar) {
                        var isSecondary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                        var _this$chartVariables3 = this.chartVariables, annotationLabelLineHeight = _this$chartVariables3.annotationLabelLineHeight, annotationLabelTextSize = _this$chartVariables3.annotationLabelTextSize, currentMeasureAnnotationBottomMargin = _this$chartVariables3.currentMeasureAnnotationBottomMargin, barLabelConfig = _this$chartVariables3.barLabelConfig;
                        var otherLabelOffset = barLabelConfig[isSecondary ? "primaryHeight" : "secondaryHeight"] || annotationLabelLineHeight + currentMeasureAnnotationBottomMargin;
                        var offsetFromOtherLabel = !isSecondary && otherLabelOffset || 0;
                        var barOffset = this.chartVariables.yScale(bar.barHeight);
                        var extraLineOffset = (barLabelConfig[isSecondary ? "secondaryExtraLines" : "primaryExtraLines"] || 0) * annotationLabelLineHeight;
                        var lineHeightOffset = (annotationLabelLineHeight - annotationLabelTextSize) / 2;
                        return barOffset - extraLineOffset - lineHeightOffset - currentMeasureAnnotationBottomMargin - offsetFromOtherLabel;
                    }
                }, {
                    key: "_addBaseline",
                    value: function _addBaseline() {
                        var _this$chartVariables4 = this.chartVariables, xScale = _this$chartVariables4.xScale, yScale = _this$chartVariables4.yScale, svg = _this$chartVariables4.svg;
                        var x0 = xScale.range()[0];
                        var x1 = this.chartVariables.baselineLength;
                        var y = yScale(0);
                        svg.append("path").attr("class", "baseline").attr("d", "M".concat(x0, ",").concat(y, "L").concat(x1, ",").concat(y));
                    }
                }, {
                    key: "_getFormatter",
                    value: function _getFormatter(formatString, functionName) {
                        var _this7 = this;
                        var formatter;
                        if (this.d3PrefixFormatter) {
                            formatter = formatString ? function(value) {
                                _newArrowCheck(this, _this7);
                                return d3__WEBPACK_IMPORTED_MODULE_1__["formatPrefix"](formatString, value)(value).replace("G", "B").replace("k", "K");
                            }.bind(this) : this[functionName];
                        } else {
                            formatter = formatString ? function(value) {
                                _newArrowCheck(this, _this7);
                                return d3__WEBPACK_IMPORTED_MODULE_1__["format"](formatString)(value).replace("G", "B").replace("k", "K");
                            }.bind(this) : this[functionName];
                        }
                        if (typeof formatter !== "function") {
                            formatter = function formatter(_) {
                                _newArrowCheck(this, _this7);
                                return _;
                            }.bind(this);
                        }
                        return formatter;
                    }
                }, {
                    key: "_isEmpty",
                    value: function _isEmpty() {
                        return !this.bars || !this.bars.highProjectionBar || !this.bars.mediumProjectionBar || !this.bars.lowProjectionBar || !this.bars.currentMeasureBar || !this.bars.highProjectionBar.value || !this.bars.mediumProjectionBar.value || !this.bars.lowProjectionBar.value || typeof this.bars.currentMeasureBar.value !== "number";
                    }
                }, {
                    key: "_hasPositiveCurrentMeasure",
                    value: function _hasPositiveCurrentMeasure() {
                        return this.bars && this.bars.currentMeasureBar && this.bars.currentMeasureBar.value && this.bars.currentMeasureBar.value > 0;
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback(prop) {
                        var _this8 = this;
                        _get(_getPrototypeOf(MdsProjectionBarChart.prototype), "renderedCallback", this) && _get(_getPrototypeOf(MdsProjectionBarChart.prototype), "renderedCallback", this).call(this, prop);
                        if (this._isEmpty()) {
                            this.chartVariables.svg && this.chartVariables.svg.remove();
                            this.chartVariables.svg = null;
                        } else {
                            setTimeout(function() {
                                _newArrowCheck(this, _this8);
                                this.renderChart(prop);
                            }.bind(this));
                        }
                    }
                }, {
                    key: "_renderEmptyChart",
                    value: function _renderEmptyChart() {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__empty-chart"));
                        _renderArbitrary(this.noDataPointText);
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_renderNonPoisitiveCurrentMeasureChart",
                    value: function _renderNonPoisitiveCurrentMeasureChart(formatter) {
                        var _valueClasses;
                        this._setDimensionVariables();
                        var valueClasses = (_valueClasses = {}, _defineProperty(_valueClasses, "".concat(this.rootClass, "__non-positive__current-measure__value"), true), 
                        _defineProperty(_valueClasses, "".concat(this.rootClass, "__non-positive__current-measure__value--negative"), this.bars.currentMeasureBar.value < 0), 
                        _valueClasses);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__non-positive-chart"), "style", "height: ".concat(this.graphHeight, "px; width: ").concat(this.chartVariables.width, "px;"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__non-positive__current-measure"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "".concat(this.rootClass, "__non-positive__current-measure__key"));
                        _renderArbitrary(this.bars.currentMeasureBar.key);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", valueClasses);
                        _renderArbitrary(this.bars.currentMeasureBar.value);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__non-positive__message"));
                        _renderArbitrary(this.message);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_generateAccessibleDescription",
                    value: function _generateAccessibleDescription(formatter) {
                        var desc = [];
                        desc.push(this.bars.currentMeasureBar.key, d3__WEBPACK_IMPORTED_MODULE_1__["format"]("$")(this.bars.currentMeasureBar.value), this.legendLabel ? this.legendLabel : "", this.bars.highProjectionBar.key, d3__WEBPACK_IMPORTED_MODULE_1__["format"]("$")(this.bars.highProjectionBar.value), this.bars.mediumProjectionBar.key, d3__WEBPACK_IMPORTED_MODULE_1__["format"]("$")(this.bars.mediumProjectionBar.value), this.bars.lowProjectionBar.key, d3__WEBPACK_IMPORTED_MODULE_1__["format"]("$")(this.bars.lowProjectionBar.value));
                        return desc.join(". ");
                    }
                }, {
                    key: "_renderLegend",
                    value: function _renderLegend(formatter) {
                        var _this9 = this;
                        var filteredSeries = this._series.filter(function(bar) {
                            _newArrowCheck(this, _this9);
                            return bar.type === "reference";
                        }.bind(this));
                        var style = "width: ".concat(this.legendWidth, ";");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "legend-right");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", "projection-bar-chart__legend-right");
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_7__["conditionalAttribute"])({
                            style: style
                        }, this.legendWidth));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("aria-hidden", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "legend-content");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("ul", null, null, "class", "projection-bar-chart__legend-list-container");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "projection-bar-chart__legend-title");
                        _renderArbitrary(this.legendLabel);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(filteredSeries.map(function(series) {
                            _newArrowCheck(this, _this9);
                            return _jsxWrapper(_li$wrapper, [ "projection-bar-chart__legend-swatch projection-bar-chart__legend-swatch--".concat(this._mapBarSize(series)), series.key, formatter, series.value ]);
                        }.bind(this)));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("ul");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var classes = {
                            root: _defineProperty({}, "".concat(this.rootClass), true),
                            container: _defineProperty({}, "".concat(this.rootClass, "__chart-container"), true),
                            dataContainer: _defineProperty({}, "".concat(this.rootClass, "__data-container"), true),
                            chartBody: _defineProperty({}, "".concat(this.rootClass, "__chart-body"), true)
                        };
                        var idAccessibleTitle = "".concat(this.id, "-accessible-title");
                        var isEmpty = this._isEmpty();
                        var formatter;
                        if (!isEmpty) {
                            this._createSeries();
                            formatter = this._getFormatter(this.d3BarLabelFormatString);
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.root, "style", "width: ".concat(this.graphWidth, "px"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.chartBody);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text", "role", "img", "aria-labelledby", idAccessibleTitle);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true", "id", idAccessibleTitle);
                        _renderArbitrary(this.accessibleName);
                        _renderArbitrary(this.shortDescription);
                        _renderArbitrary(!(isEmpty || !this._hasPositiveCurrentMeasure()) && this._generateAccessibleDescription(formatter));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes.dataContainer);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("style", "height: ".concat(this.graphHeight, "px; width: ").concat(this.graphWidth, "px"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "chart-data-container");
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_7__["conditionalAttribute"])({
                            "aria-hidden": true
                        }, !(isEmpty || !this._hasPositiveCurrentMeasure())));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.container, "id", "chart-container");
                        _renderArbitrary(isEmpty ? this._renderEmptyChart() : !this._hasPositiveCurrentMeasure() ? this._renderNonPoisitiveCurrentMeasureChart(formatter) : (Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "projection-bar-chart__svg-container", "__skip", "true"), 
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])(), Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div")));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(!(isEmpty || !this._hasPositiveCurrentMeasure()) && this._renderLegend(formatter));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsProjectionBarChart;
            }(_abstract_chart__WEBPACK_IMPORTED_MODULE_4__["default"]), _class2.styles = _projection_bar_chart_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsProjectionBarChart;
        },
        "./src/projection-bar-chart/projection-bar-chart.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/projection-bar-chart/projection-bar-chart.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/projection-chart/index.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "lineEntity", (function() {
                return lineEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "yAxisEntity", (function() {
                return yAxisEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "xAxisEntity", (function() {
                return xAxisEntity;
            }));
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_0__);
            var _projection_line_chart__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("./src/projection-line-chart/index.jsx");
            var _abstract_chart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("./src/abstract-chart/index.jsx");
            var _dec, _class;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_0__["mixins"].AttributeMarshallingMixin, enumerables = _mixins$AttributeMars.enumerables, string = _mixins$AttributeMars.string, stringRequired = _mixins$AttributeMars.stringRequired, number = _mixins$AttributeMars.number, arrayOf = _mixins$AttributeMars.arrayOf, satisfies = _mixins$AttributeMars.satisfies;
            var lineEntity = {
                name: stringRequired,
                yValues: arrayOf(number)
            };
            var yAxisEntity = {
                axisType: enumerables(string, "log", "linear").defaultsTo("linear"),
                logBase: number.defaultsTo(10),
                d3TickFormatString: string,
                numTickLabels: number,
                range: arrayOf(number).withMaxLength(2).withMinLength(2)
            };
            var xAxisEntity = {
                numTickLabels: number.withMinSize(2),
                todayText: string.defaultsTo("Today"),
                tickSuffix: string.defaultsTo("yr")
            };
            var entity = _objectSpread({}, _abstract_chart__WEBPACK_IMPORTED_MODULE_2__["entity"], {
                xAxis: satisfies(xAxisEntity).withChangedCallback(),
                yAxis: satisfies(yAxisEntity).withChangedCallback(),
                legendHeadingPrefix: stringRequired,
                legendHeadingSuffixSingular: stringRequired,
                legendHeadingSuffixPlural: stringRequired,
                lines: arrayOf(satisfies(lineEntity)).withChangedCallback(),
                bandColor: string
            });
            var MdsProjectionChart = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_0__["stamp"])(entity), 
            _dec(_class = function(_MdsProjectionLineCha) {
                _inherits(MdsProjectionChart, _MdsProjectionLineCha);
                function MdsProjectionChart() {
                    _classCallCheck(this, MdsProjectionChart);
                    return _possibleConstructorReturn(this, _getPrototypeOf(MdsProjectionChart).apply(this, arguments));
                }
                _createClass(MdsProjectionChart, [ {
                    key: "render",
                    value: function render() {
                        console.error("MdsProjectionChart was renamed to MdsProjectionLineChart in Nov 2020. This component will be deprecated and removed in Nov 2021.");
                        _get(_getPrototypeOf(MdsProjectionChart.prototype), "render", this).call(this);
                    }
                } ], [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsProjectionChart";
                    }
                } ]);
                return MdsProjectionChart;
            }(_projection_line_chart__WEBPACK_IMPORTED_MODULE_1__["default"])) || _class);
            __webpack_exports__["default"] = MdsProjectionChart;
        },
        "./src/projection-line-chart/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "lineEntity", (function() {
                return lineEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "yAxisEntity", (function() {
                return yAxisEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "xAxisEntity", (function() {
                return xAxisEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var d3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d3");
            var d3__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(d3__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_2__);
            var _mds_projection_line_chart_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/projection-line-chart/mds-projection-line-chart.scss");
            var _mds_projection_line_chart_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_projection_line_chart_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _abstract_chart__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/abstract-chart/index.jsx");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/data-utils.js");
            var _utils_chart_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/chart-utils.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("./src/utils/common-utils.js");
            var _spreadAttribute = function _spreadAttribute(spread) {
                for (var prop in spread) if (_hasOwn.call(spread, prop)) Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])(prop, spread[prop]);
            };
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            function _slicedToArray(arr, i) {
                return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
            }
            function _nonIterableRest() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _iterableToArrayLimit(arr, i) {
                var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
                if (null != _i) {
                    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
                    try {
                        if (_x = (_i = _i.call(arr)).next, 0 === i) {
                            if (Object(_i) !== _i) return;
                            _n = !1;
                        } else for (;!(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) ;
                    } catch (err) {
                        _d = !0, _e = err;
                    } finally {
                        try {
                            if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
                        } finally {
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
            }
            function _arrayWithHoles(arr) {
                if (Array.isArray(arr)) return arr;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _extends() {
                _extends = Object.assign ? Object.assign.bind() : function(target) {
                    for (var i = 1; i < arguments.length; i++) {
                        var source = arguments[i];
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                    return target;
                };
                return _extends.apply(this, arguments);
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            function ownKeys(object, enumerableOnly) {
                var keys = Object.keys(object);
                if (Object.getOwnPropertySymbols) {
                    var symbols = Object.getOwnPropertySymbols(object);
                    enumerableOnly && (symbols = symbols.filter((function(sym) {
                        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                    }))), keys.push.apply(keys, symbols);
                }
                return keys;
            }
            function _objectSpread(target) {
                for (var i = 1; i < arguments.length; i++) {
                    var source = null != arguments[i] ? arguments[i] : {};
                    i % 2 ? ownKeys(Object(source), !0).forEach((function(key) {
                        _defineProperty(target, key, source[key]);
                    })) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach((function(key) {
                        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                    }));
                }
                return target;
            }
            function _defineProperty(obj, key, value) {
                key = _toPropertyKey(key);
                if (key in obj) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                } else {
                    obj[key] = value;
                }
                return obj;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            var _mixins$AttributeMars = _mds_agave__WEBPACK_IMPORTED_MODULE_2__["mixins"].AttributeMarshallingMixin, enumerables = _mixins$AttributeMars.enumerables, string = _mixins$AttributeMars.string, stringRequired = _mixins$AttributeMars.stringRequired, number = _mixins$AttributeMars.number, arrayOf = _mixins$AttributeMars.arrayOf, satisfies = _mixins$AttributeMars.satisfies;
            var lineEntity = {
                name: stringRequired,
                yValues: arrayOf(number)
            };
            var yAxisEntity = {
                axisType: enumerables(string, "log", "linear").defaultsTo("linear"),
                logBase: number.defaultsTo(10),
                d3TickFormatString: string,
                numTickLabels: number,
                range: arrayOf(number).withMaxLength(2).withMinLength(2)
            };
            var xAxisEntity = {
                numTickLabels: number.withMinSize(2),
                todayText: string.defaultsTo("Today"),
                tickSuffix: string.defaultsTo("yr")
            };
            var entity = _objectSpread({}, _abstract_chart__WEBPACK_IMPORTED_MODULE_4__["entity"], {
                xAxis: satisfies(xAxisEntity).withChangedCallback(),
                yAxis: satisfies(yAxisEntity).withChangedCallback(),
                legendHeadingPrefix: stringRequired,
                legendHeadingSuffixSingular: stringRequired,
                legendHeadingSuffixPlural: stringRequired,
                lines: arrayOf(satisfies(lineEntity)).withChangedCallback(),
                bandColor: string
            });
            var tokens = {
                xAxisMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_5__["cleanCssToPx"])("4px"),
                xAxisTickLineHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_5__["cleanCssToPx"])("1.25rem"),
                xAxisFirstTickLabelTrailingMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_5__["cleanCssToPx"])("8px"),
                yAxisMargin: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_5__["cleanCssToPx"])("16px"),
                chartMinHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_5__["cleanCssToPx"])("200px"),
                chartMinWidth: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_5__["cleanCssToPx"])("240px"),
                chartTrailingPadding: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_5__["cleanCssToPx"])("16px"),
                chartLeadingPadding: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_5__["cleanCssToPx"])("16px")
            };
            var MdsProjectionLineChart = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_2__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AbstractChart) {
                _inherits(MdsProjectionLineChart, _AbstractChart);
                _createClass(MdsProjectionLineChart, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsProjectionLineChart";
                    }
                } ]);
                function MdsProjectionLineChart(props) {
                    var _this2 = this;
                    var _this;
                    _classCallCheck(this, MdsProjectionLineChart);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsProjectionLineChart).call(this, props));
                    _this.rootClass = "projection-line-chart";
                    _extends(_this.chartVariables, tokens);
                    _this.hoverVariables = {};
                    _this._moveDetailOnHover = _this._moveDetailOnHover.bind(_assertThisInitialized(_this));
                    _this.moveDetailEvent = Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_7__["createCustomEventDispatcher"])(function() {
                        _newArrowCheck(this, _this2);
                        return "move-detail";
                    }.bind(this), _assertThisInitialized(_this));
                    _this.defineObservedProperty("_legendRenderObserved", 1);
                    return _this;
                }
                _createClass(MdsProjectionLineChart, [ {
                    key: "renderChart",
                    value: function renderChart() {
                        if (this._isEmpty()) {
                            return;
                        }
                        this._setDimensionVariables();
                        this._createSVG();
                        this._addAxes();
                        this._addBand();
                        this._addBaseline();
                        this._addLines();
                        this._addHoverLine();
                    }
                }, {
                    key: "_setDimensionVariables",
                    value: function _setDimensionVariables() {
                        this.chartVariables.container = this.chartVariables.container || this.shadowRoot.getElementById("chart-container");
                        this.chartVariables.width = this.chartVariables.container && this.chartVariables.container.offsetWidth || this._getDefaultWidth();
                        this.chartVariables.height = this.chartVariables.container && this.chartVariables.container.offsetHeight || this._getDefaultHeight();
                    }
                }, {
                    key: "_getDefaultHeight",
                    value: function _getDefaultHeight() {
                        return Math.max(this.chartVariables.chartMinHeight, this.chartHeight);
                    }
                }, {
                    key: "_getDefaultWidth",
                    value: function _getDefaultWidth() {
                        var _this$chartVariables = this.chartVariables, chartTrailingPadding = _this$chartVariables.chartTrailingPadding, chartLeadingPadding = _this$chartVariables.chartLeadingPadding, chartMinWidth = _this$chartVariables.chartMinWidth;
                        var padding = chartLeadingPadding + chartTrailingPadding;
                        var totalWidth = this.offsetWidth - padding;
                        return Math.max(chartMinWidth, totalWidth);
                    }
                }, {
                    key: "_createSVG",
                    value: function _createSVG() {
                        this.chartVariables.svg && this.chartVariables.svg.remove();
                        var svgContainer = this.shadowRoot.querySelector(".projection-line-chart__svg-container");
                        this.chartVariables.svg = d3__WEBPACK_IMPORTED_MODULE_1__["select"](svgContainer).append("svg").attr("width", this.chartVariables.width).attr("height", this.chartVariables.height);
                        this.chartVariables.dataRegionGroup && this.chartVariables.dataRegionGroup.remove();
                        this.chartVariables.dataRegionGroup = this.chartVariables.svg.append("g");
                    }
                }, {
                    key: "_addAxes",
                    value: function _addAxes() {
                        this.chartVariables.yAxisWidth = this._addYAxis(this.chartVariables.xAxisMargin + this.chartVariables.xAxisTickLineHeight);
                        this._addXAxis();
                    }
                }, {
                    key: "_addYAxis",
                    value: function _addYAxis(xAxisHeight) {
                        var _this3 = this;
                        this.chartVariables.xAxisHeight = xAxisHeight;
                        this.chartVariables.yAxisHeight = this.chartVariables.height - xAxisHeight;
                        var range = [ this.chartVariables.yAxisHeight, 0 ];
                        if (this.yAxis.axisType === "log") {
                            this.chartVariables.yScale = d3__WEBPACK_IMPORTED_MODULE_1__["scaleLog"]().base(this.yAxis.logBase).domain(this.yAxis.range).range(range);
                        } else {
                            this.chartVariables.yScale = d3__WEBPACK_IMPORTED_MODULE_1__["scaleLinear"]().domain(this.yAxis.range).range(range);
                        }
                        var domainAndLineOffset = 9;
                        var axis = d3__WEBPACK_IMPORTED_MODULE_1__["axisRight"](this.chartVariables.yScale);
                        this._specifyTicks(axis);
                        axis.tickFormat(Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_6__["getFormatter"])(d3__WEBPACK_IMPORTED_MODULE_1__, this, this.yAxis.d3TickFormatString, "formatYAxis"));
                        this.chartVariables.yAxis = this.chartVariables.svg.append("g").attr("class", "y-axis").attr("transform", "translate(".concat(this.chartVariables.width - domainAndLineOffset, ", 0)")).call(axis).call(function(g) {
                            _newArrowCheck(this, _this3);
                            return g.select(".domain").remove();
                        }.bind(this)).call(function(g) {
                            _newArrowCheck(this, _this3);
                            return g.selectAll("line").remove();
                        }.bind(this));
                        this.chartVariables.yAxis.selectAll("text").attr("font-size", "".concat(this.chartVariables.yAxisTickSize, "px")).style("text-anchor", "end");
                        if (MDS.isFireFox) {
                            return Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_6__["getLargestTextWidth"])(this.chartVariables.yAxis, "text");
                        }
                        return this.chartVariables.yAxis.node().getBBox().width;
                    }
                }, {
                    key: "_specifyTicks",
                    value: function _specifyTicks(axis) {
                        var _this$yAxis = this.yAxis, numTickLabels = _this$yAxis.numTickLabels, range = _this$yAxis.range;
                        var ticks = [];
                        if (this.yAxis.axisType === "log") {
                            var base = this.yAxis.logBase;
                            var startingValue = range[0] === 0 ? 1 : range[0];
                            for (var i = 0; i <= numTickLabels; i += 1) {
                                ticks.push(startingValue * Math.pow(base, i));
                            }
                        } else {
                            var increment = Math.abs((range[1] - range[0]) / numTickLabels);
                            for (var _i = 0; _i <= numTickLabels; _i += 1) {
                                ticks.push(range[0] + increment * _i);
                            }
                        }
                        axis.tickValues(ticks);
                    }
                }, {
                    key: "_createXAxisLabels",
                    value: function _createXAxisLabels() {
                        var todayText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Today";
                        var tickSuffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "yr";
                        this.chartVariables.xAxisLabels = [];
                        this.chartVariables.xAxisLabels.push(todayText);
                        for (var i = 1; i < this.lines[0].yValues.length; i += 1) {
                            this.chartVariables.xAxisLabels.push(i.toString() + tickSuffix);
                        }
                        return this.chartVariables.xAxisLabels.length;
                    }
                }, {
                    key: "_addXAxis",
                    value: function _addXAxis() {
                        var _this$chartVariables2 = this.chartVariables, width = _this$chartVariables2.width, yAxisWidth = _this$chartVariables2.yAxisWidth, yAxisMargin = _this$chartVariables2.yAxisMargin, xAxisMargin = _this$chartVariables2.xAxisMargin;
                        var _this$xAxis = this.xAxis, todayText = _this$xAxis.todayText, tickSuffix = _this$xAxis.tickSuffix;
                        this._createXAxisLabels(todayText, tickSuffix);
                        var yAxisOffset = yAxisWidth + yAxisMargin;
                        this.chartVariables.xAxisWidth = width - yAxisOffset;
                        this.chartVariables.xScale = d3__WEBPACK_IMPORTED_MODULE_1__["scaleLinear"]().domain([ 0, this.lines[0].yValues.length - 1 ]).range([ 0, this.chartVariables.xAxisWidth ]);
                        var newXAxisHeight = xAxisMargin + this._renderXAxis(this.chartVariables.xScale, xAxisMargin);
                        return newXAxisHeight;
                    }
                }, {
                    key: "_renderXAxis",
                    value: function _renderXAxis(xScale, axisOffset) {
                        var _this4 = this;
                        var _this$chartVariables3 = this.chartVariables, svg = _this$chartVariables3.svg, height = _this$chartVariables3.height, xAxisLabels = _this$chartVariables3.xAxisLabels, xAxisTickLineHeight = _this$chartVariables3.xAxisTickLineHeight;
                        var axis = d3__WEBPACK_IMPORTED_MODULE_1__["axisBottom"](xScale).ticks(this.lines[0].yValues.length - 1).tickFormat(function(d, i) {
                            _newArrowCheck(this, _this4);
                            return xAxisLabels[i];
                        }.bind(this));
                        var axisGroup = svg.append("g").attr("class", "x-axis").attr("transform", "translate(0, ".concat(height - xAxisTickLineHeight - axisOffset, ")")).call(axis).call(function(g) {
                            _newArrowCheck(this, _this4);
                            return g.select(".domain").remove();
                        }.bind(this)).call(function(g) {
                            _newArrowCheck(this, _this4);
                            return g.selectAll("line").remove();
                        }.bind(this));
                        var increment = Math.floor(this.lines[0].yValues.length / this.xAxis.numTickLabels);
                        axisGroup.selectAll("text").filter(function(d, i) {
                            _newArrowCheck(this, _this4);
                            return i !== 0;
                        }.bind(this)).style("text-anchor", "end").attr("padding-left", this.chartVariables.xAxisTickLabelLeadingMargin);
                        axisGroup.selectAll("text").filter(function(d, i) {
                            _newArrowCheck(this, _this4);
                            return i % increment !== 0;
                        }.bind(this)).style("display", "none");
                        axisGroup.select("text").attr("padding-right", this.chartVariables.xAxisFirstTickLabelTrailingMargin);
                        return xAxisTickLineHeight;
                    }
                }, {
                    key: "_addBaseline",
                    value: function _addBaseline() {
                        var _this$chartVariables4 = this.chartVariables, xScale = _this$chartVariables4.xScale, yScale = _this$chartVariables4.yScale, svg = _this$chartVariables4.svg;
                        var y = yScale(this.yAxis.range[0]);
                        var _xScale$range = xScale.range(), _xScale$range2 = _slicedToArray(_xScale$range, 2), x0 = _xScale$range2[0], x1 = _xScale$range2[1];
                        svg.append("path").attr("class", "baseline").attr("d", "M".concat(x0, ",").concat(y, "L").concat(x1, ",").concat(y));
                    }
                }, {
                    key: "_addLines",
                    value: function _addLines() {
                        var _this5 = this;
                        this.chartVariables.drawLine = d3__WEBPACK_IMPORTED_MODULE_1__["line"]().x(function(d, i) {
                            _newArrowCheck(this, _this5);
                            return this.chartVariables.xScale(i);
                        }.bind(this)).y(function(d) {
                            _newArrowCheck(this, _this5);
                            return this.chartVariables.yScale(d);
                        }.bind(this)).curve(d3__WEBPACK_IMPORTED_MODULE_1__["curveMonotoneX"]);
                        this._renderOneLine(0);
                        this._renderOneLine(1);
                        this._renderOneLine(2);
                    }
                }, {
                    key: "_renderOneLine",
                    value: function _renderOneLine() {
                        var lineOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
                        var lineAttributes = {
                            class: "line"
                        };
                        if (lineOrder === 0) {
                            _extends(lineAttributes, {
                                class: "line line--top"
                            });
                        } else if (lineOrder === 2) {
                            _extends(lineAttributes, {
                                class: "line line--bottom"
                            });
                        }
                        var line = this.chartVariables.dataRegionGroup.append("path").attr("d", this.chartVariables.drawLine(this.lines[lineOrder].yValues));
                        Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_6__["applyAttributes"])(line, lineAttributes);
                    }
                }, {
                    key: "_addBand",
                    value: function _addBand() {
                        var _this6 = this;
                        this.chartVariables.drawBand = d3__WEBPACK_IMPORTED_MODULE_1__["area"]().x(function(d, i) {
                            _newArrowCheck(this, _this6);
                            return this.chartVariables.xScale(i);
                        }.bind(this)).y0(this.chartVariables.height - this.chartVariables.xAxisHeight).y1(function(d) {
                            _newArrowCheck(this, _this6);
                            return this.chartVariables.yScale(d);
                        }.bind(this)).curve(d3__WEBPACK_IMPORTED_MODULE_1__["curveMonotoneX"]);
                        this._renderBand(0);
                        this._renderBand(2);
                    }
                }, {
                    key: "_renderBand",
                    value: function _renderBand(lineOrder) {
                        var customClass = this.bandColor ? "area--custom" : "area";
                        var bandAttributes = {
                            class: "".concat(customClass),
                            fill: this.bandColor
                        };
                        if (lineOrder === 2) {
                            _extends(bandAttributes, {
                                class: "area area--bottom"
                            });
                        }
                        var band = this.chartVariables.dataRegionGroup.append("path").attr("d", this.chartVariables.drawBand(this.lines[lineOrder].yValues));
                        Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_6__["applyAttributes"])(band, bandAttributes);
                    }
                }, {
                    key: "_addHoverLine",
                    value: function _addHoverLine() {
                        this.hoverVariables.referenceLineContainer = this.chartVariables.dataRegionGroup;
                        this.hoverVariables.hoverContainer = this.chartVariables.svg.append("rect").attr("class", "mouse-over-effects").attr("height", this.chartVariables.height - this.chartVariables.xAxisHeight - this.chartVariables.xAxisMargin).attr("width", this.chartVariables.width - this.chartVariables.yAxisWidth - this.chartVariables.yAxisMargin).attr("fill", "none").style("pointer-events", "all").on("mousemove", Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_7__["throttle"])(this._moveDetailOnHover)).on("touchmove", Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_7__["throttle"])(this._moveDetailOnHover)).on("touchstart", this._moveDetailOnHover);
                        var finalX = this.lines[0].yValues.length - 1;
                        this._renderHoverLine(finalX);
                        this.hoverVariables.xValue = finalX;
                        this.hoverVariables.circles = [];
                        var finalDataPoint = this._findDataPointAtXValue(finalX);
                        this._renderHoverCircle(0, finalX, finalDataPoint.y0);
                        this._renderHoverCircle(1, finalX, finalDataPoint.y1);
                        this._renderHoverCircle(2, finalX, finalDataPoint.y2);
                    }
                }, {
                    key: "_renderHoverLine",
                    value: function _renderHoverLine(xValue) {
                        this.hoverVariables.hoverLine = this.hoverVariables.referenceLineContainer.append("line").attr("class", "mouse-line").attr("transform", "translate(".concat(this.chartVariables.xScale(xValue), ", 0)")).attr("y1", "-".concat(Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_5__["cleanCssToPx"])("16px"))).attr("y2", this.chartVariables.height - this.chartVariables.xAxisHeight);
                    }
                }, {
                    key: "_moveDetailOnHover",
                    value: function _moveDetailOnHover() {
                        var location = d3__WEBPACK_IMPORTED_MODULE_1__["mouse"](this.hoverVariables.hoverContainer.node())[0];
                        var hoverXValue = this.chartVariables.xScale.invert(location);
                        var closestPointData = this._getClosestPointData(hoverXValue);
                        this.hoverVariables.xValue = closestPointData.closestIndex;
                        this.hoverVariables.hoverLine.attr("transform", "translate(".concat(this.chartVariables.xScale(this.hoverVariables.xValue), ", 0)"));
                        this._moveCircles();
                        this.moveDetailEvent(d3__WEBPACK_IMPORTED_MODULE_1__["event"]);
                        this._legendRenderObserved += 1;
                    }
                }, {
                    key: "_findDataPointAtXValue",
                    value: function _findDataPointAtXValue(x) {
                        var y0 = this.lines[0].yValues[x];
                        var y1 = this.lines[1].yValues[x];
                        var y2 = this.lines[2].yValues[x];
                        var dataAtX = {
                            x: x,
                            y0: y0,
                            y1: y1,
                            y2: y2
                        };
                        return dataAtX;
                    }
                }, {
                    key: "_getClosestPointData",
                    value: function _getClosestPointData(hoverXValue) {
                        var _this7 = this;
                        var points = [];
                        this.lines.forEach(function(line, i) {
                            var _this8 = this;
                            _newArrowCheck(this, _this7);
                            var nextIndex = Math.min(d3__WEBPACK_IMPORTED_MODULE_1__["bisector"](function(d) {
                                _newArrowCheck(this, _this8);
                                return d;
                            }.bind(this)).left(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_7__["convertRange"])(0, line.yValues.length - 1), hoverXValue, 1), line.yValues.length - 1);
                            var _this$_getClosestData = this._getClosestDataPointIndex(hoverXValue, nextIndex, Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_7__["convertRange"])(0, line.yValues.length - 1)), closestIndex = _this$_getClosestData.closestIndex, difference = _this$_getClosestData.difference;
                            points.push({
                                closestIndex: closestIndex,
                                difference: difference,
                                lineIndex: i
                            });
                        }.bind(this));
                        return points.reduce(function(minPoint, nextPoint) {
                            _newArrowCheck(this, _this7);
                            return minPoint.difference < nextPoint.difference ? minPoint : nextPoint;
                        }.bind(this), points[0]);
                    }
                }, {
                    key: "_getClosestDataPointIndex",
                    value: function _getClosestDataPointIndex(xValue, indexAbove, rangeX) {
                        var differenceAbove = Math.abs(xValue - rangeX[indexAbove]);
                        var aboveReturn = {
                            closestIndex: indexAbove,
                            difference: differenceAbove
                        };
                        if (indexAbove === 0) {
                            return aboveReturn;
                        }
                        var differenceBelow = Math.abs(xValue - rangeX[indexAbove - 1]);
                        return differenceAbove < differenceBelow ? aboveReturn : {
                            closestIndex: indexAbove - 1,
                            difference: differenceBelow
                        };
                    }
                }, {
                    key: "_renderHoverCircle",
                    value: function _renderHoverCircle(lineOrder, xValue, yValue) {
                        var translateX = this.chartVariables.xScale(xValue);
                        var translateY = this.chartVariables.yScale(yValue);
                        var radius = Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_5__["cleanCssToPx"])("10px") / 2;
                        var circleClasses = {
                            class: "detail-marker"
                        };
                        if (lineOrder === 0) {
                            _extends(circleClasses, {
                                class: "detail-marker detail-marker--top"
                            });
                        } else if (lineOrder === 2) {
                            _extends(circleClasses, {
                                class: "detail-marker detail-marker--bottom"
                            });
                        }
                        var hoverCircle = this.hoverVariables.referenceLineContainer.append("circle").attr("class", circleClasses.class).attr("r", radius).attr("cx", translateX).attr("cy", translateY);
                        this.hoverVariables.circles.push({
                            hoverCircle: hoverCircle,
                            xValue: xValue,
                            yValue: yValue
                        });
                    }
                }, {
                    key: "_moveCircles",
                    value: function _moveCircles() {
                        var dataPoint = this._findDataPointAtXValue(this.hoverVariables.xValue);
                        this._moveCircle.bind(this);
                        this._moveCircle(0, dataPoint.x, dataPoint.y0);
                        this._moveCircle(1, dataPoint.x, dataPoint.y1);
                        this._moveCircle(2, dataPoint.x, dataPoint.y2);
                    }
                }, {
                    key: "_moveCircle",
                    value: function _moveCircle(lineOrder, x, y) {
                        var translateX = this.chartVariables.xScale(x);
                        var translateY = this.chartVariables.yScale(y);
                        var circleData = this.hoverVariables.circles[lineOrder];
                        circleData.hoverCircle.attr("cx", translateX).attr("cy", translateY).style("display", "");
                        circleData.xValue = x;
                        circleData.yValue = y;
                    }
                }, {
                    key: "_renderLegend",
                    value: function _renderLegend() {
                        this.chartVariables.dataPointDetailYFormatter = Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_6__["getFormatter"])(d3__WEBPACK_IMPORTED_MODULE_1__, this, this.yAxis.d3TickFormatString, "formatYAxis");
                        var hoverValue = this._findDataPointAtXValue(this.hoverVariables.xValue || this.lines[0].yValues.length - 1);
                        var legendHeadingSuffix = this.hoverVariables.xValue === 1 ? this.legendHeadingSuffixSingular : this.legendHeadingSuffixPlural;
                        var legendHeading = this.hoverVariables.xValue === 0 ? this.xAxis.todayText || "Today" : "".concat(this.legendHeadingPrefix, " ").concat(hoverValue.x, " ").concat(legendHeadingSuffix);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "projection-line-chart__legend-container", "aria-hidden", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "projection-line-chart__legend-heading");
                        _renderArbitrary(legendHeading);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "projection-line-chart__legend-item-container");
                        _renderArbitrary(this._renderLegendItem({
                            name: this.lines[0].name,
                            yValue: hoverValue["y".concat(0)]
                        }, 0));
                        _renderArbitrary(this._renderLegendItem({
                            name: this.lines[1].name,
                            yValue: hoverValue["y".concat(1)]
                        }, 1));
                        _renderArbitrary(this._renderLegendItem({
                            name: this.lines[2].name,
                            yValue: hoverValue["y".concat(2)]
                        }, 2));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_renderLegendItem",
                    value: function _renderLegendItem(itemData, lineOrder) {
                        var yValue = itemData.yValue;
                        var lineName = itemData.name;
                        var legendClasses = {
                            class: "legend"
                        };
                        if (lineOrder === 0) {
                            _extends(legendClasses, {
                                class: "legend legend--top"
                            });
                        } else if (lineOrder === 2) {
                            _extends(legendClasses, {
                                class: "legend legend--bottom"
                            });
                        }
                        var swatchClasses = {
                            circle: {
                                "projection-line-chart__swatch-circle": true,
                                "projection-line-chart__swatch-circle--top": lineOrder === 0,
                                "projection-line-chart__swatch-circle--bottom": lineOrder === 2
                            },
                            swatch: {
                                "projection-line-chart__swatch": true,
                                "projection-line-chart__swatch--top": lineOrder === 0,
                                "projection-line-chart__swatch--primary": lineOrder === 1,
                                "projection-line-chart__swatch--bottom": lineOrder === 2
                            }
                        };
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "projection-line-chart__legend-item");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "projection-line-chart__swatch-wrapper");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("span", null, null, "class", swatchClasses.circle);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("div", null, null, "class", swatchClasses.swatch);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "projection-line-chart__legend-line-label");
                        _renderArbitrary(lineName);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "projection-line-chart__legend-value");
                        _renderArbitrary(this.chartVariables.dataPointDetailYFormatter ? this.chartVariables.dataPointDetailYFormatter(yValue) : Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_6__["getFormatter"])(d3__WEBPACK_IMPORTED_MODULE_1__, this, "dataPointDetailY")(yValue));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "_isEmpty",
                    value: function _isEmpty() {
                        var _this9 = this;
                        return !this.lines || this.lines.length === 0 || this.lines.every(function(line) {
                            _newArrowCheck(this, _this9);
                            return line.yValues.length === 0;
                        }.bind(this));
                    }
                }, {
                    key: "_renderEmptyChart",
                    value: function _renderEmptyChart() {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "".concat(this.rootClass, "__empty-chart"));
                        _renderArbitrary(this.noDataPointText);
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "xAxisChangedCallback",
                    value: function xAxisChangedCallback() {
                        if (this.xAxis && this.lines && this.lines[0] && this.lines[0].yValues && this.xAxis.numTickLabels > this.lines[0].yValues.length) {
                            this.throwConstraintError("The number of y-values in a projection line must be greater than or equal to the number of x-axis tick labels.");
                        }
                    }
                }, {
                    key: "yAxisChangedCallback",
                    value: function yAxisChangedCallback() {
                        var minValue = 0;
                        if (this.yAxis && this.yAxis.range && this.yAxis.range[minValue] < 0) {
                            this.throwConstraintError("yAxis range cannot be negative.");
                        }
                    }
                }, {
                    key: "linesChangedCallback",
                    value: function linesChangedCallback() {
                        if (this.lines && this.lines.length !== 0 && this.lines.length !== 3) {
                            this.throwConstraintError("There must be exactly three lines provided for Projection Chart.");
                        }
                        if (this.lines && this.lines[0] && (!this.lines[0].yValues || this.lines[0].yValues.length === 0)) {
                            this.throwConstraintError("The values of the x-axis labels depends on the length of lines[0].yValues");
                        }
                        if (this.lines && this.lines[0] && (this.lines[0].yValues[0] !== this.lines[1].yValues[0] || this.lines[1].yValues[0] !== this.lines[2].yValues[0])) {
                            this.throwConstraintError("All three lines must have the same starting yValue, to be plotted at Today");
                        }
                        if (this.xAxis && this.lines[0].yValues && this.xAxis.numTickLabels > this.lines[0].yValues.length) {
                            this.throwConstraintError("The number of y-values in a projection line must be greater than or equal to the number of x-axis tick labels.");
                        }
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback(prop) {
                        _get(_getPrototypeOf(MdsProjectionLineChart.prototype), "renderedCallback", this) && _get(_getPrototypeOf(MdsProjectionLineChart.prototype), "renderedCallback", this).call(this, prop);
                        if (this._isEmpty()) {
                            this.chartVariables.svg && this.chartVariables.svg.remove();
                            this.chartVariables.svg = null;
                        } else {
                            var isWidthChanged = !this.chartVariables.container || this.chartVariables.container.offsetWidth && this.chartVariables.container.offsetWidth !== this.chartVariables.width;
                            var container = this.shadowRoot.getElementById("chart-container");
                            var isChartDataChanged = !prop || prop.match(/(chartHeight|lines|xAxis|yAxis|bandColor)/);
                            if (container && (isWidthChanged || isChartDataChanged) && this.isConnected) {
                                this.renderChart(prop);
                            }
                        }
                    }
                }, {
                    key: "render",
                    value: function render() {
                        var _root, _dataContainer;
                        var classes = {
                            root: (_root = {}, _defineProperty(_root, "".concat(this.rootClass), true), _defineProperty(_root, "".concat(this.rootClass, "--").concat(this.chartSize), this.chartSize === true), 
                            _root),
                            dataContainer: (_dataContainer = {}, _defineProperty(_dataContainer, "".concat(this.rootClass, "__data-container"), true), 
                            _defineProperty(_dataContainer, "".concat(this.rootClass, "__data-container--with-legend"), true), 
                            _dataContainer),
                            container: _defineProperty({}, "".concat(this.rootClass, "__chart-container--with-axis"), true),
                            chartBody: _defineProperty({}, "".concat(this.rootClass, "__chart-body"), true)
                        };
                        var idAccessibleTitle = "".concat(this.id, "-accessible-title");
                        var isEmptyBoolean = this._isEmpty();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.root);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.chartBody);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "accessible-text", "role", "img", "aria-labelledby", idAccessibleTitle);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true", "id", idAccessibleTitle);
                        _renderArbitrary(this.accessibleName);
                        _renderArbitrary(this.shortDescription);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", classes.dataContainer);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenStart"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("class", classes.container);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("id", "chart-container");
                        _spreadAttribute(Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_7__["conditionalAttribute"])({
                            "aria-hidden": true
                        }, !isEmptyBoolean));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["attr"])("style", "height: ".concat(this.chartHeight, "px"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpenEnd"])("div");
                        _renderArbitrary(isEmptyBoolean && this._renderEmptyChart());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "class", "projection-line-chart__svg-container", "__skip", "true");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["skip"])();
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        _renderArbitrary(!isEmptyBoolean && this._renderLegend());
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsProjectionLineChart;
            }(_abstract_chart__WEBPACK_IMPORTED_MODULE_4__["default"]), _class2.styles = _mds_projection_line_chart_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2)) || _class);
            __webpack_exports__["default"] = MdsProjectionLineChart;
        },
        "./src/projection-line-chart/mds-projection-line-chart.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/projection-line-chart/mds-projection-line-chart.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/sparkline/index.jsx": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "dataPointEntity", (function() {
                return dataPointEntity;
            }));
            __webpack_require__.d(__webpack_exports__, "entity", (function() {
                return entity;
            }));
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("./node_modules/incremental-dom/dist/incremental-dom-cjs.js");
            var incremental_dom__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(incremental_dom__WEBPACK_IMPORTED_MODULE_0__);
            var d3__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("d3");
            var d3__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(d3__WEBPACK_IMPORTED_MODULE_1__);
            var _mds_agave__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("../agave/bundle/agave-polyfilled.cjs.js");
            var _mds_agave__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_mds_agave__WEBPACK_IMPORTED_MODULE_2__);
            var _mds_sparkline_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("./src/sparkline/mds-sparkline.scss");
            var _mds_sparkline_scss__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_mds_sparkline_scss__WEBPACK_IMPORTED_MODULE_3__);
            var _utils_chart_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("./src/utils/chart-utils.js");
            var _utils_common_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("./src/utils/common-utils.js");
            var _utils_data_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("./src/utils/data-utils.js");
            function _typeof(obj) {
                "@babel/helpers - typeof";
                return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                    return typeof obj;
                } : function(obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, _typeof(obj);
            }
            var _hasOwn = Object.prototype.hasOwnProperty;
            var _renderArbitrary = function _renderArbitrary(child) {
                var type = _typeof(child);
                if (type === "number" || type === "string" || type === "object" && child instanceof String) {
                    Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["text"])(child);
                } else if (Array.isArray(child)) {
                    for (var i = 0; i < child.length; i++) _renderArbitrary(child[i]);
                } else if (type === "object") {
                    if (child.__jsxDOMWrapper) {
                        var func = child.func, args = child.args;
                        if (args) {
                            func.apply(this, args);
                        } else {
                            func();
                        }
                    } else if (String(child) === "[object Object]") {
                        for (var prop in child) if (_hasOwn.call(child, i)) _renderArbitrary(child[i]);
                    }
                }
            };
            var _dec, _class, _class2;
            function _slicedToArray(arr, i) {
                return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
            }
            function _nonIterableRest() {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function _unsupportedIterableToArray(o, minLen) {
                if (!o) return;
                if (typeof o === "string") return _arrayLikeToArray(o, minLen);
                var n = Object.prototype.toString.call(o).slice(8, -1);
                if (n === "Object" && o.constructor) n = o.constructor.name;
                if (n === "Map" || n === "Set") return Array.from(o);
                if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
            }
            function _arrayLikeToArray(arr, len) {
                if (len == null || len > arr.length) len = arr.length;
                for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
                return arr2;
            }
            function _iterableToArrayLimit(arr, i) {
                var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
                if (null != _i) {
                    var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
                    try {
                        if (_x = (_i = _i.call(arr)).next, 0 === i) {
                            if (Object(_i) !== _i) return;
                            _n = !1;
                        } else for (;!(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) ;
                    } catch (err) {
                        _d = !0, _e = err;
                    } finally {
                        try {
                            if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
                        } finally {
                            if (_d) throw _e;
                        }
                    }
                    return _arr;
                }
            }
            function _arrayWithHoles(arr) {
                if (Array.isArray(arr)) return arr;
            }
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                    throw new TypeError("Cannot call a class as a function");
                }
            }
            function _possibleConstructorReturn(self, call) {
                if (call && (_typeof(call) === "object" || typeof call === "function")) {
                    return call;
                } else if (call !== void 0) {
                    throw new TypeError("Derived constructors may only return object or undefined");
                }
                return _assertThisInitialized(self);
            }
            function _assertThisInitialized(self) {
                if (self === void 0) {
                    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                }
                return self;
            }
            function _get() {
                if (typeof Reflect !== "undefined" && Reflect.get) {
                    _get = Reflect.get.bind();
                } else {
                    _get = function _get(target, property, receiver) {
                        var base = _superPropBase(target, property);
                        if (!base) return;
                        var desc = Object.getOwnPropertyDescriptor(base, property);
                        if (desc.get) {
                            return desc.get.call(arguments.length < 3 ? target : receiver);
                        }
                        return desc.value;
                    };
                }
                return _get.apply(this, arguments);
            }
            function _superPropBase(object, property) {
                while (!Object.prototype.hasOwnProperty.call(object, property)) {
                    object = _getPrototypeOf(object);
                    if (object === null) break;
                }
                return object;
            }
            function _getPrototypeOf(o) {
                _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
                    return o.__proto__ || Object.getPrototypeOf(o);
                };
                return _getPrototypeOf(o);
            }
            function _defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
                }
            }
            function _createClass(Constructor, protoProps, staticProps) {
                if (protoProps) _defineProperties(Constructor.prototype, protoProps);
                if (staticProps) _defineProperties(Constructor, staticProps);
                Object.defineProperty(Constructor, "prototype", {
                    writable: false
                });
                return Constructor;
            }
            function _toPropertyKey(arg) {
                var key = _toPrimitive(arg, "string");
                return _typeof(key) === "symbol" ? key : String(key);
            }
            function _toPrimitive(input, hint) {
                if (_typeof(input) !== "object" || input === null) return input;
                var prim = input[Symbol.toPrimitive];
                if (prim !== undefined) {
                    var res = prim.call(input, hint || "default");
                    if (_typeof(res) !== "object") return res;
                    throw new TypeError("@@toPrimitive must return a primitive value.");
                }
                return (hint === "string" ? String : Number)(input);
            }
            function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                    throw new TypeError("Super expression must either be null or a function");
                }
                subClass.prototype = Object.create(superClass && superClass.prototype, {
                    constructor: {
                        value: subClass,
                        writable: true,
                        configurable: true
                    }
                });
                Object.defineProperty(subClass, "prototype", {
                    writable: false
                });
                if (superClass) _setPrototypeOf(subClass, superClass);
            }
            function _setPrototypeOf(o, p) {
                _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
                    o.__proto__ = p;
                    return o;
                };
                return _setPrototypeOf(o, p);
            }
            var string = _mds_agave__WEBPACK_IMPORTED_MODULE_2__["MarshalerTypes"].string, enumerables = _mds_agave__WEBPACK_IMPORTED_MODULE_2__["MarshalerTypes"].enumerables, boolean = _mds_agave__WEBPACK_IMPORTED_MODULE_2__["MarshalerTypes"].boolean, number = _mds_agave__WEBPACK_IMPORTED_MODULE_2__["MarshalerTypes"].number, numberRequired = _mds_agave__WEBPACK_IMPORTED_MODULE_2__["MarshalerTypes"].numberRequired, arrayOf = _mds_agave__WEBPACK_IMPORTED_MODULE_2__["MarshalerTypes"].arrayOf, satisfies = _mds_agave__WEBPACK_IMPORTED_MODULE_2__["MarshalerTypes"].satisfies;
            var tokens = {
                branded: {
                    cpo: {
                        baseLineColor: "#414042",
                        gainLineColor: "#128842",
                        lossLineColor: "#bf2155",
                        brandLineColor: "#126bc5",
                        referenceLineColor: "#949494"
                    },
                    jpo: {
                        baseLineColor: "#414042",
                        gainLineColor: "#128842",
                        lossLineColor: "#bf2155",
                        brandLineColor: "#1570a3",
                        referenceLineColor: "#949494"
                    },
                    cpc: {
                        baseLineColor: "#414042",
                        gainLineColor: "#128842",
                        lossLineColor: "#bf2155",
                        brandLineColor: "#126bc5",
                        referenceLineColor: "#949494"
                    },
                    cmb: {
                        baseLineColor: "#101820",
                        gainLineColor: "#398100",
                        lossLineColor: "#b80009",
                        brandLineColor: "#005eb8",
                        referenceLineColor: "#8c8e90"
                    },
                    jmb: {
                        baseLineColor: "#101820",
                        gainLineColor: "#008259",
                        lossLineColor: "#a50034",
                        brandLineColor: "#005eb8",
                        referenceLineColor: "#8c8e90"
                    },
                    bcb: {
                        baseLineColor: "#414042",
                        gainLineColor: "#128842",
                        lossLineColor: "#bf2155",
                        brandLineColor: "#126bc5",
                        referenceLineColor: "#949494"
                    }
                },
                referenceLineDashLength: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("2px"),
                referenceLineDashGap: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("2px"),
                referenceLineThickness: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("1px"),
                finalValuePointRadius: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("4px") / 2,
                lineThickness: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("1px"),
                minHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("24px"),
                maxHeight: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("60px"),
                minWidth: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("40px"),
                maxWidth: Object(_utils_data_utils__WEBPACK_IMPORTED_MODULE_6__["cleanCssToPx"])("240px")
            };
            var dataPointEntity = {
                x: number,
                y: number
            };
            var entity = {
                accessibleName: string,
                accessibleDescription: string,
                lineColor: enumerables(string, "base", "gain", "loss", "brand").defaultsTo("base"),
                referenceLineValue: number,
                finalValuePoint: boolean,
                finalValuePointColor: enumerables(string, "base", "gain", "loss", "brand").defaultsTo("base"),
                xRange: arrayOf(number).withMinLength(2).withMaxLength(2),
                yRange: arrayOf(number).withMinLength(2).withMaxLength(2),
                dataPoints: arrayOf(satisfies(dataPointEntity)),
                chartHeight: numberRequired.withMinSize(tokens.minHeight).withMaxSize(tokens.maxHeight),
                noDataPointText: string
            };
            var MdsSparkline = (_dec = Object(_mds_agave__WEBPACK_IMPORTED_MODULE_2__["stamp"])(entity), 
            _dec(_class = (_class2 = function(_AgaveComponent) {
                _inherits(MdsSparkline, _AgaveComponent);
                _createClass(MdsSparkline, null, [ {
                    key: "getElementName",
                    value: function getElementName() {
                        return "MdsSparkline";
                    }
                } ]);
                function MdsSparkline() {
                    var _this;
                    _classCallCheck(this, MdsSparkline);
                    _this = _possibleConstructorReturn(this, _getPrototypeOf(MdsSparkline).call(this));
                    _this._chartVariables = {};
                    return _this;
                }
                _createClass(MdsSparkline, [ {
                    key: "_getToken",
                    value: function _getToken(name, branded) {
                        var tokenCollection = this.constructor._tokens;
                        if (branded) {
                            tokenCollection = tokenCollection.branded[MDS.brand || "cpo"];
                        }
                        return tokenCollection[name];
                    }
                }, {
                    key: "renderChart",
                    value: function renderChart() {
                        if (!this._isEmpty()) {
                            this._chartVariables.width = this._getWidth();
                            this._createScales();
                            this._setUpContainer();
                            !Object(_utils_common_utils__WEBPACK_IMPORTED_MODULE_5__["isNonZeroFalsy"])(this.referenceLineValue) && this._addReferenceLine();
                            this._addLine();
                            this._addFinalValuePoint();
                        }
                    }
                }, {
                    key: "_getWidth",
                    value: function _getWidth() {
                        var container = this.shadowRoot.getElementById("sparkline-container");
                        var containerWidth = container && container.offsetWidth;
                        if (!containerWidth) {
                            return this._getToken("minWidth");
                        }
                        return Math.max(this._getToken("minWidth"), Math.min(containerWidth, this._getToken("maxWidth")));
                    }
                }, {
                    key: "_createScales",
                    value: function _createScales() {
                        var _this$_generateRanges = this._generateRanges(), xDomain = _this$_generateRanges.xDomain, yDomain = _this$_generateRanges.yDomain;
                        var xRange = [ 0, this._chartVariables.width ];
                        var yRange = [ this.chartHeight, 0 ];
                        if (this.finalValuePoint) {
                            var finalValuePointRadius = this._getToken("finalValuePointRadius");
                            xRange[1] -= finalValuePointRadius;
                            yRange[1] += finalValuePointRadius;
                            yRange[0] -= finalValuePointRadius;
                        }
                        this._chartVariables.xScale = d3__WEBPACK_IMPORTED_MODULE_1__["scaleTime"]().domain(xDomain).range(xRange);
                        this._chartVariables.yScale = d3__WEBPACK_IMPORTED_MODULE_1__["scaleLinear"]().domain(yDomain).range(yRange);
                    }
                }, {
                    key: "_generateRanges",
                    value: function _generateRanges() {
                        var _this2 = this;
                        var isXRange = this.xRange && this.xRange.length === 2;
                        var isYRange = this.yRange && this.yRange.length === 2;
                        var domains = {
                            xDomain: isXRange ? this.xRange : [ this.dataPoints[0].x, this.dataPoints[0].x ],
                            yDomain: isYRange ? this.yRange : [ this.dataPoints[0].y, this.dataPoints[0].y ]
                        };
                        if (!isXRange || !isYRange) {
                            return this.dataPoints.reduce(function(currentDomains, dataPoint) {
                                _newArrowCheck(this, _this2);
                                var x = dataPoint.x, y = dataPoint.y;
                                !isXRange && this._updateRange(currentDomains.xDomain, x);
                                !isYRange && this._updateRange(currentDomains.yDomain, y);
                                return currentDomains;
                            }.bind(this), domains);
                        }
                        return domains;
                    }
                }, {
                    key: "_updateRange",
                    value: function _updateRange(range, point) {
                        var _range = _slicedToArray(range, 2), min = _range[0], max = _range[1];
                        if (point < min) {
                            range[0] = point;
                        } else if (point > max) {
                            range[1] = point;
                        }
                    }
                }, {
                    key: "_setUpContainer",
                    value: function _setUpContainer() {
                        this._chartVariables.svg = d3__WEBPACK_IMPORTED_MODULE_1__["select"](this.shadowRoot.getElementById("sparkline"));
                        var chartHeight = this.chartHeight;
                        var _this$_chartVariables = this._chartVariables, svg = _this$_chartVariables.svg, width = _this$_chartVariables.width;
                        Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_4__["applyAttributes"])(svg, {
                            height: chartHeight,
                            width: width
                        });
                        this._chartVariables.group && this._chartVariables.group.remove();
                        this._chartVariables.group = this._chartVariables.svg.append("g");
                    }
                }, {
                    key: "_addReferenceLine",
                    value: function _addReferenceLine() {
                        var _this$_chartVariables2 = this._chartVariables, xScale = _this$_chartVariables2.xScale, yScale = _this$_chartVariables2.yScale;
                        var dashLength = this._getToken("referenceLineDashLength");
                        var dashGap = this._getToken("referenceLineDashGap");
                        var xEnd = xScale(xScale.domain()[1]);
                        var y = yScale(this.referenceLineValue);
                        var attributes = {
                            stroke: this._getToken("referenceLineColor", true),
                            "stroke-dasharray": "".concat(dashLength, ", ").concat(dashGap),
                            "stroke-width": this._getToken("referenceLineThickness"),
                            d: "M0,".concat(y, "L").concat(xEnd, ",").concat(y)
                        };
                        Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_4__["applyAttributes"])(this._chartVariables.group.append("path"), attributes);
                    }
                }, {
                    key: "_addLine",
                    value: function _addLine() {
                        var _this3 = this;
                        var lineGenerator = d3__WEBPACK_IMPORTED_MODULE_1__["line"]().x(function(d) {
                            _newArrowCheck(this, _this3);
                            return this._chartVariables.xScale(new Date(d.x));
                        }.bind(this)).y(function(d) {
                            _newArrowCheck(this, _this3);
                            return this._chartVariables.yScale(d.y);
                        }.bind(this));
                        this._chartVariables.group.append("path").attr("class", "line").attr("fill", "none").attr("stroke", this._getToken("".concat(this.lineColor, "LineColor"), true)).attr("stroke-width", this._getToken("lineThickness")).attr("d", lineGenerator(this.dataPoints));
                    }
                }, {
                    key: "_addFinalValuePoint",
                    value: function _addFinalValuePoint() {
                        if (this.finalValuePoint) {
                            var _this$dataPoints = this.dataPoints[this.dataPoints.length - 1], x = _this$dataPoints.x, y = _this$dataPoints.y;
                            var color = this.lineColor !== "base" ? this.lineColor : this.finalValuePointColor;
                            var fill = this._getToken("".concat(color, "LineColor"), true);
                            Object(_utils_chart_utils__WEBPACK_IMPORTED_MODULE_4__["applyAttributes"])(this._chartVariables.group.append("circle"), {
                                cx: this._chartVariables.xScale(x),
                                cy: this._chartVariables.yScale(y),
                                r: this._getToken("finalValuePointRadius"),
                                fill: fill
                            });
                        }
                    }
                }, {
                    key: "_isEmpty",
                    value: function _isEmpty() {
                        return !this.dataPoints || this.dataPoints.length <= 1;
                    }
                }, {
                    key: "_conditionallyHideNoDataPointText",
                    value: function _conditionallyHideNoDataPointText() {
                        if (this._getWidth() < 200) {
                            this.shadowRoot.getElementById("sparkline-empty-text").classList.add("sparkline__empty-text--hidden");
                        }
                    }
                }, {
                    key: "renderedCallback",
                    value: function renderedCallback() {
                        _get(_getPrototypeOf(MdsSparkline.prototype), "renderedCallback", this) && _get(_getPrototypeOf(MdsSparkline.prototype), "renderedCallback", this).call(this);
                        this._isEmpty() ? this._conditionallyHideNoDataPointText() : this.renderChart();
                    }
                }, {
                    key: "_emptyRender",
                    value: function _emptyRender() {
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "sparkline-container", "class", "sparkline", "style", "height: ".concat(this.chartHeight, "px;"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("p", null, null, "id", "sparkline-empty-text", "class", "sparkline__empty-text");
                        _renderArbitrary(this.noDataPointText);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("p");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                }, {
                    key: "render",
                    value: function render() {
                        if (this._isEmpty()) {
                            return this._emptyRender();
                        }
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("div", null, null, "id", "sparkline-container", "class", "sparkline", "style", "height: ".concat(this.chartHeight, "px;"));
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "class", "sparkline__accessible-text", "role", "img", "aria-labelledby", "sparkline-label", "aria-describedby", "sparkline-description");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true", "id", "sparkline-label");
                        _renderArbitrary(this.accessibleName);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementOpen"])("span", null, null, "aria-hidden", "true", "id", "sparkline-description");
                        _renderArbitrary(this.accessibleDescription);
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("span");
                        Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementVoid"])("svg", null, null, "id", "sparkline");
                        return Object(incremental_dom__WEBPACK_IMPORTED_MODULE_0__["elementClose"])("div");
                    }
                } ]);
                return MdsSparkline;
            }(_mds_agave__WEBPACK_IMPORTED_MODULE_2___default.a), _class2.styles = _mds_sparkline_scss__WEBPACK_IMPORTED_MODULE_3___default.a, 
            _class2._tokens = tokens, _class2)) || _class);
            __webpack_exports__["default"] = MdsSparkline;
        },
        "./src/sparkline/mds-sparkline.scss": function(module, exports, __webpack_require__) {
            var result = __webpack_require__("./node_modules/css-loader/dist/cjs.js!./node_modules/postcss-loader/src/index.js?!./node_modules/sass-loader/dist/cjs.js?!./src/sparkline/mds-sparkline.scss");
            if (result && result.__esModule) {
                result = result.default;
            }
            if (typeof result === "string") {
                module.exports = result;
            } else {
                module.exports = result.toString();
            }
        },
        "./src/utils/chart-utils.js": function(module, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            __webpack_require__.d(__webpack_exports__, "textWrap", (function() {
                return textWrap;
            }));
            __webpack_require__.d(__webpack_exports__, "textWrapBreakFullWord", (function() {
                return textWrapBreakFullWord;
            }));
            __webpack_require__.d(__webpack_exports__, "textWrapBreakWord", (function() {
                return textWrapBreakWord;
            }));
            __webpack_require__.d(__webpack_exports__, "textWrapByCharacter", (function() {
                return textWrapByCharacter;
            }));
            __webpack_require__.d(__webpack_exports__, "applyAttributes", (function() {
                return applyAttributes;
            }));
            __webpack_require__.d(__webpack_exports__, "removeEndAxisTextNode", (function() {
                return removeEndAxisTextNode;
            }));
            __webpack_require__.d(__webpack_exports__, "isNegative", (function() {
                return isNegative;
            }));
            __webpack_require__.d(__webpack_exports__, "colorNegativeAxisTicks", (function() {
                return colorNegativeAxisTicks;
            }));
            __webpack_require__.d(__webpack_exports__, "getLargestTextWidth", (function() {
                return getLargestTextWidth;
            }));
            __webpack_require__.d(__webpack_exports__, "runArcTween", (function() {
                return runArcTween;
            }));
            __webpack_require__.d(__webpack_exports__, "isStringFalseOrUndefined", (function() {
                return isStringFalseOrUndefined;
            }));
            __webpack_require__.d(__webpack_exports__, "getFormatter", (function() {
                return getFormatter;
            }));
            function _newArrowCheck(innerThis, boundThis) {
                if (innerThis !== boundThis) {
                    throw new TypeError("Cannot instantiate an arrow function");
                }
            }
            function textWrap(d3, texts, maxWidth) {
                var lineHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1.1;
                var heightUnit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "em";
                var shouldAlwaysWrap = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
                var useYForDy = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
                var extraLines = 0;
                var overflows = false;
                texts.each((function wrap() {
                    var _this = this;
                    if (overflows) {
                        return;
                    }
                    var text = d3.select(this);
                    var words = text.text().split(/\s+/).filter(function(x) {
                        _newArrowCheck(this, _this);
                        return x !== "";
                    }.bind(this)).reverse();
                    var word;
                    var line = [];
                    var lineNumber = 0;
                    var y = text.attr("y");
                    var dy = useYForDy ? +y : 0;
                    var tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + heightUnit);
                    while (word = words.pop()) {
                        line.push(word);
                        tspan.text(line.join(" "));
                        var width = getWidth(tspan);
                        if (width > maxWidth || shouldAlwaysWrap) {
                            if (line.length === 1 && width > maxWidth) {
                                overflows = true;
                                return;
                            } else if (line.length !== 1) {
                                line.pop();
                                tspan.text(line.join(" "));
                                line = [ word ];
                                tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + heightUnit).text(word);
                                if (!words.length) {
                                    var finalLineWidth = getWidth(tspan);
                                    if (finalLineWidth > maxWidth) {
                                        overflows = true;
                                        return;
                                    }
                                }
                            }
                        }
                    }
                    extraLines = extraLines < lineNumber ? lineNumber : extraLines;
                }));
                return {
                    extraLines: extraLines,
                    overflows: overflows
                };
            }
            function textWrapBreakFullWord(d3, texts, maxWidth) {
                var lineHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1.1;
                var heightUnit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "em";
                var shouldAlwaysWrap = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
                var useYForDy = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
                var extraLines = 0;
                var overflows = false;
                texts.each((function wrap() {
                    var text = d3.select(this);
                    var words = text.text().split(/\s+/).reverse();
                    var word;
                    var tempLine = [];
                    var lineNumber = 0;
                    var y = text.attr("y");
                    var dy = useYForDy ? +y : 0;
                    var tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + heightUnit);
                    while (word = words.pop()) {
                        tempLine.push(word);
                        tspan.text(tempLine.join(" "));
                        var width = tempLine.join(" ").length * 7 + 4;
                        if (width > maxWidth || shouldAlwaysWrap) {
                            if (tempLine.length === 1) {
                                var charLineNumber = wrapCharacter(text, maxWidth, lineHeight, heightUnit, dy);
                                lineNumber += charLineNumber;
                                overflows = true;
                            }
                            if (tempLine.length !== 1) {
                                tempLine.pop();
                                tspan.text(tempLine.join(" "));
                                tempLine = [ word ];
                                var newWidth = tempLine.join(" ").length * 7 + 4;
                                if (newWidth <= maxWidth) {
                                    lineNumber += 1;
                                    tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", lineNumber * lineHeight + dy + heightUnit).text(word);
                                } else {
                                    tspan = text.append("tspan").attr("x", 0).text(word);
                                    var _charLineNumber = wrapCharacter(tspan, maxWidth, lineHeight, heightUnit, dy, false);
                                    lineNumber += _charLineNumber;
                                    overflows = true;
                                }
                                if (!words.length) {
                                    var finalLineWidth = tspan.text().length * 7 + 4;
                                    if (finalLineWidth > maxWidth) {
                                        return;
                                    }
                                }
                            }
                        }
                    }
                    extraLines = Math.max(extraLines, lineNumber);
                }));
                return {
                    extraLines: extraLines,
                    overflows: overflows
                };
            }
            function textWrapBreakWord(d3, texts, maxWidth) {
                var lineHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1.1;
                var heightUnit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "em";
                var shouldAlwaysWrap = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
                var useYForDy = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
                var extraLines = 0;
                var overflows = false;
                texts.each((function wrap() {
                    var text = d3.select(this);
                    var words = text.text().split(/\s+/).reverse();
                    var word;
                    var line = [];
                    var lineNumber = 0;
                    var y = text.attr("y");
                    var dy = useYForDy ? +y : 0;
                    var tspan = text.text(null).append("tspan").attr("x", 0).attr("y", y).attr("dy", dy + heightUnit);
                    while (word = words.pop()) {
                        line.push(word);
                        tspan.text(line.join(" "));
                        var width = tspan.text().length * 7 + 4;
                        if (width > maxWidth || shouldAlwaysWrap) {
                            if (line.length === 1 && width > maxWidth) {
                                lineNumber = wrapCharacter(text, maxWidth, lineHeight, heightUnit, dy);
                                overflows = true;
                            } else if (line.length !== 1) {
                                line.pop();
                                tspan.text(line.join(" "));
                                line = [ word ];
                                tspan = text.append("tspan").attr("x", 0).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + heightUnit).text(word);
                                if (!words.length) {
                                    var finalLineWidth = getWidth(tspan);
                                    if (finalLineWidth > maxWidth) {
                                        return;
                                    }
                                }
                            }
                        }
                    }
                    extraLines = extraLines < lineNumber ? lineNumber : extraLines;
                }));
                return {
                    extraLines: extraLines,
                    overflows: overflows
                };
            }
            function wrapCharacter(text, maxWidth) {
                var lineHeight = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1.1;
                var heightUnit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "em";
                var dy = arguments.length > 4 ? arguments[4] : undefined;
                var firstWrap = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : true;
                var widthArr = [];
                var characters = text.text().split("").reverse();
                var character;
                var line = [];
                var lineNumber = 0;
                var x = text.attr("x") || 0;
                dy = firstWrap ? dy : lineHeight;
                var tspan = text.text(null).append("tspan").attr("x", x).attr("dy", dy + heightUnit);
                while (character = characters.pop()) {
                    line.push(character);
                    tspan.text(line.join(""));
                    var width = getWidth(tspan);
                    if (width > maxWidth) {
                        if (line.length === 1 && width > maxWidth) {
                            return;
                        }
                        if (line.length !== 1) {
                            lineNumber += 1;
                            line.pop();
                            tspan.text(line.join(""));
                            line = [ character ];
                            tspan = text.append("tspan").attr("x", x).attr("dy", lineHeight + heightUnit).text(character);
                            if (!characters.length) {
                                var finalLineWidth = getWidth(tspan);
                                if (finalLineWidth > maxWidth) {
                                    return;
                                }
                            }
                        }
                    }
                }
                return lineNumber;
            }
            function textWrapByCharacter(d3, texts, maxWidth) {
                var lineHeight = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1.1;
                var heightUnit = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "em";
                var shouldAlwaysWrap = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
                var extraLines = 0;
                var overflows = false;
                texts.each((function wrap() {
                    var text = d3.select(this);
                    var characters = text.text().split("").reverse();
                    var character;
                    var line = [];
                    var lineNumber = 0;
                    var x = text.attr("x");
                    var dy = 0;
                    var tspan = text.text(null).append("tspan").attr("x", x).attr("dy", dy + heightUnit);
                    while (character = characters.pop()) {
                        line.push(character);
                        tspan.text(line.join(""));
                        var width = getWidth(tspan);
                        if (width > maxWidth || shouldAlwaysWrap) {
                            if (line.length === 1 && width > maxWidth) {
                                overflows = true;
                                return;
                            }
                            if (line.length !== 1) {
                                lineNumber += 1;
                                line.pop();
                                tspan.text(line.join(""));
                                line = [ character ];
                                tspan = text.append("tspan").attr("x", x).attr("dy", lineHeight + dy + heightUnit).text(character);
                                if (!characters.length) {
                                    var finalLineWidth = getWidth(tspan);
                                    if (finalLineWidth > maxWidth) {
                                        overflows = true;
                                        return;
                                    }
                                }
                            }
                        }
                    }
                    extraLines = extraLines < lineNumber ? lineNumber : extraLines;
                }));
                return {
                    extraLines: extraLines,
                    overflows: overflows
                };
            }
            function getWidth(tspan) {
                if (MDS.isFireFox) {
                    return tspan.text().length * 7;
                }
                return tspan.node().getComputedTextLength();
            }
            function applyAttributes(svgElement, attributes) {
                var _this2 = this;
                Object.keys(attributes).forEach(function(property) {
                    _newArrowCheck(this, _this2);
                    return svgElement.attr(property, attributes[property]);
                }.bind(this));
                return svgElement;
            }
            function removeEndAxisTextNode(svg, axisClass) {
                var isLast = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
                var nodes = svg.selectAll(".".concat(axisClass, " text")).nodes();
                nodes[isLast ? nodes.length - 1 : 0].remove();
            }
            function isNegative(str) {
                return /-(.?\d+|\.)\d*/.test(str);
            }
            function colorNegativeAxisTicks(d3, yAxis) {
                yAxis.selectAll("text").filter((function filter() {
                    return isNegative(d3.select(this).text().toString());
                })).attr("class", "tick--negative");
            }
            function getLargestTextWidth(container, selector) {
                var maxCharacters = 0;
                container.selectAll(selector).each((function getTextWidth() {
                    var text = this.textContent;
                    if (text.length > maxCharacters) {
                        maxCharacters = text.length;
                    }
                }));
                return maxCharacters * 8;
            }
            function runArcTween(d3, arc, startingRadius, endingRadius, time, arcHighlightFn) {
                var _this3 = this;
                d3.select(this).transition().duration(time).ease(d3.easeCubic).attrTween("d", function(d) {
                    _newArrowCheck(this, _this3);
                    return function(t) {
                        d.outerRadius = d3.interpolate(startingRadius, endingRadius)(t);
                        if (arcHighlightFn) {
                            arcHighlightFn(d);
                        }
                        return arc(d);
                    };
                }.bind(this));
            }
            function isStringFalseOrUndefined(str) {
                return typeof str !== "undefined" && str !== "false";
            }
            function getFormatter(d3, component, formatString, functionName, formatStringAxis, time) {
                var _this4 = this;
                var formatMethod = !time ? "format" : "timeFormat";
                var replaceArgs = !time ? function(f) {
                    _newArrowCheck(this, _this4);
                    return f.replace("G", "B");
                }.bind(this) : function(f) {
                    _newArrowCheck(this, _this4);
                    return f;
                }.bind(this);
                var formatArgument = formatString || formatStringAxis;
                var formatter = formatArgument ? function(arg) {
                    _newArrowCheck(this, _this4);
                    return replaceArgs(d3[formatMethod](formatArgument)(arg));
                }.bind(this) : component[functionName];
                if (typeof formatter !== "function") {
                    formatter = function formatter(_) {
                        _newArrowCheck(this, _this4);
                        return _;
                    }.bind(this);
                }
                return function() {
                    _newArrowCheck(this, _this4);
                    if ((arguments.length <= 0 ? undefined : arguments[0]) === "—") {
                        return "—";
                    }
                    return formatter.apply(void 0, arguments);
                }.bind(this);
            }
        },
        d3: function(module, exports) {
            module.exports = __WEBPACK_EXTERNAL_MODULE_d3__;
        }
    });
}));